const auth = {
    "app.registration.caption": "Registrierung",
    "app.registration.description": "Bitte füllen Sie die Daten zum Anlegen eines Zugangskontos aus",
    "app.registration.firm": "Firma / Name",
    "app.registration.agb": "AGB",
    // Two separate legal acts: accepting the AGB is contract formation, acknowledging
    // the Datenschutzerklärung is Art. 13 DSGVO information. Hence two checkboxes.
    "app.registration.agb.agree": "Ja, ich stimme den {agbLink} zu.",
    "app.registration.privacy.agree": "Ja, ich habe die {datenschutzLink} und die {cookieLink} zur Kenntnis genommen.",
    "app.registration.message.send_verification_email": "Bestätigungs-E-Mail verschickt",
    "app.registration.almost_done": "Fast fertig",
    "app.registration.almost_done_description":
        "Vielen Dank für Ihre Registrierung bei Binale! Bitte bestätigen Sie noch Ihre E-Mail-Adresse. Gehen Sie dazu auf den Link, den wir Ihnen auf Ihre E-Mail-Adresse gesendet haben. ",
    "app.registration.send_again": "Erneut senden",
    "app.registration.resend_again_in": "Sie können die E-Mail erneut senden in",

    "app.login.description": "Willkommen bei Binale",
    "app.login.error.fail": "E-Mail-Adresse oder Passwort ist nicht gültig.",
    "app.login.loose_2fa_app": "Authentifizierungs-App ist nicht verfügbar",
    "app.login.loose_2fa_app_instructions":
        "Wenn Ihre Authentifizierungs-App nicht mehr verfügbar, kontaktieren Sie uns bitte unter {email}",

    "app.reset_password.caption": "Passwort vergessen?",
    "app.reset_password.description":
        "Bitte geben Sie Ihre E-Mail-Adresse an und klicken Sie auf 'Abschicken', um ein neues Passwort zu erhalten",
    "app.reset_password.confirmation":
        "Wir haben soeben einen Link für die Erstellung eines neuen Passowrts an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Postfach.",

    "app.new_password.caption": "Neues Passwort",
    "app.new_password.description": "Geben Sie ein neues Passwort an.",
    "app.new_password.confirmation": "Neues Passwort wird gesichert.",

    "app.2fa.button.enable2fa": "2FA aktivieren",
    "app.2fa.button.showPrivateKey": "Privaten Schlüssel anzeigen",
    "app.2fa.button.disable2fa": "2FA deaktivieren",
    "app.2fa.input_label": "Gib den 6-stelligen Authentifizierungscode ein.",
    "app.2fa.step.title": "Authenticator aktivieren",
    "app.2fa.confirm_delete": "Sind Sie sicher, dass Sie die 2FA deaktivieren möchten?",
    "app.2fa.description":
        "Mit <b>Zwei-Faktor-Authentifizierung</b> fügen Sie Ihrem Benutzerkonto eine zusätzliche Sicherheitsebene hinzu. Beim Einloggen verwenden Sie zusätzlich zu Ihrem Passwort einen einmaligen Verifizierungs-Zufallscode, der mit einer Authentifizierungs-App generiert wird.",
    "app.2fa.enabled2fa_description":
        "Die <b>Zwei-Faktor-Authentifizierung</b> wurde für Ihr Benutzerkonto erfolgreich aktiviert!",

    "app.2fa.step.download.title": "App herunterladen",
    "app.2fa.step.download.description":
        "Laden Sie eine der unten aufgeführten Authentifizierungs-Apps herunter und installieren Sie sie auf Ihrem Smartphone",

    "app.2fa.step.scan.title": "QR-Code scannen",
    "app.2fa.step.scan.description": "Scanne diesen QR-Code mit der Authenticator App.",
    "app.2fa.step.scan.manual_enter":
        "Wenn du den QR-Code nicht scannen kannst, gib diesen Code bitte manuell in die App ein.",

    "app.2fa.step.backup.title": "Backup-Schlüssel",
    "app.2fa.step.backup.description":
        "Bitte speichere diesen Schlüssel auf Papier. Dieser Schlüssel ermöglicht es dir, deinen Authenticator App im Falle eines Telefonverlustes wiederherzustellen.",

    "app.2fa.step.enable.title": "Authenticator aktiviert",
    "app.2fa.token_error": "Falscher 2FA-Verifizierungscode",
    "app.2fa.too_many_attempts": "Zu viele falsche Codes. Bitte versuchen Sie es in 15 Minuten erneut.",
};

const errors = {
    // firebase errors
    "app.firebase.error.auth_requires_recent_login":
        "Um das Kennwort zu ändern, müssen Sie sich erneut beim System anmelden.",
    "app.firebase.error.auth_user_not_found":
        "Es gibt keinen Benutzerdatensatz, der dieser Kennung entspricht. Der Benutzer wurde möglicherweise gelöscht.",
    "app.firebase.error.auth_too_many_requests": "Zu viele Anfragen",
    "app.firebase.error.duplicate_email": "E-Mail wird bereits verwendet.",
    "app.firebase.error.auth_weak_password": "Passwort ist schwach",
    "app.firebase.error.auth_invalid_email": "Ungültige E-Mail",
    "app.firebase.error.auth_invalid_token": "Token is invalid",

    // error pages
    "app.error_page.title.something_went_wrong": "Etwas scheint nicht gut gelaufen zu sein... ",
    "app.error_page.we_already_fix_it": "Wir kümmern uns schnellstmöglich darum. Bitte aktualisieren Sie die Seite.",
    "app.error_page.button.reload_page": "Neu laden",
    "app.error_page.title.problem_with_db": "Es gibt scheinbar aktuell ein Problem mit Verbindung zur Datenbank. ",
    "app.error_page.fix_problems_with_db.1":
        "Bitte überprüfen Sie zunächst, dass Sie sich nicht in einem sogenannten “Privaten-Fenster“ Ihres Browsers befinden. In diesem Fall können die Daten nicht geladen werden.",
    "app.error_page.fix_problems_with_db.2": "Bitte laden Sie die Seite noch einmal neu.",
    "app.error_page.fix_problems_with_db.3":
        "Wenn das Problem weiterhin besteht oder wiederholt auftritt, schreiben Sie uns bitte kurz über {email} an. Wir kümmern uns darum.",
    "app.error_page.not_found": "Diese Seite existiert nicht.",
    "app.error_page.button.back_home": "Startseite",

    // validation
    "app.validation.error.field_empty": "Das Feld darf nicht leer sein",
    "app.validation.error.short_password": "Das Passwort muss mindestens {length} stellig sein",
    "app.validation.error.passwords_not_match": "Passwörter stimmen nicht überein",
    "app.validation.error.invalid_email": "Ungültige E-Mail",
    "app.validation.error.strictLength": "{length} Zeichen",
    "app.validation.error.consent_required": "Bitte stimmen Sie zu, um fortzufahren",

    "app.error.message.incomplete_data": "Die Daten sind unvollständig. Bitte überprüfen Sie die Einträge ({reason})",
    "app.error.message.bank_not_available": "Die Bank ist im ausgewählten Jahr nicht vorhanden",
    "app.error.message.kb_not_available": "Die Kasse ist im ausgewählten Jahr nicht vorhanden",
    "app.error.message.some_incorrect": "Einige Einträge sind fehlerhaft ",
};

export const messagesDe = {
    ...auth,
    ...errors,

    "app.header.workplace": "Arbeitsplatz",
    "app.header.others": "Weitere Programme",
    "app.header.navigation": "Navigation",
    "app.header.logout": "Abmelden",
    "app.header.login": "Anmelden",
    "app.releaseNotes.title": "Neuigkeiten",
    "app.releaseNotes.markAllRead": "Alle als gelesen markieren",
    "app.releaseNotes.clearAll": "Alle ausblenden",
    "app.releaseNotes.clear": "Ausblenden",
    "app.releaseNotes.readMore": "Mehr erfahren",
    "app.releaseNotes.showAll": "Alle Versionshinweise",
    "app.releaseNotes.empty": "Keine neuen Mitteilungen",
    "app.releaseNotes.version": "Version {version}",
    "app.releaseNotes.unread": "{count} ungelesen",
    "app.releaseNotes.germanOnly": "Die Versionshinweise sind nur auf Deutsch verfügbar.",
    "app.releaseNotes.history.versions": "Versionen",
    "app.releaseNotes.history.latest": "Neueste",
    "app.releaseNotes.history.title": "Versionshinweise",
    "app.releaseNotes.history.empty": "Noch keine Versionshinweise vorhanden.",
    "app.releaseNotes.history.error": "Die Versionshinweise konnten nicht geladen werden.",
    "app.settings.button.columns.text": "Spalten",
    "app.settings.button.columns.title": "Spalten auswählen",
    "app.companies.view.table.admin": "Hauptnutzer",
    "app.companies.view.table.user": "Benutzer",
    "app.companies.filter.datev": "DATEV",
    "app.companies.filter.withDatev": "Mit DATEV",
    "app.companies.filter.withoutDatev": "Ohne DATEV",
    "app.companies.filter.lockStatus": "Sperrstatus",
    "app.companies.filter.locked": "Gesperrt",
    "app.companies.filter.unlocked": "Entsperrt",
    "app.companies.loadError":
        "Gesellschaften konnten nicht vollständig geladen werden. Bitte laden Sie die Seite neu.",
    "app.companies.detail_request.select_skr": "Bitte wählen Sie einen Sachkontenrahmen für Ihr Unternehmen",
    "app.companies.detail_request.select_kb": "Bitte erstellen oder wählen Sie eine Kasse",
    "app.companies.detail_request.select_bank": "Bitte erstellen oder wählen Sie eine Bank",
    "app.companies.permission": "Genehmigung",
    "app.companies.permission.no": "Keine",
    "app.companies.permission.read": "Audit (Lesen)",
    "app.companies.permission.write": "Teilnehmer (Schreiben)",
    "app.companies.permission.admin": "Admin",
    "app.companies.permission.admin-read": "Admin Read",
    "app.profile.select.title": "Sprache",
    "app.profile.button.change_password": "Passwort ändern",
    "app.profile.button.re_login": "Anmelden",
    "app.profile.email_verification.success_message": "Die E-Mail wurde erfolgreich bestätigt.",
    "app.profile.email_verification.fail_message": "E-Mail-Bestätigungsfehler",
    "app.messages.no_elements_found": "Keine Elemente gefunden",
    "app.message.no_document_found": "Keine Dokumente gefunden",
    "app.items.create_tag": "Kostenstelle erstellen",
    "app.items.create_creditor": "Kreditor erstellen",
    "app.items.create_debitor": "Debitor erstellen",
    "app.items.create_category": "Konto/Kategorie erstellen",
    "app.items.create_article": "Artikel erstellen",

    "app.titles.ER": "Eingangsrechnungen",
    "app.titles.ER_A": "Anzahlungen",
    "app.titles.Deb": "Ausgangsrechnungen",
    "app.titles.FE": "Freie Erfassung",
    "app.titles.POS": "Kassenabrechnung",
    "app.titles.KB": "Kasse",
    "app.titles.Bank": "Bank",
    "app.titles.Bank.pl": "Banken",
    "app.titles.Common": "Gemeinsame",
    "app.titles.KB.pl": "Kassen",
    "app.titles.ER.erfassung": "Erfassung",
    "app.titles.ER.rechnungen": "Rechnungen",
    "app.titles.ER.auswertung": "Auswertung",
    "app.titles.filtern": "Filtern und Suchen",
    "app.titles.ER.festschreibung": "Festschreibung",
    "app.titles.ER.za": "Zahlungsliste",
    "app.titles.Lager": "Lager",
    "app.titles.LA": "Entgeltabrechnungen",
    "app.titles.AVM": "Anlagenbuch",
    "app.titles.OCR": "PDF-Tool",
    "app.titles.KA": "Kontenauskunft",
    "app.titles.calendar": "Kalender",
    "app.titles.Contact": "Kontakt",
    "app.titles.Contacts": "Kontakte",
    "app.titles.DMS": "Unterlagen",
    "app.titles.Banks": "Banken",
    "app.titles.CashRegister": "Kassenbuch",
    "app.titles.Invoices": "Invoicing",
    "app.titles.payments": "Zahlungen",
    "app.titles.templates": "Vorlagen",
    "app.titles.data_export": "Datenexport",
    "app.titles.data_import": "Datenimport",
    "app.titles.SuSa": "Summen und Salden",
    "app.titles.Vat": "UStVA",
    "app.titles.settings": "Einstellungen",
    "app.titles.settings.manage": "Verwalten",
    "app.titles.settings.formSettings": "Einstellungen Erfassungsform",
    "app.titles.settings.optionalFields": "Optionale Felder",
    "app.titles.security": "Sicherheit",
    "app.titles.company": "Gesellschaft",
    "app.titles.company.pl": "Gesellschaften",
    "app.titles.category": "Sachkonto",
    "app.titles.category.pl": "Sachkonten",
    "app.titles.creditor": "Kreditor",
    "app.titles.creditor.pl": "Kreditoren",
    "app.titles.debitor": "Debitor",
    "app.titles.debitor.pl": "Debitoren",
    "app.titles.tag": "Kostenstelle",
    "app.titles.tag.pl": "Kostenstellen",
    "app.titles.postingRules": "Kontierungsregeln",
    "app.titles.article": "Artikel",
    "app.titles.article.pl": "Artikeln",
    "app.titles.profile": "Profile",
    "app.titles.kontenverwaltung": "Kontenverwaltung",
    "app.titles.import_export": "Import/Export",
    "app.titles.accounting": "Buchhaltung",
    "app.titles.contactPerson": "Ansprechpartner",
    "app.titles.legalInformation": "Rechtliche Informationen",
    "app.titles.termsOfPayment": "Zahlungsbedingungen",
    "app.titles.communication": "Kommunikation",
    "app.titles.contacts.client": "Kunde",
    "app.titles.contacts.partner": "Lieferant",
    "app.titles.contacts.other": "Sonstiges (Freie Erfassung)",
    "app.titles.contacts.employee": "Mitarbeiter",
    "app.titles.contacts.shareholder": "Gesellschafter",
    "app.titles.contacts.bankDetails": "Bankverbindung",
    "app.titles.contacts.classification": "Zuordnung",
    "app.titles.bulkEdit": "Multi-Änderung",

    "app.bulkEdit.buGate.mixedScope":
        "BU-Änderung ohne Kategorie nicht möglich: Die ausgewählten Buchungen haben Konten mit gemischten Steuerbereichen (VSt und USt).",
    "app.bulkEdit.buGate.autoBu":
        "BU-Änderung ohne Kategorie nicht möglich: Mindestens ein Konto ist ein Automatikkonto.",
    "app.bulkEdit.buGate.noVatScope":
        "BU-Änderung ohne Kategorie nicht möglich: Mindestens ein Konto hat keinen Steuerbereich (VSt/USt).",
    "app.bulkEdit.buGate.nonCategoryItems":
        "BU-Änderung ohne Kategorie nicht möglich: Mindestens eine Buchung hat einen Kreditor/Debitor statt eines Sachkontos.",
    "app.bulkEdit.buGate.kust": "BU-Änderung nicht möglich: Kleinunternehmer-Besteuerung (§ 19 UStG).",
    "app.bulkEdit.buGate.unresolvedCategory":
        "BU-Änderung ohne Kategorie nicht möglich: Mindestens ein Konto konnte im Kontenrahmen nicht aufgelöst werden.",
    "app.bulkEdit.splitHint.question": "Wo sind die anderen Felder?",
    "app.bulkEdit.splitHint.explanation":
        "Die Auswahl enthält aufgeteilte Buchungen mit mehreren Positionen. Felder, die zu einer einzelnen Position gehören, lassen sich nicht eindeutig zuordnen und werden ausgeblendet. Editierbar bleiben nur Felder, die für die ganze Buchung gelten.",

    "app.postingRules.metro.category": "Kategorie",
    "app.postingRules.metro.default": "Standard",
    "app.postingRules.metro.own": "Eigenes Konto",
    "app.postingRules.metro.sentinel": "kein Konto, Buchhalter entscheidet",
    "app.postingRules.hint.metro":
        "Positionen von Metro-Rechnungen werden einer Kategorie zugeordnet. Das Konto kommt aus dieser Tabelle, die KI wird dafür nicht gefragt.",
    "app.postingRules.direction.incoming": "Eingangsrechnungen",
    "app.postingRules.direction.outgoing": "Ausgangsrechnungen",
    "app.postingRules.section.corpus": "Datenbasis",
    "app.postingRules.section.patterns": "Buchungsmuster",
    "app.postingRules.section.corrections": "Korrekturen",
    "app.postingRules.tile.skr": "Kontenrahmen SKR {skr}",
    "app.postingRules.tile.ownRows": "Geprüfte Buchungen",
    "app.postingRules.tile.pending": "Noch nicht verfügbar",
    "app.postingRules.tile.shared": "Vergleichsbuchungen anderer Firmen",
    "app.postingRules.tile.shared.active": "aktiv",
    "app.postingRules.tile.shared.inactive": "nicht aktiv",
    "app.postingRules.tile.corrections": "{total} Korrekturen, {inPrompt} im Prompt",
    "app.postingRules.column.supplier": "Lieferant",
    "app.postingRules.column.customer": "Kunde",
    "app.postingRules.column.sachkonto": "Sachkonto",
    "app.postingRules.column.bu": "BU",
    "app.postingRules.column.lines": "Buchungszeilen",
    "app.postingRules.column.share": "Anteil",
    "app.postingRules.column.lastBooking": "Letzte Buchung",
    "app.postingRules.column.from": "KI-Vorschlag",
    "app.postingRules.column.to": "Gebucht",
    "app.postingRules.column.count": "Anzahl",
    "app.postingRules.column.lastSeen": "Zuletzt",
    "app.postingRules.column.inPrompt": "Im Prompt aktiv",
    "app.postingRules.column.counterparty": "Gegenpartei",
    "app.postingRules.column.purpose": "Zweck",
    "app.postingRules.column.rate": "MwSt.-Satz",
    "app.postingRules.column.status": "Status",
    "app.postingRules.column.applied": "Angewendet",
    "app.postingRules.column.updatedBy": "Geändert von",
    "app.postingRules.unknownSupplier": "Unbekannter Lieferant",
    "app.postingRules.unknownCustomer": "Unbekannter Kunde",
    "app.postingRules.purpose.any": "Jeder Zweck",
    "app.postingRules.purpose.general": "Allgemein",
    "app.postingRules.purpose.shipping": "Versand",
    "app.postingRules.purpose.pfand": "Pfand",
    "app.postingRules.purpose.logistic_surcharge": "Logistikzuschlag",
    "app.postingRules.purpose.ec_service_fee": "EC-Service-Entgelt",
    "app.postingRules.purpose.ec_zero_tax_fee": "EC-Entgelt ohne USt.",
    "app.postingRules.purpose.tip": "Trinkgeld",
    "app.postingRules.purpose.global_discount": "Gesamtrabatt",
    "app.postingRules.purpose.third_party_funded_discount": "Fremdfinanzierter Rabatt",
    "app.postingRules.purpose.authority_fee": "Behördengebühr",
    "app.postingRules.purpose.other": "Sonstiges",
    "app.postingRules.rate.any": "Jeder Satz",
    "app.postingRules.status.draft": "Entwurf",
    "app.postingRules.status.active": "Aktiv",
    "app.postingRules.status.rejected": "Abgelehnt",
    "app.postingRules.warning.unknownKonto": "Unbekanntes Konto",
    "app.postingRules.applied.never": "{count}×",
    "app.postingRules.applied.withDate": "{count}× zuletzt {date}",
    "app.postingRules.rules.filter.current": "Aktiv / Entwurf",
    "app.postingRules.rules.filter.rejected": "Abgelehnt",
    "app.postingRules.rules.hint.status":
        "Nur aktive Regeln werden bei der Kontierung angewendet. Entwürfe müssen erst bestätigt werden, abgelehnte Regeln werden nie angewendet.",
    "app.postingRules.rules.loadError": "Die Firmenregeln konnten nicht geladen werden.",
    "app.postingRules.rules.empty.title": "Noch keine Firmenregeln",
    "app.postingRules.rules.empty.description": "Für diese Richtung sind noch keine Regeln hinterlegt.",
    "app.postingRules.rules.action.edit": "Regel bearbeiten",
    "app.postingRules.rules.action.confirm": "Regel bestätigen",
    "app.postingRules.rules.action.reject": "Regel ablehnen",
    "app.postingRules.rules.editor.new": "Neue Regel",
    "app.postingRules.rules.import": "Vorschläge importieren",
    "app.postingRules.rules.import.result":
        "{count, plural, =0 {Keine neuen Vorschläge} one {# Regel importiert} other {# Regeln importiert}}",
    "app.postingRules.rule.create": "Regel anlegen",
    "app.postingRules.hint.corpus":
        "Die KI lernt aus geprüften Buchungen (Prüfstatus OK, kein Entwurf, nicht storniert). Neue Buchungen stehen in der Regel ab dem nächsten Tag zur Verfügung.",
    "app.postingRules.hint.retrieval":
        "Für jede neue Rechnung sucht die KI die {retrieveK} ähnlichsten eigenen Buchungen, vor allem desselben Lieferanten mit ähnlichen Positionen, und orientiert sich an deren Kontierung.",
    "app.postingRules.hint.shared":
        "Solange weniger als {sharedBelow} eigene Buchungen vorliegen, ergänzt die KI anonymisierte Buchungen anderer Firmen, ohne Personennamen und ohne Buchungstexte.",
    "app.postingRules.hint.corrections":
        "Weicht eine geprüfte Buchung vom KI-Vorschlag ab, gilt sie als Korrektur. Die {correctionsLimit} neuesten Korrekturen haben Vorrang vor den Buchungsmustern.",
    "app.postingRules.hint.confidence":
        "Vorschläge mit einer Sicherheit unter {confidence} % werden nicht übernommen, das Feld bleibt leer.",
    "app.postingRules.examples.unknown": "Ohne Kontakt",
    "app.postingRules.examples.open": "Indexierte Buchungen anzeigen",
    "app.postingRules.examples.routing": "Sachkonto {sachkonto}, BU {bu}",
    "app.postingRules.examples.empty": "Keine indexierten Buchungen zu diesem Muster.",
    "app.postingRules.hint.examples":
        "Das sind die indexierten Sätze der Buchungen hinter diesem Muster. Genau diese Sätze vergleicht die KI mit einer neuen Rechnung.",
    "app.postingRules.hint.direction": "Eingangs- und Ausgangsrechnungen werden getrennt ausgewertet.",
    "app.postingRules.patterns.empty.title": "Noch keine Buchungsmuster",
    "app.postingRules.patterns.empty.description":
        "Geprüfte Buchungen erscheinen hier in der Regel ab dem nächsten Tag.",
    "app.postingRules.corrections.empty.title": "Bisher keine Korrekturen",
    "app.postingRules.corrections.empty.description":
        "Weicht eine geprüfte Buchung bei Sachkonto oder BU vom KI-Vorschlag ab, erscheint sie hier.",
    "app.postingRules.ai.loadError":
        "Die Belege konnten nicht geladen werden. Für diese Rechnungsart fehlen möglicherweise Leserechte.",
    "app.postingRules.metro.loadError": "Die Metro-Kategorien konnten nicht geladen werden.",
    "app.postingRules.metro.ownLoadError":
        "Die eigenen Konten konnten nicht geladen werden, die Spalte „Eigenes Konto“ bleibt daher leer. Dafür sind Leserechte für Eingangsrechnungen nötig.",
    "app.postingRules.truncated": "Es werden nur die ersten {shown} von {total} Einträgen angezeigt.",
    "app.postingRules.tab.metro": "Metro-Kategorien",
    "app.postingRules.tab.rules": "Firmenregeln",
    "app.postingRules.tab.ai": "Kontierungsmuster der KI",
    "app.postingRules.hint.label": "Hinweis",
    "app.postingRules.hint.order":
        "Reihenfolge der Kontierung: Metro-Kategorien zuerst, danach Firmenregeln, danach die KI. Bei Automatikkonten legt das Konto den Steuerschlüssel immer selbst fest. Eine Buchungsvorlage des Kontakts füllt nur Felder, die danach noch leer sind.",

    "app.titles.reconciliation": "Verknüpfung",
    "app.titles.copy_data_from": "Neue Konten kopieren aus",
    "app.titles.bind_to_bank": "FIBU-Bank verknüpfen",
    "app.titles.bind_to_kb": "FIBU-Kasse verknüpfen",
    "app.titles.unbind": "Verknüpfung löschen",
    "app.titles.bind_to_banking_bank": "Banking-Bank verknüpfen",
    "app.titles.create_kb": "Kasse hinzufügen",
    "app.titles.update_kb": "Kasse bearbeiten",
    "app.titles.create_bank": "Bank hinzufügen",
    "app.titles.update_bank": "Bank bearbeiten",
    "app.titles.create_subtype": "Unterordner hinzufügen",
    "app.titles.update_subtype": "Unterordner bearbeiten",

    "app.button.login": "Anmelden",
    "app.button.register": "Registrieren",
    "app.button.send_to_dms": "an DMS",
    "app.button.save": "Speichern",
    "app.button.saveAll": "Alle speichern",
    "app.button.saveSelected": "Ausgewählte speichern",
    "app.button.create": "Erstellen",
    "app.button.add": "Anlegen",
    "app.button.cancel": "Abbrechen",
    "app.button.confAndClose": "Bestätigen und Schließen",
    "app.button.close": "Schließen",
    "app.button.finish": "Beenden",
    "app.button.confirm": "Bestätigen",
    "app.button.dmsSave": "speichern",
    "app.button.dmsSaveAndClose": "speichern und schließen",
    "app.button.aiReview": "KI-Prüfung",
    "app.button.send": "Abschicken",
    "app.button.done": "Fertig",
    "app.button.apply": "Anwenden",
    "app.button.unselect": "Deselektieren",
    "app.button.buchen": "Buchen",
    "app.button.delete": "Löschen",
    "app.button.bind": "Verknüpfen",
    "app.button.unbind": "Verknüpfung löschen",
    "app.button.bind_banking": "Banking verknüpfen",
    "app.button.unbind_banking": "Banking-Verknüpfung löschen",
    "app.button.bind_cash_register": "Kasse verknüpfen",
    "app.button.unbind_cash_register": "Kasse-Verknüpfung löschen",
    "app.button.storno": "Stornieren",
    "app.button.edit": "Bearbeiten",
    "app.button.view": "Ansehen",
    "app.button.copy": "Kopieren",
    "app.button.select": "Wahlen",
    "app.button.loading": "Laden...",
    "app.button.saving": "Schpichern...",
    "app.title.color": "Markierung",
    "app.button.color.remove_color": "Markierung löschen",
    "app.button.color.red": "Rot",
    "app.button.color.blue": "Blau",
    "app.button.color.purple": "Violett",
    "app.button.color.yellow": "Gelb",
    "app.button.color.green": "Grün",
    "app.button.download": "Herunterladen",
    "app.button.reorganise": "Reorganisieren",
    "app.button.upload": "Hochladen",
    "app.button.next": "Weiter",
    "app.button.back": "Zurück",
    "app.button.reset": "Zurücksetzen",
    "app.button.default": "Standardeinstellungen",
    "app.button.update": "Aktualisieren",
    "app.button.openInNewTab": "In neuem Tab öffnen",
    "app.button.export": "Exportieren",

    "app.confirmation.pdf.finish": "Arbeit beenden?",
    "app.confirmation.record_remove.body": "Wollen Sie diesen Buchungssatz wirklich löschen?",
    "app.confirmation.invoice_remove.body": "Do you really want to remove this Rechnung?",
    "app.confirmation.record_cancel.body": "Wollen Sie diesen Buchungssatz wirklich stornieren?",
    "app.confirmation.festschreiben_edit.body":
        "Der Buchungssatz ist festgeschrieben und kann nicht bearbeitet werden.\n" +
        "Wollen Sie diese Buchung stornieren und eine neue anlegen?",
    "app.kb.journal.no_items_tooltip":
        "Keine Buchungssätze ausgewählt, Saldo für einige ausgewählte Buchungssätze ist negativ oder frühere Buchungssätze werden nicht festgeschriben",
    "app.confirmation.header": "Bestätigung",
    "app.confirmation.header.record_delete": "Buchungssatz löschen!",
    "app.confirmation.header.record_cancel": "Buchungssatz stornieren",
    "app.confirmation.header.confirmed_edit": "Bestätigte Buchung bearbeiten!",
    "app.confirmation.header.festschreiben_edit": "Festschriben Buchungssatz bearbeiten!",
    "app.confirmation.body": "Bitte bestätigen!",

    "app.fields.lfdnr": "Lfd.Nr.",
    "app.fields.nr": "Nr.",
    "app.fields.date": "Datum",
    "app.fields.dateTo": "Datum bis",
    "app.auswertung.loadedYears.title": "Geladene Jahre",
    "app.auswertung.loadedYears.info":
        "Aus Performancegründen werden nur Buchungen des ausgewählten Jahres sowie des Vor- und Folgejahres geladen. Um Buchungen aus anderen Jahren zu sehen, wählen Sie bitte das entsprechende Jahr aus.",
    "app.fields.date.month": "Monat",
    "app.fields.date.year": "Jahr",
    "app.fields.date.erfassung": "Erfassung",
    "app.fields.creditor": "Kreditor",
    "app.fields.debitor": "Debitor",
    "app.fields.creditor_view": "Kreditorenansicht",
    "app.fields.konto_view": "Kontenansicht",
    "app.fields.bezeichnung": "Bezeichnung",
    "app.fields.name": "Name",
    "app.fields.contact": "Kontakt",
    "app.fields.bankDetails": "Bankverbindung",
    "app.fields.products": "Produkte",
    "app.fields.rechnung_num": "Rechnung Nr.",
    "app.fields.internal_num": "Interne Nr.",
    "app.fields.konto": "Konto",
    "app.fields.gkonto": "G.Konto",
    "app.fields.gkonto.full": "Gegenkonto",
    "app.fields.brutto": "Brutto",
    "app.fields.betrag": "Betrag",
    "app.fields.betragType": "Art",
    "app.fields.totalAmount": "Gesamtbetrag",
    "app.fields.partialAmount": "Teilbetrag",
    "app.fields.originalAmount": "FW-Betrag",
    "app.fields.currency.rate": "Kurs",
    "app.fields.vat%": "USt, %",
    "app.fields.vat": "USt",
    "app.fields.netto": "Netto",
    "app.fields.open": "Offen",
    "app.fields.buchtext": "Ware/Leistung",
    "app.fields.buchtext2": "Zusatz-Info",
    "app.fields.freigabe": "Freigabe",
    "app.fields.skonto": "Skonto",
    "app.fields.zugewiesen": "Zugewiesen",
    "app.fields.deadlineDays": "Fälligkeit (Tage)",
    "app.fields.dueDate": "Fälligkeit (Datum)",
    "app.fields.discountDays": "Skonto (Tage)",
    "app.fields.discountDate": "Skonto (Datum)",
    "app.fields.discountPercent": "Skonto (%)",
    "app.fields.discountAmount": "Skonto (EUR)",
    "app.fields.notes": "Notizen",
    "app.fields.verrechnung": "Verrechnung",
    "app.fields.wählen": "wählen",
    "app.fields.rabatt": "Rabatt",
    "app.fields.offner_betrag": "Offener Betrag",
    "app.fields.lastschrift": "Abbuchung/Lastschrift",
    "app.fields.draft": "Entwurf",
    "app.fields.uberweisung": "Überweisung",
    "app.fields.barzahlung": "Barzahlung",
    "app.fields.kartenzahlung": "Kartenzahlung",
    "app.fields.sonstiges": "Sonstiges",
    "app.fields.falligkeit": "Fälligkeit",
    "app.fields.actions": "Aktion",
    "app.fields.saldo": "Saldo",
    "app.fields.payment": "Zahlung",
    "app.fields.konto_len": "Kontenlänge",
    "app.fields.color": "Farbe",
    "app.fields.user": "Benutzer",
    "app.fields.schleppend": "Schleppend",
    "app.fields.search": "Suchen",
    "app.fields.address": "Adresse",
    "app.fields.company_name": "Firma",
    "app.fields.producer": "Produzent",
    "app.fields.description": "Beschreibung",
    "app.fields.unit": "Einheit",
    "app.fields.taxation": "Versteuerung der Umsätze",
    "app.fields.favouritePaymentType": "Hauptzahlungsmittel",
    "app.fields.datevNrConsultant": "Beraternummer",
    "app.fields.datevNrCompany": "Mandantennummer",
    "app.fields.countryCode": "Land",
    "app.fields.euroCountryCode": "EU-Land",
    "app.fields.postcode": "PLZ",
    "app.fields.city": "Ort",
    "app.fields.street": "Straße",
    "app.fields.house": "Haus Nr.",
    "app.fields.additionalAddress": "Adresszusatz",
    "app.fields.vatNb": "USt-IDNr (VAT ID)",
    "app.fields.wIdNr": "W-IdNr.",
    "app.fields.wIdNr.invalid": "Ungültige Wirtschafts-Identifikationsnummer",
    "app.fields.wIdNr.missingSuffix": "Unterscheidungsmerkmal fehlt - vollständiger Aufbau: DE123456788-00001",
    "app.fields.taxNumber": "Steuernummer",
    "app.fields.typeOfRegister": "Registerart",
    "app.fields.registerCourt": "Registergericht",
    "app.fields.registerNumber": "Registernummer",
    "app.fields.13bUStG": "Sachverhalt § 13b UStG",
    "app.fields.paymentPurpose": "Verwendungszweck",
    "app.fields.paymentMethod": "Zahlungsart",
    "app.fields.days": "Tage",
    "app.fields.phone": "Telefon",
    "app.fields.internalDesignation": "Interne Bezeichnung",
    "app.fields.type": "Typ",
    "app.fields.subType": "Untertyp",
    "app.fields.companyName": "Unternehmensname",
    "app.fields.companyNameWithLegalForm": "Unternehmensname (einschl. Rechtsform)",
    "app.fields.legalForm": "Rechtsform",
    "app.fields.createdAt": "Erstellt am",
    "app.fields.salutation": "Anrede",
    "app.fields.title": "Titel",
    "app.fields.firstName": "Vorname",
    "app.fields.lastName": "Nachname",
    "app.fields.customerNumber": "Kundennummer",
    // Owner of a company (the customer a company is provisioned for). NOT the same as
    // "app.fields.accountOwner" below, which is the bank-account holder in the contacts form.
    "app.fields.ownerEmail": "E-Mail des Inhabers",
    "app.fields.ownerEmail.hint": "Die Person muss bereits registriert sein. Sie wird Inhaber dieser Firma.",
    "app.fields.accountOwner": "Kontoinhaber",
    "app.fields.bankCodeNumber": "BLZ",
    "app.fields.bankAccountNumber": "Kontonummer",
    "app.fields.bankName": "Bankbezeichnung",
    "app.fields.productService": "Ware/Leistung",
    "app.fields.position": "Position",
    "app.fields.department": "Abteilung",
    "app.fields.currency": "Währung",
    "app.fields.comment": "Bemerkung",
    "app.fields.module": "Modul",
    "app.fields.attachment": "Anhang",
    "app.fields.invoice": "Rechnung",
    "app.fields.creditNote": "Gutschrift",

    "app.fields.fileUrl": "File URL",
    "app.fields.numPages": "Num Pages",
    "app.fields.rowNumber": "Nr.",

    "app.fields.recordReview": "Kontrolle",
    "app.fields.recordReview.ok": "OK",
    "app.fields.recordReview.new": "Neu",
    "app.fields.recordReview.changed": "geändert",
    "app.fields.recordReview.question": "Frage",
    "app.fields.recordReview.error": "Fehler",
    "app.fields.recordAiReview": "KI-Kontrolle",
    "app.fields.recordAiReview.valid": "KI bestätigt",
    "app.fields.recordAiReview.invalid": "KI Abweichung",
    "app.fields.recordAiReview.unchecked": "ungeprüft",
    "app.fields.recordAiReview.checks.booking_date": "Buchungsdatum",
    "app.fields.recordAiReview.checks.brutto_amount": "Bruttobetrag",
    "app.fields.recordAiReview.checks.vat_amount": "Umsatzsteuer",

    // PDF Stats filters
    "app.pdf.stats.date": "Datum",
    "app.pdf.stats.module": "Modul",
    "app.pdf.stats.user": "Benutzer",
    "app.pdf.stats.company": "Unternehmen",
    "app.pdf.stats.search": "Suchen...",
    "app.pdf.stats.csv": "CSV",
    "app.pdf.stats.loading": "Abgerufen {done}/{total}",

    "app.fields.ertrag": "Ertrag",
    "app.fields.aufwand": "Aufwand",

    "app.fields.purpose": "Verwendungszweck",
    "app.fields.myIban": "Meine IBAN",
    "app.fields.myBankAccount": "Mein Bankkonto",
    "app.fields.counterpartyName": "Name Geschäftspartner",
    "app.fields.counterpartyIbanOrAccountNum": "IBAN/Konto Geschäftspartner",
    "app.fields.counterpartyBicOrBlz": "BIC/BLZ Geschäftspartner",
    "app.fields.transactionType": "Umsatzart",
    "app.fields.transactionAmount": "Umsatz",
    "app.fields.openingBalance": "Anfangssaldo",
    "app.fields.openingBalanceDate": "Datum der Eröffnungsbilanz",
    "app.fields.bankTitle": "Interner Bankname",

    "app.labels.allYear": "ganzes Jahr",
    "app.labels.paymentConditions": "Zahlungsbedingungen",

    "app.components.split.title": "Rechnungsaufteilung",
    "app.components.editing": "Bearbeitung",
    "app.components.not_selected": "Nicht ausgewählt",
    "app.components.all_selected": "Alle ausgewählt",
    "app.components.nselected": "Ausgewählt",
    "app.components.all": "Alle",
    "app.components.all_months": "Alle Monate",
    "app.components.used": "meine Liste",
    "app.components.creating": "Erstellung",
    "app.components.date.range_error": "Datum sollte in Reichweite sein",
    "app.components.table.no_items": "Keine Treffer",
    "app.components.form.attachment": "Datei anhängen",
    "app.components.form.clear": "Leeren",

    // "app.cookie":
    // "Wir verwenden Cookies für eine bestmögliche Nutzererfahrung. Durch die Nutzung unserer Internetseite erklären Sie sich damit einverstanden, dass wir Cookies auf Ihrem Gerät speichern.",
    "app.notification.update":
        "Wir haben etwas verbessert! Bitte aktualisieren Sie das Programm, um top aktuell zu bleiben.",
    "app.notification.copiedToClipboard": "Feld kopiert",
    "app.notification.copyToClipboardFailed": "Kopieren in die Zwischenablage fehlgeschlagen",

    "app.global.email": "E-Mail-Adresse",
    "app.global.password": "Passwort",
    "app.global.password_repeat": "Passwort wiederholen",
    "app.global.error": "Unbekannter Fehler.",
    "app.global.login_now": "Jetzt anmelden",
    "app.global.register_now": "Jetzt registrieren",
    "app.global.do_not_have_account": "Neuer Kunde?",
    "app.global.already_have_account": "Haben Sie bereits einen Account?",
    "app.global.not_selected": "Keine Auswahl",
    "app.global.total": "Gesamt",
    "app.global.components.payment_connection.created": "Die Eintragung im Modul {module} wurde automatisch erzeugt.",
    "app.global.components.payment_connection.updated": "Die Eintragung im Modul {module} wurde entsprechend geändert.",
    "app.global.components.payment_connection.removed": "Die Eintragung im Modul {module} wurde ebenfalls gelöscht.",
    "app.global.components.payment_connection.markedRemoved":
        "Die Eintragung im Modul {module} wurde als entfernt markiert.",
    "app.global.components.num_corrector.title": "Zuordnung auf eine neue Nummer",
    "app.global.yes": "Ja",
    "app.global.no": "Nein",
    "app.global.step": "Schritt",
    "app.global.previous_step": "Vorheriger Schritt",
    "app.global.bank": "Bank",
    "app.global.confirmRemoveInfo": "Wollen Sie diese Informationen wirklich löschen?",
    "app.global.confirmSentToTrash": "In Papierkorb verschieben",
    "app.global.confirmRemoveDocument": "Endgültig löschen?",
    "app.global.saveChanges": "Änderungen speichern?",
    "app.global.binaleNeedUpdate": "Neue Binale Version ist verfügbar. Bitte aktualisieren Sie das Programm!",
    "app.global.onlyNumbersHint": "nur Zahlen erlaubt",

    "app.payments.verrechnungen": "Anzahlung wählen.",
    "app.paymentConnections.record": "Zahlungsdaten",
    "app.paymentConnections": "Zahlungszuordnung",
    "app.paymentConnections.helperText":
        "Bitte wählen Sie eine oder mehrere Rechnungen für die Zuordnung der Zahlung aus",
    "app.paymentConnections.deleteAssignment": "Zuordnung löschen",
    "app.paymentConnections.saveAssignment": "Zuordnung speichern",
    "app.paymentConnections.showAllOpenItems": "Alle offene Posten anzeigen",
    "app.paymentConnections.showClosedItems": "Auch geschlossene Posten",
    "app.paymentConnections.multiHint": "Sie können in diesem Schritt mehrere Rechnungen zuordnen",
    "app.paymentConnections.skontoSignHint":
        "Der gewählte Beleg in {product} verwendet einen {sign, select, negative {negativen} other {positiven}} Betrag. Bitte das gleiche Vorzeichen für den Skonto verwenden.",
    "app.paymentConnections.recordsWillBeCreated": "{n} neue Datensätze werden erstellt",
    "app.paymentConnections.differenz": "Differenz",

    "app.contacts.new": "Kontakt anlegen",
    "app.contacts.type.organization": "Unternehmen",
    "app.contacts.type.individual": "natürliche Person",
    "app.contacts.type.institution": "Institution",
    "app.contacts.add": "Adresse hinzufügen",
    "app.contacts.confirmRemoveContact": "Wollen Sie diesen Kontakt wirklich löschen?",

    "app.message.progress": "Aktion im Gange...",
    "app.message.success": "Aktion erfolgreich abgeschlossen",
    "app.dms.delete.movedToTrash": "{count, plural, one {1 Dokument} other {# Dokumente}} in den Papierkorb verschoben",
    "app.dms.delete.hardDeleted": "{count, plural, one {1 Dokument} other {# Dokumente}} endgültig gelöscht",
    "app.dms.delete.keptAttached":
        "{count, plural, one {1 Dokument bleibt} other {# Dokumente bleiben}} im Papierkorb - noch verknüpft",
    "app.message.userSelectCompany": "Ausgewählte Firma wurde gewechselt",
    "app.message.companyCreateBank": "Bank wurde erstellt",
    "app.message.companyCreateKB": "Kasse wurde erstellt",
    "app.message.companyUpdateBank": "Bank wurde geändert",
    "app.message.companyUpdateKB": "Kasse wurde geändert",
    "app.message.companyDeleteBank": "Bank wurde gelöscht",
    "app.message.companyDeleteKB": "Kasse wurde gelöscht",
    "app.message.companySetProducts": "Produkten wurde geändert",
    "app.companies.accountingProductsEnabledReload": "Die Seite wird jetzt neu geladen.",
    "app.message.companyCreate": "Firma wurde erstellt",
    "app.message.companyUpdate": "Firma wurde geändert",
    "app.message.companyDelete": "Firma wurde gelöscht",
    "app.message.companySaveMember": "Benutzer wurde gespeichert",
    "app.message.companyDeleteMember": "Benutzer wurde gelöscht",
    "app.message.nothingSelected":
        "Bitte wählen Sie eine Zuordnung des Kontakts ({ relations }) im Bereich “Allgemein“.",

    "app.tooltip.manageFavouritePaymentType": "Hauptzahlungsmittel verwalten",
    "app.tooltip.noOpenItems": "keine offene Posten vorhanden",
    "app.tooltip.form.correct": "Bitte korrigieren Sie {amount} {currency}",

    "app.ocr.button.checkAll": "alle Seiten auswählen",
    "app.ocr.button.deleteEmptyPages": "leere Seiten löschen",
    "app.ocr.button.hideDeletedPages": "gelöschte Seiten ausblenden",
    "app.ocr.button.showDeletedPages": "gelöschte Seiten anzeigen",
    "app.ocr.button.deletePage": "Seite löschen",
    "app.ocr.button.restorePage": "Löschen rückgängig",
    "app.ocr.button.rotatePage": "drehen",
    "app.ocr.button.splitDocs": "trennen",
    "app.ocr.button.unifyDocs": "verbinden",
    "app.ocr.button.uncheckAll": "Auswahl aufheben",
    "app.ocr.button.addDocument": "Dokument hinzufügen",
    "app.ocr.button.selectDocument": "Dokument auswählen",

    "app.ocr.parking": "Parking",
    "app.ocr.page": "Seite",
    "app.ocr.document": "Dokument",
    "app.ocr.allPages": "Alle Seiten",
    "app.ocr.totalPages": "Seiten insgesamt",
    "app.ocr.documentsNumber": "Anzahl Dokumente",
    "app.ocr.selectedPages": "Ausgewählte Seiten",

    "app.ocr.mode.put": "Verbinden",
    "app.ocr.mode.qr": "Trennen (QR-Code)",
    "app.ocr.mode.every": "Trennen (jede Seite)",
    "app.ocr.mode.second": "Trennen (jede zweite Seite)",
    "app.ocr.mode.manual": "Manuelle Bearbeitung",

    "app.ocr.error.encrypted":
        "Das gewählte Dokument ist verschlüsselt oder geschützt und kann nicht bearbeitet werden.",
    "app.ocr.dragDocument": "ziehen Sie das gewünschte Dokument hierher",
    "app.ocr.placeDocumentHere": "Dokument hier ablegen",

    "app.titles.taxes": "Steuern",
    "app.titles.contracts": "Verträge",
    "app.titles.year_report": "Abschluss",
    "app.titles.uncategorized": "Nicht kategorisiert",

    "app.dms.add_documents": "{isSingular, select, true {Dokument} other {Dokumente}} hinzufügen",
    "app.titles.new_documents": "Neue Dokumente",

    "app.dms.typeOfDocuments": "Ordner",
    "app.titles.trash": "gelöschte Dokumente",
    "app.dms.add_subtype": "Element hinzufügen",

    "app.dms.list": "Listenansicht",
    "app.dms.grid": "Bilder",

    "app.dms.empty": "Leer",
    "app.dms.fileName": "Dateiname",
    "app.dms.documentDate": "Datum",
    "app.dms.documentNumber": "Dokumentennummer",
    "app.dms.userName": "Nutzername",
    "app.dms.fileInformation": "Dateiinformationen",
    "app.dms.createdBy": "Erstellt von",
    "app.dms.createdAt": "Erstellt am",
    "app.dms.updatedAt": "Aktualisiert am",
    "app.dms.hasXRechnung": "E",
    "app.dms.hasMarkdown": "MD",
    "app.dms.comment": "Kommentar",
    "app.dms.status": "Status",
    "app.dms.closeEditor": "Editor schließen",
    "app.dms.total": "Gesamt",
    "app.dms.totalDocuments": "{count, plural, one {# Dokument} other {# Dokumente}}",

    "app.dms.search.mode.quick": "Schnell",
    "app.dms.search.mode.fulltext": "Volltext",
    "app.dms.search.mode.semantic": "KI-Suche",
    "app.dms.search.mode.label": "Suchmodus",
    "app.dms.search.placeholder.fulltext": "Volltextsuche, Enter drücken",
    "app.dms.search.placeholder.semantic": "KI-Suche, Enter drücken",
    "app.dms.search.noResults": "Keine Dokumente gefunden",
    "app.dms.search.error": "Suche fehlgeschlagen",

    "app.dms.selectAll": "Alles auswählen",
    "app.dms.copyId": "ID kopieren",
    "app.dms.datevBeleg": "DATEV-Beleg",
    "app.dms.eInvoiceBeleg": "E-Rechnung",
    "app.dms.eInvoiceBelegHint":
        "Diese E-Rechnung wird unverändert an DATEV übertragen. Die übrigen Belege dieser Buchung werden nicht übertragen.",
    "app.dms.datevBeleglinkHint":
        "Die ersten bis zu 5 Belege (max. 20 MB) werden zu einem PDF zusammengefügt und an DATEV übertragen.",
    "app.dms.primaryBeleg": "Hauptbeleg",
    "app.dms.primaryBelegHint": "Dieser Beleg steht an erster Stelle und gilt als Hauptbeleg.",
    "app.dms.documentPosition": "Position {position}",
    "app.dms.copyUrl": "Kopieren URL",
    "app.dms.idCopied": "ID kopiert",
    "app.dms.idCopyFailed": "Kopieren ID fehlgeschlagen",
    "app.dms.urlCopied": "URL kopiert",
    "app.dms.clickOrDrag":
        "Klicken Sie, um auszuwählen, oder ziehen Sie {isSingular, select, true {Dokument} other {Dokumente}} (max. 20 MB/Dokument) in diesen Bereich, um diese hochzuladen.",
    "app.dms.supportFor": "Mehrauswahl ist möglich",
    "app.dms.identicalFiles":
        "Identische Dateien. Wählen Sie eine Datei zum Hochladen aus und bestätigen Sie Ihre Auswahl",
    "app.dms.confirmResolving": "Auswahl bestätigen",
    "app.dms.deleteAll": "alles löschen",
    "app.dms.view": "Ansicht",
    "app.dms.moveTo": "verschieben",
    "app.dms.emptyDate": "ohne Datum",

    "app.dms.complete": "Vollständig",
    "app.dms.allDocuments": "Alle Dokumente",
    "app.dms.changeModeEnabled": "Änderungsmodus aktiviert",
    "app.dms.noticeOfDelete": "Benachrichtigung über den Löschmodus",
    "app.dms.cantDelete": "Sie können dieses Dokument nicht aus dem Papierkorb löschen",
    "app.dms.moveSelectedDocuments": "Ausgewählte dokumente in den bevorzugten typ verschieben!",
    "app.dms.pages": "{count, plural, one {# Seite} other {# Seiten}}",
    "app.dms.mainTypes": "Haupttypen",
    "app.dms.tooltipDocumentNumber": "Bitte verwenden Sie die folgenden Zeichen",
    "app.dms.letters": "Briefe",
    "app.dms.number": "Nummer",
    "app.dms.specialSymbols": "Spezielle Symbole",

    "app.dms.paymentStatus.offen": "offen",
    "app.dms.paymentStatus.avis": "AVIS",
    "app.dms.paymentStatus.bezahlt": "bezahlt",
    "app.dms.paymentStatus.storno": "Storno",
    "app.dms.vat": "Umsatzsteuer",
    "app.dms.corporation_tax": "Körperschaftsteuer",
    "app.dms.business_tax": "Gewerbesteuer",
    "app.dms.statement": "Gesonderte und Einheitliche Feststellung",
    "app.dms.income_tax": "Einkommensteuer",
    "app.dms.other_taxes": "Sonstige Steuern",
    "app.dms.tax_office": "Finanzamt",
    "app.dms.more": "Mehr",
    "app.dms.isAttached": "mit Buchhaltung verknüpft",
    "app.dms.isTransactionAttached": "mit Banktransaktion verknüpft",
    "app.dms.isCashRegisterAttached": "mit Kassenbewegung verknüpft",
    "app.dms.filterConnected": "verknüpft",
    "app.dms.filterNotConnected": "nicht verknüpft",
    "app.dms.filterAccountingModule": "Buchhaltung Modul",
    "app.dms.filterAccountingModuleYearHint":
        "Nur mit ausgewähltem Jahr verfügbar. Buchungen werden nur für das gewählte Jahr geladen, ohne Jahresauswahl wäre der Modulfilter unvollständig.",
    "app.dms.filterActive": "filter ist aktiviert",
    "app.dms.selectBank": "wählen Bankbelege",
    "app.dms.selectCashJournal": "wählen Kasse",
    "app.dms.selectTaxes": "wählen Steuern",
    "app.dms.noInternetConnection": "Keine Internetverbindung",
    "app.dms.addDocumentId": "Dokument-ID hinzufügen",
    "app.dms.selectInDms": "im DMS auswählen",
    "app.dms.noAssignment": "kein Zuordnung",
    "app.dms.filterColor": "Farbfilter",
    "app.dms.logs": "Log",

    "app.dms.payments.title": "Zahlungen",
    "app.dms.payments.documentAmount": "Rechnungsbetrag",
    "app.dms.payments.openAmount": "Offener Betrag",
    "app.dms.payments.paymentAmount": "Zahlungsbetrag",
    "app.dms.payments.discountPercent": "Skonto %",
    "app.dms.payments.discountAmount": "Skontobetrag",
    "app.dms.payments.account": "Bank / Kasse",
    "app.dms.payments.accountKind.bank": "Bank",
    "app.dms.payments.accountKind.kasse": "Kasse",
    "app.dms.payments.source.bankTransaction": "aus Banktransaktion",
    "app.dms.payments.source.cashRegisterTransaction": "aus Kassentransaktion",
    "app.dms.payments.paymentGroup": "Sammelzahlung",
    "app.dms.payments.noPayments": "Noch keine Zahlungen vorhanden",
    "app.dms.payments.deleteConfirm": "Zahlung löschen?",
    "app.dms.payments.deleteConfirmDesc": "Möchten Sie diese Zahlung wirklich löschen?",
    "app.dms.payments.lockedTooltip": "Gesperrt durch Sammelzahlung",
    "app.dms.payments.viewGroup": "Sammelzahlung anzeigen",
    "app.dms.payments.document": "Dokument",
    "app.dms.payments.goToBank": "Zur Bank",
    "app.dms.payments.deleteGroupConfirm": "Sammelzahlung löschen?",
    "app.dms.payments.deleteGroupConfirmDesc": "Alle zugehörigen Zahlungen werden ebenfalls gelöscht.",

    "app.invoice.createInvoice": "Rechnung erstellen",
    "app.invoice.createInvoiceFormat": "Rechnungsnummerformat erstellen",
    "app.invoice.createInvoiceLineItemTemplate": "Produkt-/Dienstleistungsvorlage erstellen",
    "app.invoice.createInvoicePaymentTemplate": "Zahlungsbedingungsvorlage erstellen",
    "app.invoice.invoicesList": "Rechnungsliste",
    "app.invoice.invoicePaymentTemplates": "Zahlungsbedingungsvorlagen",
    "app.invoice.invoiceLineItemTemplates": "Produkt-/Dienstleistungsvorlagen",

    "app.invoice.brutto": "mit USt",
    "app.invoice.netto": "ohne USt",
    "app.invoice.contactDetails": "Kundenangaben",
    "app.invoice.contact": "Kontakt suchen oder erfassen",
    "app.invoice.address": "Adresszusatz",
    "app.invoice.street": "Straße",
    "app.invoice.houseNumber": "Hausnummer",
    "app.invoice.zeep": "PLZ",
    "app.invoice.city": "Stadt",
    "app.invoice.countryCode": "Land",

    "app.invoice.invoiceDetails": "Rechnungsdaten",
    "app.invoice.isConfirmed": "Status",
    "app.invoice.invoiceNumberFormatId": "Rechnungsformat",
    "app.invoice.customerNum": "Kundennummer",
    "app.invoice.customerReceiverName": "Empfänger",
    "app.invoice.date": "Datum",
    "app.invoice.deliveryDate": "Lieferdatum",
    "app.invoice.serviceDate": "Leistungsdatum",
    "app.invoice.servicePeriodDays": "Leistungszeitraum (Tage)",
    "app.invoice.servicePeriodMonths": "Leistungszeitraum (Monate)",
    "app.invoice.noShowDate": "Kein Lieferdatum anzeigen",

    "app.invoice.head": "Kopfbereich",
    "app.invoice.invoiceTitle": "Belegtitel",
    "app.invoice.introductionText": "Einleitungstext",

    "app.invoice.lineItems": "Belegpositionen",
    "app.invoice.viewer": "Rechnungsvorschau",
    "app.invoice.position": "Position",
    "app.invoice.productService": "Produkt / Service",
    "app.invoice.quantity": "Menge",
    "app.invoice.price": "Preis",
    "app.invoice.unit": "Einheit",
    "app.invoice.tax": "USt",
    "app.invoice.discount": "Rabatt",
    "app.invoice.total": "Gesamt",
    "app.invoice.newLine": "Neue Position",
    "app.invoice.subTotalNet": "Zwischensumme netto",
    "app.invoice.piece": "Stück",
    "app.invoice.hour": "Stunde",
    "app.invoice.vat": "USt",
    "app.invoice.totalAmount": "Gesamtbetrag",

    "app.invoice.foot": "Fußbereich",
    "app.invoice.paymentTerm": "Zahlungsbedingung",
    "app.invoice.description": "Beschreibung",

    "app.invoice.caching": "Zwischenspeichern",
    "app.invoice.goToPreview": "Weiter zur Vorschau",
    "app.invoice.save_tooltip":
        "Sie sollten Rechnungsdatum und mindestens eine Position haben. Alle Positionen sollten eine Beschreibung und einen Preis haben",
    "app.invoice.save_contact_tooltip":
        "Möchten Sie Ihre Kundendaten als Kontakt speichern? Mit Kontakt können Sie Ihre Kundendaten mit einem Klick ausfüllen",
    "app.invoice.contact_tooltip": "Wählen Sie Ihren Kontakt aus, um Ihre Kundendaten automatisch auszufüllen",

    "app.invoiceList.invoiceDate": "Rechnungsdatum",
    "app.invoiceList.serviceDescription": "Leistungsbezeichnung",
    "app.invoiceList.project": "Projekt",
    "app.invoiceList.amountNetto": "Betrag Netto (EUR)",
    "app.invoiceList.amountBrutto": "Betrag Brutto (EUR)",

    "app.cash_register.allCashRegisters": "Alle Kassen",
    "app.cash_register.exportToFibu": "Export zu FIBU",
    "app.cash_register.countCashRegisters": "Anzahl Kassen",
    "app.cash_register.fibuKasse": "FIBU Kasse",
    "app.cash_register.newCashRegister": "Neue Kasse",
    "app.cash_register.dmsDocuments": "DMS Dokumente",
    "app.cash_register.deleteConfirm":
        "Bitte bestätigen Sie, dass Sie die Kasse löschen wollen. Alle Daten werden dabei endgültig gelöscht.",
    "app.cash_register.fibuExportTitle": "FIBU Export",
    "app.cash_register.fibuExportTooltip": "Datensätze in der FIBU-Kasse <b>{name} ({accountNum})</b> erstellen",
    "app.cash_register.exportAll": "Alle exportieren",
    "app.cash_register.exportAllInfo": "Alle Transaktionen werden exportiert.",
    "app.cash_register.exportNewInfo": "Nur neue Transaktionen werden exportiert.",
    "app.cash_register.upload.aiRunning": "Binale AI läuft...",
    "app.cash_register.upload.ocrRunning": "KI OCR läuft...",
    "app.cash_register.upload.aiDescription": "{count} Dokumente werden momentan mit KI verarbeitet, bitte warten",
    "app.cash_register.upload.processing": "Wird verarbeitet...",
    "app.cash_register.upload.processed": "Verarbeitet",
    "app.cash_register.upload.errorCount": "({count} Fehler)",
    "app.cash_register.upload.createTransactions": "Transaktionen erstellen",
    "app.cash_register.fromDocuments.result": "{created} erstellt, {linked} bereits verknüpft, {refused} abgelehnt",

    "app.transactionExport.created": "{count} exportiert",
    "app.transactionExport.alreadyExported": "{count} bereits exportiert, übersprungen",
    "app.transactionExport.invalid": "{count} nicht exportiert: {message}",
    "app.transactionExport.notFound": "{count} nicht gefunden",
    "app.transactionExport.reason.invalidDate": "Ungültiges Buchungsdatum",
    "app.transactionExport.reason.noAccountForYear": "Kein Buchhaltungskonto für das Jahr der Transaktion",
    "app.transactionExport.reason.noAccountingYear": "Kein Buchhaltungsjahr für das Jahr der Transaktion",
    "app.transactionExport.reason.noAmount": "Transaktion ohne Betrag",
    "app.transactionExport.reason.nothing": "Nichts zu exportieren",
    "app.transactionExport.reason.noChart": "Kein BU-Zeitraum des Kontenrahmens für das Buchungsdatum",
    "app.transactionExport.suggestionsFailed": "Gegenkonto-Vorschläge nicht verfügbar: {error}",
    "app.banks.allBanks": "Alle Banken",
    "app.banks.myBank": "Meine Bank",
    "app.banks.transactionInfo": "Transaktionsinformationen",
    "app.banks.counterparty": "Geschäftspartner",
    "app.banks.newBank": "Neue Bank",
    "app.banks.editBank": "Bank bearbeiten",
    "app.banks.editTransaction": "Transaktion bearbeiten",
    "app.banks.editTransactions": "Transaktionen bearbeiten",
    "app.banks.uploadTransactions": "Banktransaktionsdatei hochladen",
    "app.banks.unmapped": "Nicht zugeordnet",
    "app.banks.selectDataField": "Datenfeld auswählen",
    // --- intl migration batch (phases 1-9) ---
    "app.fields.bicSwift": "BIC (SWIFT-Code)",
    "app.fields.federalState": "Bundesland",
    "app.datev.disconnect": "DATEV Verbindung löschen",
    "app.datev.connected": "DATEV ist verbunden",
    "app.datev.connect": "DATEV verbinden",
    "app.datev.refreshToken": "Token aktualisieren",
    "app.titles.documents": "Dokumente",
    "app.titles.eInvoice": "E-Rechnung",
    "app.titles.diverse": "diverse",
    "app.companies.deleteData": "Daten löschen",
    "app.companies.type.gastronomy": "Gastronomie",
    "app.companies.type.restaurant": "Restaurant",
    "app.companies.type.cafe": "Café",
    "app.companies.type.bakery": "Bäckerei",
    "app.companies.type.trade": "Handel",
    "app.companies.type.retail": "Einzelhandel",
    "app.companies.type.wholesale": "Großhandel",
    "app.companies.type.services": "Dienstleistungen",
    "app.companies.type.consulting": "Beratungsleistungen",
    "app.companies.type.servicesOther": "Sonstige Dienstleistungen",
    "app.companies.imageMaxSize": "Bild (Max. {size})",
    "app.companies.accountingYears": "Geschäftsjahre",
    "app.companies.companyLogo": "Firmenlogo",
    "app.companies.validation.range": "muss im Bereich [{min}, {max}] liegen",
    "app.companies.invoice.email": "Rechnung E-Mail",
    "app.companies.invoice.attention": "zu Händen von (optional)",
    "app.companies.invoice.receiver": "Rechnungsempfänger",
    "app.companies.invoice.director": "Geschäftsführer",
    "app.companies.invoice.headquarter": "Sitz der Gesellschaft",
    "app.companies.invoice.generalPartner": "Komplementär",
    "app.companies.invoice.taxInfo": "{country}: Steuerliche Informationen",
    "app.companies.invoice.commercialRegister": "{country} Handelsregister",
    "app.companies.invoice.invalidTaxNumber": "Ungültige Steuernummer",
    "app.companies.onlyAdminCanSetProducts": "Nur ein Administrator kann Produkte festlegen",
    "app.companies.saldoTransfer": "Saldenvortrag",
    "app.companies.saldoTransfer.feWriteRequired":
        "Für diese Auswahl werden Zahlungsentwürfe in Freie Erfassung geschrieben. Dafür ist Schreibzugriff auf Freie Erfassung nötig.",
    "app.companies.logs": "Protokolle",
    "app.companies.go": "Los",
    "app.companies.updateAdmin": "Hauptnutzer ändern",
    "app.companies.selectAtLeastOneProduct": "Bitte wählen Sie mindestens ein Produkt aus",
    "app.companies.createOrUpdateMember": "Benutzer anlegen/bearbeiten",
    "app.companies.modules": "Module",
    "app.companies.roles": "Rollen",
    "app.companies.noRolesAssigned": "Keine Rollen zugewiesen",
    "app.companies.editRoles": "Rollen bearbeiten",
    "app.companies.role.reviewer": "Prüfer",
    "app.companies.role.datevExporter": "DATEV-Exporteur",
    "app.companies.role.elsterExporter": "ELSTER-Übermittler",
    "app.companies.role.avmApprover": "Anlagenbuch freigeben",
    "app.companies.role.dmsAdmin": "DMS-Administrator",
    "app.companies.role.dmsNewDocuments": "DMS Neue Dokumente",
    "app.companies.role.dmsReviewer": "DMS-Prüfer",
    "app.companies.fiscalYearConfig": "Konfiguration des Geschäftsjahres",
    "app.companies.noAccountingProductsWarning":
        "Für diese Gesellschaft sind keine Buchhaltungsprodukte aktiviert, daher konnte das Jahr nicht angelegt werden. Bitte bitten Sie den Administrator, Buchhaltungsprodukte zu aktivieren.",
    "app.companies.yearsConfigTable": "Konfiguration der Geschäftsjahre",
    "app.companies.col.fiscalYearStart": "WJ-Beginn",
    "app.companies.col.ustvaFrequency": "UStVA-Rhythmus",
    "app.companies.col.dauerfristverlaengerung": "Dauerfristverlängerung",
    "app.companies.col.steuerlichBeraten": "Steuerlich beraten",
    "app.companies.filingFrequency.monthly": "Monatlich",
    "app.companies.filingFrequency.quarterly": "Vierteljährlich",
    "app.companies.filingFrequency.none": "Keine UStVA",
    "app.companies.triState.notSet": "Nicht festgelegt",
    "app.companies.triState.yes": "Ja",
    "app.companies.triState.no": "Nein",
    "app.companies.taxPrepayments.title": "Vorauszahlungsbescheide",
    "app.companies.taxPrepayments.button": "Vorauszahlungsbescheide",
    "app.companies.taxPrepayments.empty": "Keine Vorauszahlungsbescheide erfasst",
    "app.companies.taxPrepayments.col.taxType": "Steuerart",
    "app.companies.taxPrepayments.col.validFromYear": "Gültig ab Jahr",
    "app.companies.taxPrepayments.col.amount": "Betrag (vierteljährlich)",
    "app.companies.taxPrepayments.col.note": "Notiz",
    "app.companies.taxPrepayments.col.docRef": "Beleg-Referenz",
    "app.companies.taxPrepayments.taxType.est": "Einkommensteuer (EST)",
    "app.companies.taxPrepayments.taxType.kst": "Körperschaftsteuer (KST)",
    "app.companies.taxPrepayments.taxType.gewst": "Gewerbesteuer (GEWST)",
    "app.companies.taxPrepayments.addNew": "Neuen Bescheid erfassen",
    "app.companies.noSkrForYearWarning":
        "Dieses Jahr kann nicht angelegt werden. Für das Jahr {year} ist kein SKR konfiguriert, bitte wenden Sie sich an den Administrator.",
    "app.companies.dataCopyFromYearInfo": "Daten werden aus dem Jahr {year} kopiert",
    "app.companies.taxation.none": "Keine USt",
    "app.companies.kontoLen.standard": "Standard",
    "app.companies.kontoLen.extended": "Erweitert",
    "app.companies.vatNumbers": "USt-IdNr.",
    "app.admin.metroAccountingCategories.title": "Metro-Kontierungskategorien",
    "app.admin.metroAccountingCategories.key": "Schlüssel",
    "app.admin.metroAccountingCategories.label": "Bezeichnung",
    "app.admin.metroAccountingCategories.skr03": "SKR03",
    "app.admin.metroAccountingCategories.skr04": "SKR04",
    "app.admin.metroAccountingCategories.articles": "Artikel",
    "app.admin.metroAccountingCategories.new": "Neue Kategorie",
    "app.admin.metroAccountingCategories.save": "Speichern",
    "app.admin.metroAccountingCategories.saved": "Kategorie gespeichert",
    "app.companies.metroAccountingCategories": "Metro-Kontierungskategorien",
    "app.companies.metroAdministration": "Metro-Verwaltung",
    "app.companies.metroAccountingCategories.default": "Standard: {konto}",
    "app.companies.metroAccountingCategories.own": "Eigenes Konto ({digits}-stellig)",
    "app.companies.metroAccountingCategories.noExt":
        "Eigene Konten sind nur mit erweiterten Kontonummern (kontoExt > 0) möglich.",
    "app.companies.metroAccountingCategories.saved": "Zuordnung gespeichert",
    "app.admin.metroArticles.title": "Metro-Artikel",
    "app.admin.metroArticles.tab.candidates": "Kandidaten",
    "app.admin.metroArticles.tab.articles": "Artikel",
    "app.admin.metroArticles.search": "Art.-Nr., EAN oder Bezeichnung",
    "app.admin.metroArticles.articleNo": "Art.-Nr.",
    "app.admin.metroArticles.ean": "EAN",
    "app.admin.metroArticles.eanSearch": "EAN auf metro.de suchen",
    "app.admin.metroArticles.group": "Warengruppe",
    "app.admin.metroArticles.description": "Bezeichnung",
    "app.admin.metroArticles.taxChar": "USt-KZ",
    "app.admin.metroArticles.aiCategories": "KI-Einordnung",
    "app.admin.metroArticles.category": "Kategorie",
    "app.admin.metroArticles.source": "Quelle",
    "app.admin.metroArticles.note": "Notiz",
    "app.admin.metroArticles.documents": "Belege",
    "app.admin.metroArticles.companies": "Firmen",
    "app.admin.metroArticles.netVolume": "Netto",
    "app.admin.metroArticles.lastSeen": "Zuletzt",
    "app.admin.metroArticles.confirm": "Bestätigen",
    "app.admin.metroArticles.save": "Speichern",
    "app.admin.metroArticles.import": "Import (xlsx/csv)",
    "app.admin.metroArticles.importResult": "{inserted} neu, {updated} aktualisiert, {rejected} abgelehnt",
    "app.admin.metroArticles.importRejected": "Zeile {row}: {reason}",
    "app.admin.metroArticles.total": "{total} Artikel",
    "app.admin.metroArticles.truncated":
        "Es werden nur die ersten {shown} von {total} Ergebnissen angezeigt. Bitte Suche verfeinern.",
    // AG Grid chrome (pagination controls); keys map to AG Grid's own localeText names.
    "app.grid.page": "Seite",
    "app.grid.to": "bis",
    "app.grid.of": "von",
    "app.grid.firstPage": "Erste Seite",
    "app.grid.previousPage": "Vorherige Seite",
    "app.grid.nextPage": "Nächste Seite",
    "app.grid.lastPage": "Letzte Seite",
    "app.grid.pageSize": "Zeilen pro Seite:",
    "app.grid.pageSizeAria": "Zeilen pro Seite",

    "app.companies.metroArticles": "Metro-Artikel",
    "app.companies.pending.title": "Ihre Firma wird eingerichtet",
    "app.companies.pending.description":
        "Wir richten Ihre Firma gerade ein. Sobald sie bereit ist, erscheint sie hier automatisch - bitte laden Sie die Seite dann neu.",
    "app.companies.pending.contact": "Bei Fragen erreichen Sie uns unter {email}.",
    "app.avv.accept": "Ja, ich habe den {avvLink} gelesen und stimme ihm zu.",
    "app.avv.modal.description":
        "Fast geschafft: Für {companyName} fehlt nur noch die Zustimmung zum {avvLink} (AVV). Er beschreibt nach Art. 28 DSGVO, wie binale.app Ihre Daten für Sie verarbeitet. Werfen Sie gern einen Blick hinein und bestätigen Sie danach einfach unten.",
    "app.button.later": "Später",
    "app.page.legal.section": "Rechtliches",
    "app.page.legal.compliance": "Datenschutz & Rechtliches",
    "app.page.legal.impressum": "Impressum",
    "app.page.legal.haftungsausschluss": "Haftungsausschluss",
    "app.page.legal.agb": "AGB",
    "app.page.legal.datenschutz": "Datenschutzerklärung",
    "app.page.legal.avv": "Auftragsverarbeitungsvertrag",
    "app.page.legal.cookiePolicy": "Cookie-Richtlinie",
    "app.page.legal.privacy": "Ihre Privatsphäre",
    "app.page.home.temporarilyLocked": "Vorübergehend gesperrt",

    "app.home.metrics.title": "Kennzahlen",
    "app.home.metrics.expand": "Details anzeigen",
    "app.home.metrics.collapse": "Einklappen",
    "app.home.metrics.guv": "GuV",
    "app.home.metrics.revenue": "Umsatz",
    "app.home.metrics.costs": "Kosten",
    "app.home.metrics.profit": "Gewinn",
    "app.home.metrics.op": "Offene Posten",
    "app.home.metrics.op.receivables": "Debitoren",
    "app.home.metrics.op.payables": "Kreditoren",
    "app.home.metrics.op.count": "{count} offen",
    "app.home.metrics.vat": "USt {month}",
    "app.home.metrics.vat.zahllast": "Zahllast",
    "app.home.metrics.vat.erstattung": "Erstattung",
    "app.home.metrics.cash": "Kasse",
    "app.home.metrics.bank": "Bank",
    "app.home.metrics.bank.trend": "Verlauf 30 Tage",
    "app.home.metrics.betriebsergebnis": "Betriebsergebnis",
    "app.home.metrics.overdueReceivables": "Überfällige Forderungen",
    "app.home.metrics.liquidity": "Liquide Mittel",
    "app.home.aiUsage.title": "KI-Verarbeitung",
    "app.home.aiUsage.scope": "Auswertungsbereich",
    "app.home.aiUsage.scope.all": "Alle",
    "app.home.aiUsage.scope.company": "Firma",
    "app.home.aiUsage.today": "Heute",
    "app.home.aiUsage.week": "7 Tage",
    "app.home.aiUsage.window": "{days} Tage",
    "app.home.aiUsage.documents": "Belege",
    "app.home.aiUsage.documentsPerDay": "Belege pro Tag",
    "app.home.aiUsage.cost": "Kosten",
    "app.home.aiUsage.costPerDay": "Kosten pro Tag (USD)",
    "app.home.aiUsage.tokens": "Tokens",
    "app.home.aiUsage.tokens.input": "Eingabe",
    "app.home.aiUsage.tokens.cached": "Gecacht",
    "app.home.aiUsage.tokens.output": "Ausgabe",
    "app.home.aiUsage.tokens.thoughts": "Denkprozess",
    "app.home.aiUsage.tokens.total": "Gesamt",
    "app.home.aiUsage.models": "Modelle",
    "app.home.aiUsage.model": "Modell",
    "app.home.aiUsage.model.unknown": "ohne Angabe",
    "app.home.aiUsage.costByStage": "Kosten nach Bereich (USD)",
    "app.home.aiUsage.stage.EXTRACTION": "Belegerkennung",
    "app.home.aiUsage.stage.METRO_SPLIT": "METRO-Aufteilung",
    "app.home.aiUsage.stage.OCR": "OCR",
    "app.home.aiUsage.stage.DOCUMENTS_TO_RECORDS": "Belege zu Buchungen",
    "app.home.aiUsage.stage.TRANSACTION_EXPORT": "Bank/Kasse-Export",
    "app.home.aiUsage.stage.TRANSACTION_SUGGESTIONS": "Gegenkonto-Vorschläge",
    "app.home.aiUsage.hint":
        "{from} – {to}. Pro Beleg wird nur die letzte KI-Verarbeitung gezählt; erneut verarbeitete Belege wandern auf den späteren Tag, Kosten früherer Durchläufe sind nicht enthalten.",
    "app.home.calendar.title": "Termine",
    "app.home.calendar.summary.today": "Heute: {count, plural, one {# Termin} other {# Termine}}",
    "app.home.calendar.summary.next": "Nächster Termin: {title} in {days, plural, one {# Tag} other {# Tagen}}",
    "app.home.calendar.summary.empty": "Keine anstehenden Termine",
    "app.home.calendar.group.heute": "Heute",
    "app.home.calendar.group.woche": "Diese Woche",
    "app.home.calendar.group.monat": "Diesen Monat",
    "app.home.calendar.group.spaeter": "Später",
    "app.home.calendar.ustva": "USt-Voranmeldung {month}",
    "app.home.calendar.ustvaQuarter": "USt-Voranmeldung {quarter}. Quartal",
    "app.home.calendar.sondervz": "Sondervorauszahlung USt",
    "app.home.calendar.vzEst": "Einkommensteuer-Vorauszahlung",
    "app.home.calendar.vzKst": "Körperschaftsteuer-Vorauszahlung",
    "app.home.calendar.vzGewst": "Gewerbesteuer-Vorauszahlung",
    "app.home.calendar.annualUst": "Umsatzsteuererklärung",
    "app.home.calendar.annualEst": "Einkommensteuererklärung",
    "app.home.calendar.annualKst": "Körperschaftsteuererklärung",
    "app.home.calendar.annualGewst": "Gewerbesteuererklärung",
    "app.home.calendar.offenlegung": "Offenlegung Jahresabschluss",
    "app.home.calendar.softDeadline": "empfohlen bis {date}",
    "app.home.calendar.hardDeadline": "spätestens {date}",
    "app.home.calendar.userEventTitle": "{title}",
    "app.home.calendar.addEvent": "Termin hinzufügen",
    "app.home.calendar.type.meeting": "Meeting",
    "app.home.calendar.type.appointment": "Termin",
    "app.home.calendar.type.reminder": "Erinnerung",
    "app.home.calendar.type.delivery": "Lieferung",
    "app.home.calendar.type.other": "Sonstiges",
    "app.home.calendar.modal.createTitle": "Termin erstellen",
    "app.home.calendar.modal.editTitle": "Termin bearbeiten",
    "app.home.calendar.modal.fields.title": "Titel",
    "app.home.calendar.modal.fields.eventDate": "Datum",
    "app.home.calendar.modal.fields.type": "Art",
    "app.home.calendar.modal.fields.assignee": "Zuständig",
    "app.home.calendar.modal.fields.assigneeNone": "Niemand zugewiesen",
    "app.home.calendar.modal.fields.contact": "Kontakt",
    "app.home.calendar.modal.fields.notes": "Notizen",
    "app.home.calendar.modal.fields.color": "Farbe",
    "app.home.calendar.modal.delete": "Termin löschen",
    "app.home.calendar.state.doneLabel": "Als erledigt markieren",
    "app.home.calendar.state.noteTrigger": "Notiz & Farbe bearbeiten",
    "app.home.calendar.state.noteLabel": "Notiz",

    // SP4 (FIBU-22): dedicated /calendar page - distinct namespace from
    // app.home.calendar.* (the Termine widget), since the page reuses most
    // widget message ids (title/type/modal/state) verbatim but adds its own
    // tab labels and month-grid/agenda-specific empty states.
    "app.calendar.tabs.month": "Monat",
    "app.calendar.tabs.agenda": "Agenda",
    "app.calendar.month.badgeLabel": "{count, plural, one {# Termin} other {# Termine}}",
    "app.calendar.dayPanel.empty": "Keine Termine an diesem Tag",
    "app.calendar.dayPanel.selectPrompt": "Tag auswählen, um Termine zu sehen",
    "app.calendar.agenda.empty": "Keine Termine in diesem Jahr",
    "app.home.openPositions.title": "Offene Posten",
    "app.home.openPositions.empty": "Keine offenen Posten",
    "app.home.openPositions.bucket.ueberfaellig": "Überfällig",
    "app.home.openPositions.bucket.heute": "Heute fällig",
    "app.home.openPositions.bucket.woche": "Diese Woche",
    "app.home.openPositions.bucket.spaeter": "Später",
    "app.home.openPositions.debitor": "Debitoren",
    "app.home.openPositions.kreditor": "Kreditoren",
    "app.page.test.skrTestPage": "SKR Testseite",
    "app.page.auth.confirmingEmail": "E-Mail wird bestätigt, bitte warten...",
    "app.page.profile.theme": "Design",
    "app.page.profile.theme.system": "System",
    "app.page.profile.theme.light": "Hell",
    "app.page.profile.theme.dark": "Dunkel",
    "app.page.profile.deleteAccount":
        "Möchten Sie Ihr Konto löschen lassen? Schreiben Sie uns an {contact}. Wir löschen Ihr Konto und die zugehörigen Daten, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
    "app.page.profile.classicBackground": "Klassischer Hintergrund",
    "app.page.profile.validating": "Wird überprüft...",
    "app.page.datev.deleteCache": "DATEV Cache löschen",
    "app.page.datev.cache": "DATEV (Cache)",
    "app.page.datev.notConnected": "DATEV ist nicht verbunden",
    "app.admin.vat.drafts": "Entwürfe",
    "app.admin.vat.showHidden": "Ausgeblendete anzeigen",
    "app.admin.vat.ibanActive": "IBAN aktiv",
    "app.admin.vat.searchPlaceholder": "Suche nach USt-IDNr, Adresse oder beliebigem Begriff",
    "app.admin.vat.legalName": "Rechtlicher Name",
    "app.admin.vat.confirmed": "Bestätigt",
    "app.admin.vat.vatNumber": "USt-IDNr",
    "app.admin.vat.show": "Anzeigen",
    "app.admin.vat.hide": "Ausblenden",
    "app.banks.creditCardNumber": "Kartennummer",
    "app.banks.deleteBankConfirm":
        "Bitte bestätigen Sie, dass Sie die Bank löschen wollen. Alle Daten werden dabei endgültig gelöscht.",
    "app.banks.onlyCsv": "nur CSV",
    "app.banks.isConnected": "ist verbunden",
    "app.banks.isNotConnected": "ist nicht verbunden",
    "app.banks.dmsBankLabel": "Bank: {name}",
    "app.banks.dmsBankBindHeading": "DMS Bank verknüpfen",
    "app.banks.bankType": "Bankart",
    "app.banks.bankTypeCreditCard": "Kreditkarte",
    "app.banks.bankTypePlatform": "Plattform",
    "app.banks.import": "Importieren",
    "app.banks.stepInitConnection": "Verbindung initialisieren",
    "app.banks.stepEstablishConnection": "Verbindung herstellen",
    "app.banks.finapiConnection": "FinAPI Verbindung",
    "app.banks.linkImportedAccount": "Importiertes Konto verknüpfen",
    "app.banks.connectNewBank": "Neue Bank verbinden",
    "app.banks.startConnection": "Verbindung starten",
    "app.banks.stepUpdateConnection": "Verbindung aktualisieren",
    "app.banks.stepImportTransactions": "Transaktionen importieren",
    "app.banks.finapiImport": "FinAPI Import",
    "app.banks.lastImportDate": "Datum des letzten Imports",
    "app.banks.importFrom": "Import ab",
    "app.banks.importFromInvalid": "Datum zwischen {min} und {max} wählen",
    "app.banks.onlyNewTransactions": "Nur neue Transaktionen",
    "app.banks.finapiIsConnected": "<b>FinAPI</b> ist verbunden.",
    "app.banks.disconnect": "Verbindung trennen",
    "app.banks.accountLinkedSuccess": "Konto erfolgreich verknüpft",
    "app.banks.noAvailableAccounts": "Keine verfügbaren Konten gefunden.",
    "app.banks.stepInitiatePayment": "Zahlung initiieren",
    "app.banks.stepFinalizePayment": "Zahlung abschließen",
    "app.banks.paymentTransfer": "Zahlungsüberweisung",
    "app.banks.recipientName": "Name des Empfängers",
    "app.banks.amountEur": "Betrag (EUR)",
    "app.banks.startPayment": "Zahlung starten",
    "app.banks.paymentInitiatedSuccess": "Zahlung erfolgreich initiiert.",
    "app.banks.paymentIdLabel": "Zahlungs-ID: {id}",
    "app.banks.transactionsProcessed":
        "{count, plural, one {# Transaktion verarbeitet} other {# Transaktionen verarbeitet}}",
    "app.banks.transactionsTimeframe": "Zeitraum von {from} bis {to}",
    "app.banks.findDmsDocument": "DMS Dokument finden",
    "app.banks.findAndFillContact": "Kontakt finden und ausfüllen (Name, IBAN)",
    "app.banks.contactSuggestions.button": "Kontakte aus Stammdaten vorschlagen",
    "app.banks.contactSuggestions.scopeHint":
        "Für die ausgewählten Transaktionen, ohne Auswahl für alle Transaktionen ohne Kontakt.",
    "app.banks.contactSuggestions.title":
        "{count, plural, one {# Kontakt aus Stammdaten vorschlagen} other {# Kontakte aus Stammdaten vorschlagen}}",
    "app.banks.contactSuggestions.description":
        "Die IBAN dieser Transaktionen ist in den USt-IdNr.-Stammdaten genau einem Unternehmen zugeordnet. Die markierten Kontakte werden angelegt und mit ihren Transaktionen verknüpft.",
    "app.banks.contactSuggestions.transactions": "{count, plural, one {# Transaktion} other {# Transaktionen}}",
    "app.banks.contactSuggestions.confirm": "Kontakte anlegen",
    "app.banks.contactSuggestions.empty": "Keine Kontaktvorschläge aus den Stammdaten gefunden.",
    "app.banks.contactSuggestions.loadError": "Fehler beim Laden der Kontaktvorschläge: {error}",
    "app.banks.contactSuggestions.saving": "Kontakte werden angelegt",
    "app.banks.contactSuggestions.saveError": "Fehler beim Anlegen der Kontakte: {error}",
    "app.banks.contactSuggestions.created": "{count, plural, one {# Kontakt angelegt} other {# Kontakte angelegt}}",
    "app.banks.contactSuggestions.existing": "{count} bereits vorhanden",
    "app.banks.contactSuggestions.unavailable": "{count} nicht mehr verfügbar",
    "app.banks.contactSuggestions.nothing": "Keine Kontakte angelegt",
    "app.banks.fibuExportTooltip": "Datensätze in der FIBU-Bank <b>{name} ({accountNum})</b> erstellen",
    "app.banks.bookings": "Buchungen",
    "app.banks.contactMatched": "mit Kontakt abgeglichen",
    "app.banks.contactMismatch": "stimmt nicht mit Kontakt überein",
    "app.banks.finapiTransactionNotDeletable":
        "Transaktionen, die von der Bank mit FinAPI importiert wurden, können nicht entfernt werden",
    "app.banks.bankUndefined": "Bank nicht definiert",
    "app.banks.closeTransactionImport": "Transaktionsimport schließen",
    "app.banks.hideExistingTransactions": "Vorhandene Transaktionen ausblenden",
    "app.banks.transactionsRecognized": "Banktransaktionen wurden erfolgreich erkannt",
    "app.banks.goToTransactionData": "Zu den Transaktionsdaten",
    "app.contacts.basicInformation": "Basisinformationen",
    "app.contacts.markAsInvoiceAddress": "als Rechnungsadresse markieren",
    "app.contacts.commercialRegister": "Handelsregister",
    "app.contacts.personalIdNr": "Personal IdNr",
    "app.contacts.idNrIndividualOnly": 'nur für den "natürliche Person" Typ verfügbar',
    "app.contacts.clearFilters": "Filter zurücksetzen",
    "app.contacts.errorSaving": "Fehler beim Speichern des Kontakts",
    "app.contacts.noWritePermission": "Sie haben keine Berechtigung zum Speichern.",
    "app.contacts.errorSearching": "Fehler bei der Kontaktsuche",
    "app.contacts.searchTerm": "Suchbegriff",
    "app.contacts.searchPlaceholder": "Name, IBAN, UStIdNr, Steuernummer...",
    "app.dms.aiLog.title": "KI-Log · {fileName}",
    "app.dms.aiLog.extractionFailed": "KI-Extraktion fehlgeschlagen",
    "app.dms.aiLog.loadError": "Fehler beim Laden des KI-Logs: {error}",
    "app.dms.aiLog.empty": "Kein KI-Log für dieses Dokument vorhanden.",
    "app.dms.aiLog.copyJson": "JSON kopieren",
    "app.dms.ibanCheck.unknownIbans": "IBAN nicht beim Kontakt hinterlegt",
    "app.dms.markdown.title": "Texterkennung: {fileName}",
    "app.dms.markdown.tab.rendered": "Ansicht",
    "app.dms.markdown.tab.raw": "Raw",
    "app.dms.markdown.copy": "Text kopieren",
    "app.dms.markdown.empty": "Kein Text vorhanden",
    "app.dms.markdown.loadError": "Fehler beim Laden: {error}",
    "app.dms.markdown.tabs.label": "Markdown-Ansicht",
    "app.dms.markdown.search": "Im Text suchen",
    "app.dms.markdown.search.next": "Nächster Treffer",
    "app.dms.markdown.search.previous": "Vorheriger Treffer",
    "app.dms.markdown.search.matches": "{current} von {total}",
    "app.dms.markdown.search.noMatches": "Keine Treffer",
    "app.dms.markdown.search.hint": "Mindestens 2 Zeichen eingeben",
    "app.dms.markdown.breakdown.title": "KI-Aufschlüsselung",
    "app.dms.markdown.breakdown.loading": "KI-Aufschlüsselung wird geladen",
    "app.dms.markdown.breakdown.error": "KI-Aufschlüsselung konnte nicht geladen werden",
    "app.dms.markdown.breakdown.empty": "Keine KI-Daten verfügbar",
    "app.dms.markdown.breakdown.metroApplied": "Metro-Aufteilung nach Kategorien",
    "app.dms.markdown.breakdown.checks": "Prüfungen {passed}/{total}",
    "app.dms.markdown.breakdown.passed": "Bestanden",
    "app.dms.markdown.breakdown.failed": "Fehlgeschlagen",
    "app.dms.markdown.breakdown.lines": "{count, plural, one {# Position} other {# Positionen}}",
    "app.dms.markdown.breakdown.net": "Netto",
    "app.dms.markdown.breakdown.tax": "USt",
    "app.dms.markdown.breakdown.gross": "Brutto",
    "app.dms.markdown.breakdown.expected": "Soll",
    "app.dms.markdown.breakdown.actual": "Ist",
    "app.dms.aiStatus": "KI-Status",
    "app.dms.aiStatus.progress": "In Bearbeitung",
    "app.dms.aiStatus.success": "Erfolgreich",
    "app.dms.aiStatus.error": "Fehler",
    "app.dms.documentsEdited": "{count, plural, one {# Dokument bearbeitet} other {# Dokumente bearbeitet}}",
    "app.dms.amountMode.input": "Eingabe",
    "app.dms.amountMode.tooltipInput":
        "Eingabe: Der eingegebene Betrag wird in alle ausgewählten Dokumente übernommen.",
    "app.dms.amountMode.tooltipSign":
        "Ertrag / Aufwand: Jedes Dokument behält seinen Betrag, nur das Vorzeichen wird passend zum Ordner gesetzt.",
    "app.dms.amountMode.tooltipSkipped":
        "Dokumente ohne Betrag, Anhänge und Dokumente außerhalb der Buchhaltungsordner bleiben unverändert.",
    "app.dms.tagFieldHint.title": "Dieses Feld kann nur bearbeitet werden, wenn:",
    "app.dms.tagFieldHint.condition1": "1. das Datum nicht leer ist und",
    "app.dms.tagFieldHint.condition2": "2. eine Buchhaltungskonfiguration für das Jahr dieses Datums vorhanden ist.",
    "app.dms.upload.alreadyExisting": "Bereits vorhanden, nicht erneut hochgeladen: {count}",
    "app.dms.fileInfo.documentType": "Dokumenttyp",
    "app.dms.fileInfo.uploadedAt": "Hochgeladen am",
    "app.dms.upload.unsupportedFiles": "Nicht unterstützte Dateien: {count}",
    "app.dms.upload.errorLabel": "Fehler: {error}",
    "app.dms.upload.success": "{count, plural, one {# Dokument hochgeladen} other {# Dokumente hochgeladen}}",
    "app.dms.upload.failed":
        "{count, plural, one {# Datei konnte nicht hochgeladen werden} other {# Dateien konnten nicht hochgeladen werden}}",
    "app.dms.payments.createGroup": "Sammelzahlung erstellen",
    "app.dms.fileNameOriginal": "Original",
    "app.dms.fileNameExport": "Export",
    "app.dms.avis.createdAt": "Erstellt",
    "app.dms.avis.documentsCount": "Dokumente ({count})",
    "app.dms.contactsCreated": "Kontakte wurden erstellt.",
    "app.dms.noContactsCreated": "Keine Kontakte erstellt.",
    "app.dms.contacts.create": "Kontakte erstellen",
    "app.dms.contacts.create.desc": "Kontakte werden aus den Daten der ausgewählten Dokumente erstellt.",
    "app.dms.contacts.fill": "Kontakt befüllen",
    "app.dms.contacts.fill.desc":
        "Anhand der KI-Daten befüllen wir den passenden Kontakt in den ausgewählten Dokumenten.",
    "app.dms.contacts.filled": "{count} Dokument(e) mit Kontakt verknüpft.",
    "app.dms.contacts.noneFilled": "Keine passenden Kontakte für die ausgewählten Dokumente gefunden.",
    "app.dms.duplicates.title": "Doppelerfassung-Prüfung",
    "app.dms.duplicates.tooltip":
        "Doppelerfassung-Prüfung in der Auswahl: filtert die Liste auf ausgewählte Dokumente mit gleicher Rechnungsnummer und gleichem Betrag. Erneut klicken, um den Filter aufzuheben.",
    "app.dms.duplicates.none": "Keine Duplikate in der Auswahl gefunden.",
    "app.dms.duplicates.found":
        "{groups, plural, one {# Gruppe} other {# Gruppen}} ({documents, plural, one {# Dokument} other {# Dokumente}})",
    "app.dms.pdfAi.maxDocs":
        "Binale PDF AI verarbeitet maximal {max} Dokumente pro Durchlauf. Aktuell sind {selected} ausgewählt.",
    "app.dms.pdfAi.normal": "Normal verarbeiten",
    "app.dms.pdfAi.normal.desc": "Verarbeitet nur Dokumente, die noch nicht von der KI verarbeitet wurden.",
    "app.dms.pdfAi.force": "Erneut verarbeiten (erzwingen)",
    "app.dms.pdfAi.force.desc":
        "Startet die KI auch für bereits verarbeitete Dokumente neu, verbraucht KI-Kontingent, maximal {max} Dokumente.",
    "app.domain.skrLoading": "Daten werden geladen... {progress}%",
    "app.domain.skrLoaded": "SKR-Daten geladen",
    "app.domain.userDataLoading": "Benutzerdaten werden geladen…",
    "app.domain.simultaneousLogin.title": "Gleichzeitige Anmeldung erkannt",
    "app.domain.simultaneousLogin.heading": "Jemand hat sich mit Ihren Zugangsdaten angemeldet",
    "app.domain.simultaneousLogin.body":
        "Leider ist es nicht möglich, auf mehreren Computern mit denselben Zugangsdaten zu arbeiten. Sie werden in 5 Sekunden abgemeldet.",
    "app.domain.simultaneousLogin.device": "Neue Anmeldung von: {device}",
    "app.domain.sessionRevoked.title": "Sitzung beendet",
    "app.domain.sessionRevoked.heading": "Diese Sitzung wurde von Ihnen beendet",
    "app.domain.sessionRevoked.body": "Sie werden in 5 Sekunden abgemeldet.",
    "app.profile.sessions.title": "Aktive Sitzungen",
    "app.profile.sessions.current": "Aktuelle Sitzung",
    "app.profile.sessions.description":
        "Browsersitzungen dieses Kontos. Geschlossene Browser verschwinden von selbst aus der Liste.",
    "app.profile.sessions.singleSession": "Andere Sitzungen automatisch abmelden",
    "app.profile.sessions.singleSession.hint":
        "Ist die Option aktiv, wird bei jeder Anmeldung jede andere Sitzung dieses Kontos beendet.",
    "app.profile.sessions.since": "Angemeldet seit",
    "app.profile.sessions.end": "Beenden",
    "app.profile.sessions.end.confirm": "Diese Sitzung beenden?",
    "app.profile.sessions.empty": "Keine weiteren Sitzungen.",
    "app.domain.recordUpdated.title": "Buchungssatz wurde aktualisiert",
    "app.domain.recordUpdated.body":
        "Es wurden {count} Änderungen am Buchungssatz aus dem angehängten Dokument vorgenommen",
    "app.domain.debitorName": "Debitor Bezeichnung",
    "app.invoice.saveCustomerAsContact": "Kundenangaben als Kontakt speichern",
    "app.invoice.completed": "Fertiggestellt",
    "app.invoice.example": "Beispiel",
    "app.invoice.finalize": "Fertigstellen",
    "app.invoice.template": "Vorlage",
    "app.invoice.plusVat": "zzgl. Umsatzsteuer {rate}% ( {amount} )",
    "app.invoice.numberFormat": "Nummernformat",
    "app.invoice.invalidCharacters": "Ungültige Zeichen",
    "app.invoice.prefix": "Prefix",
    "app.invoice.numberLength": "Nummerlänge",
    "app.invoice.startNumber": "Startnummer",
    "app.invoice.maxValue": "Max {max}",
    "app.invoice.suffix": "Suffix",
    "app.invoice.formats": "Formate",
    "app.invoice.lineItemTemplates": "Produkt-/Dienstleistungsvorlagen",
    "app.invoice.paymentTemplates": "Zahlungsbedingungsvorlagen",
    "app.invoice.pdfWithERechnung": "PDF mit E-Rechnung (ZUGFeRD 2.4 / Factur-X)",
    "app.pdf.stats.pages": "Seitenanzahl",
    "app.pdf.stats.title": "OCR-Statistik",
    "app.pdf.ocrOptions": "OCR-Optionen",
    "app.pdf.skipQrCheck": "Unlesbare QR-Codes als Trennblatt werten",
    "app.pdf.selectDocument": "Dokument {name} auswählen",
    "app.pdf.toast.decodedEncrypted": "Verschlüsselte Datei entschlüsselt",
    "app.pdf.viewer.search": "Im Dokument suchen",
    "app.pdf.viewer.search.next": "Nächster Treffer",
    "app.pdf.viewer.search.previous": "Vorheriger Treffer",
    "app.pdf.viewer.search.matches": "{current} von {total}",
    "app.pdf.viewer.search.noMatches": "Keine Treffer",
    "app.pdf.viewer.search.close": "Suche schließen",
    "app.pdf.viewer.search.unavailable": "Dieses Dokument enthält keinen durchsuchbaren Text",
    "app.components.selectAccount": "Konto auswählen",
    "app.components.xrechnung.formatDeprecated": "Achtung, dieses Format ist veraltet!",
    "app.components.xrechnung.email": "E-Mail",
    "app.components.xrechnung.paymentDetails": "Zahlungsdetails",
    "app.components.xrechnung.paymentMethodNotSpecified": "Zahlungsmethode wurde nicht angegeben",
    "app.components.xrechnung.dueDate": "Fälligkeitsdatum",
    "app.components.xrechnung.invoiceLines": "Rechnungspositionen",
    "app.components.xrechnung.bookingLines": "Buchungspositionen",
    "app.components.xrechnung.rule": "Regel",
    "app.components.xrechnung.location": "Lokation",
    "app.components.xrechnung.hasErrors": "E-Rechnung enthält Fehler oder Warnungen",
    "app.components.xrechnung.validating": "Validierung...",
    "app.components.xrechnung.isValid": "E-Rechnung Rechnung ist gültig",
    "app.components.xrechnung.showXml": "E-Rechnung XML anzeigen",
    "app.components.xrechnung.xmlTitle": "E-Rechnung XML",
    // --- intl accounting migration ---
    "app.fields.period": "Periode",
    "app.button.ok": "OK",
    "app.columns.column2": "Spalte 2",
    "app.columns.column3": "Spalte 3",
    "app.dms.copyFailed": "Kopieren fehlgeschlagen",
    "app.dms.cashRegister.export": "In die Kasse übertragen",
    "app.dms.cashRegister.exportConfirm":
        "{count, plural, one {# Beleg wird} other {# Belege werden}} als Kassenbewegung in <b>{name}</b> angelegt.",
    "app.dms.datev.export": "Ausgewählte Dokumente an DATEV senden",
    "app.dms.datev.exportTooltip": "Ausgewählte Dokumente werden nach Belegmonat gruppiert an DATEV übertragen.",
    "app.dms.datev.notConnected": "Für den Export ist eine aktive DATEV-Verbindung erforderlich.",
    "app.dms.datev.missingDocumentDate": "Alle ausgewählten Dokumente benötigen ein Belegdatum.",
    "app.dms.datev.result":
        "DATEV-Export: {uploaded} hochgeladen, {exists} bereits vorhanden, {failed} fehlgeschlagen.",
    "app.dms.datev.error": "Die Dokumente konnten nicht an DATEV gesendet werden.",
    "app.dms.autoSort.button": "Automatisch sortieren",
    "app.dms.autoSort.failed": "Automatische Sortierung fehlgeschlagen",
    "app.dms.autoSort.summaryTitle":
        "{moved, plural, =0 {Keine Dokumente sortiert} one {# Dokument sortiert} other {# Dokumente sortiert}}",
    "app.dms.autoSort.summaryDescription":
        "Eingangsrechnungen: {er} · Ausgangsrechnungen: {deb} · Bank: {bank} (mit Umsatz verknüpft: {linked}) · Kasse: {kb} · in Neue Dokumente geblieben: {remaining}{skipped, plural, =0 {} other { · # übersprungen}}{failed, plural, =0 {} other { · # fehlgeschlagen}}",
    "app.dms.bewirtung.title": "Bewirtungsbeleg",
    "app.dms.bewirtung.kind.business": "Geschäftliche Bewirtung",
    "app.dms.bewirtung.kind.employees": "Nur Mitarbeitende",
    "app.dms.bewirtung.date": "Tag der Bewirtung",
    "app.dms.bewirtung.place": "Ort (Restaurant, Anschrift)",
    "app.dms.bewirtung.participants": "Bewirtete Personen (eine pro Zeile, einschließlich Gastgeber)",
    "app.dms.bewirtung.occasion": "Anlass der Bewirtung",
    "app.dms.bewirtung.amount": "Höhe der Aufwendungen",
    "app.dms.bewirtung.tip": "Trinkgeld",
    "app.dms.bewirtung.host": "Bewirtende Person",
    "app.dms.bewirtung.confirmed": "Bestätigt von {user} am {date}",
    "app.dms.bewirtung.confirmedOn": "Bestätigt am {date}",
    "app.dms.bewirtung.save": "Speichern",
    "app.dms.bewirtung.occasionRequired": "Bitte den konkreten Anlass angeben",
    "app.dms.bewirtung.create": "Bewirtungsbeleg erstellen",
    "app.dms.bewirtung.edit": "Bearbeiten",
    "app.dms.bewirtung.staleNotice":
        "Der Bewirtungsbeleg wurde zwischenzeitlich geändert. Zum Speichern bitte neu laden.",
    "app.dms.bewirtung.reload": "Neu laden",
    "app.dms.bewirtung.saveFailed": "Der Bewirtungsbeleg konnte nicht gespeichert werden",
    "app.dms.bewirtung.removeFailed": "Der Bewirtungsbeleg konnte nicht entfernt werden",
    "app.dms.bewirtung.removeConfirm": "Den Bewirtungsbeleg wirklich entfernen?",
    "app.dms.bewirtung.discardUnsaved": "Ungespeicherte Änderungen am Bewirtungsbeleg verwerfen?",
    "app.dms.bewirtung.discardConfirm": "Verwerfen",
    "app.dms.bewirtung.remove": "Bewirtungsbeleg entfernen",
    "app.dms.bewirtung.aiLoadFailed": "KI-Daten konnten nicht geladen werden",
    "app.dms.bewirtung.virtualSigned": "Signiert",
    "app.dms.bewirtung.virtualUnsigned": "Nicht signiert",
    "app.dms.bewirtung.virtualAria": "Bewirtungsbeleg anzeigen ({state})",
    "app.dms.bewirtung.virtualHint": "Aus den Bewirtungsdaten dieses Belegs erzeugt",
    "app.dms.bewirtung.viewPdf": "PDF ansehen",
    "app.dms.bewirtung.viewPdfLocked": "Signierten Bewirtungsbeleg als PDF ansehen",
    "app.dms.bewirtung.pdfFailed": "Das PDF konnte nicht erstellt werden",
    "app.dms.bewirtung.column": "BW",
    "app.dms.bewirtung.amountHint":
        "Der Beleg muss maschinell erstellt und von einer zertifizierten Kasse (TSE) abgesichert sein. Über 250 € brutto muss die Rechnung zusätzlich den Namen des Bewirtenden als Rechnungsempfänger, die Steuernummer oder USt-IdNr. des Restaurants und eine fortlaufende Rechnungsnummer enthalten (BMF-Schreiben vom 19.11.2025).",
    "app.dms.bewirtung.hostHint":
        "Name der bewirtenden Person, z. B. „Max Muster (Geschäftsführer Muster GmbH)“, keine E-Mail-Adresse. Bei Rechnungen über 250 € muss dieser Name auf der Rechnung stehen.",
    "app.dms.bewirtung.missingHint":
        "Dieser Beleg sieht nach einer Bewirtung aus. Für den Betriebsausgabenabzug bitte zeitnah Anlass und Teilnehmer erfassen (§ 4 Abs. 5 Nr. 2 EStG).",
    "app.dms.bewirtung.sign": "Signieren und festschreiben",
    "app.dms.bewirtung.signConfirm":
        "Sie signieren als {name}. Danach ist der Bewirtungsbeleg festgeschrieben und kann nicht mehr geändert oder entfernt werden.",
    "app.dms.bewirtung.signConfirmButton": "Signieren",
    "app.dms.bewirtung.signed": "Bewirtungsbeleg signiert und festgeschrieben",
    "app.dms.bewirtung.signFailed": "Signieren fehlgeschlagen",
    "app.dms.bewirtung.alreadyLocked": "Der Bewirtungsbeleg ist bereits signiert und festgeschrieben",
    "app.dms.bewirtung.lockedBy": "Signiert und festgeschrieben von {user} am {date}",
    "app.dms.bewirtung.lockedOn": "Signiert und festgeschrieben am {date}",
    "app.dms.bewirtung.signatureChecking": "Signatur wird geprüft …",
    "app.dms.bewirtung.signatureValid": "Signatur gültig: Inhalt unverändert seit dem Festschreiben",
    "app.dms.bewirtung.signatureInvalid": "Signatur ungültig: Inhalt stimmt nicht mit dem signierten Stand überein",
    "app.dms.bewirtung.signatureUnavailable": "Signatur konnte nicht geprüft werden",
    "app.dms.sortAssistant.title": "Sortier-Assistent",
    "app.dms.sortAssistant.progress": "Schritt {current} von {total}",
    "app.dms.sortAssistant.showDocument": "Beleg ansehen",
    "app.dms.sortAssistant.hideDocument": "Beleg ausblenden",
    "app.dms.sortAssistant.skip": "Überspringen",
    "app.dms.sortAssistant.close": "Assistent schließen",
    "app.dms.sortAssistant.bewirtungQuestion": "Was war das?",
    "app.dms.sortAssistant.noBewirtung": "Keine Bewirtung (Reise, privat)",
    "app.dms.sortAssistant.bankPickQuestion": "Zu welchem Umsatz gehört der Beleg?",
    "app.dms.sortAssistant.noneOfThem": "Keiner davon",
    "app.dms.sortAssistant.whereQuestion": "Wohin gehört der Beleg?",
    "app.dms.sortAssistant.toKasse": "Kasse",
    "app.dms.sortAssistant.toBank": "Bank ohne Umsatz",
    "app.dms.sortAssistant.toEr": "Eingangsrechnungen",
    "app.dms.sortAssistant.stay": "In Neue Dokumente lassen",
    "app.dms.fibu.export.title": "FIBU Export",
    "app.dms.fibu.export.disabled.not_accounting_type": "Dies ist kein Buchhaltungsdokument.",
    "app.dms.fibu.export.disabled.too_many_documents": "Zu viele Dokumente ausgewählt (max. 200).",
    "app.dms.fibu.export.disabled.mixed_types": "Bitte nur Dokumente desselben Typs auswählen.",
    "app.dms.fibu.export.disabled.no_type": "Kein Dokumenttyp erkannt.",
    "app.dms.fibu.export.disabled.documents_not_ready":
        "Nicht alle Dokumente sind vollständig ausgefüllt (Status: Entwurf).",
    "app.dms.fibu.export.disabled.no_group_id": "Bitte zuerst ein Konto (Bank oder Kasse) auswählen.",
    "app.dms.fibu.export.disabled.missing_document_date": "Mindestens ein Dokument hat kein Belegdatum.",
    "app.dms.fibu.export.disabled.not_a_receipt": "Informationsdokument, kein Beleg: es wird keine Buchung erzeugt.",
    "app.dms.fibu.export.disabled.year_not_in_accounting_years":
        "Das Belegdatum liegt außerhalb der angelegten Buchungsjahre ({years}).",

    "app.mailbox.button": "E-Mail-Import",
    "app.mailbox.title": "Postfach verbinden",
    "app.mailbox.description":
        "Verbinden Sie ein E-Mail-Postfach, um Rechnungen (PDF-Anhänge) automatisch stündlich in die Dokumentenverwaltung zu importieren.",
    "app.mailbox.provider": "Anbieter",
    "app.mailbox.provider.imap": "IMAP",
    "app.mailbox.provider.microsoft365": "Microsoft 365",
    "app.mailbox.provider.googleWorkspace": "Google Workspace",
    "app.mailbox.provider.comingSoon": "Demnächst verfügbar",
    "app.mailbox.m365.connect": "Mit Microsoft 365 verbinden",
    "app.mailbox.m365.connectedAs": "Verbunden als",
    "app.mailbox.m365.reconnect": "Neu verbinden",
    "app.mailbox.m365.connecting": "Microsoft 365 wird verbunden…",
    "app.mailbox.host": "Server (Host)",
    "app.mailbox.port": "Port",
    "app.mailbox.secure": "Sichere Verbindung (SSL/TLS)",
    "app.mailbox.username": "Benutzername",
    "app.mailbox.folder": "Ordner (optional)",
    "app.mailbox.folder.placeholder": "INBOX",
    "app.mailbox.password.configured": "Passwort hinterlegt",
    "app.mailbox.password.change": "Passwort ändern",
    "app.mailbox.password.new": "Neues Passwort",
    "app.mailbox.enabled": "Automatischer Import aktiviert",
    "app.mailbox.testConnection": "Verbindung testen",
    "app.mailbox.testSuccess": "Verbindung erfolgreich hergestellt",
    "app.mailbox.testFailed": "Verbindung fehlgeschlagen",
    "app.mailbox.status.title": "Status",
    "app.mailbox.status.connection": "Verbindungsstatus",
    "app.mailbox.status.lastPolled": "Zuletzt abgerufen",
    "app.mailbox.status.neverPolled": "noch nicht abgerufen",
    "app.mailbox.status.lastError": "Letzter Fehler",
    "app.mailbox.status.untested": "Nicht getestet",
    "app.mailbox.status.ok": "OK",
    "app.mailbox.status.error": "Fehler",
    "app.mailbox.delete": "Konfiguration löschen",
    "app.mailbox.delete.confirm": "Möchten Sie die Postfach-Konfiguration wirklich löschen?",
    "app.mailbox.template": "Vorlage",
    "app.mailbox.template.custom": "Benutzerdefiniert",
    "app.mailbox.template.gmail": "Gmail",
    "app.mailbox.template.yahoo": "Yahoo",
    "app.mailbox.template.gmx": "GMX",
    "app.mailbox.template.webde": "WEB.DE",
    "app.mailbox.template.aol": "AOL",
    "app.mailbox.hint.openGuide": "Anleitung öffnen",
    "app.mailbox.hint.gmail":
        "Gmail erfordert die Zwei-Faktor-Authentifizierung und ein App-Passwort – dein normales Passwort funktioniert für IMAP nicht. Aktiviere die 2FA in deinem Google-Konto, erstelle ein App-Passwort und trage dieses hier als Passwort ein.",
    "app.mailbox.hint.yahoo":
        "Yahoo erfordert ein App-Passwort. Melde dich bei der Yahoo-Kontosicherheit an, wähle „App-Passwort generieren“, vergib einen Namen (z. B. Binale) und trage das generierte Passwort hier als Passwort ein.",
    "app.mailbox.hint.aol":
        "AOL erfordert ein App-Passwort. Erstelle in den AOL-Sicherheitseinstellungen ein App-Passwort und trage es hier als Passwort ein.",
    "app.mailbox.hint.gmx":
        "Bei GMX muss der IMAP-Zugriff zuvor in den Postfach-Einstellungen aktiviert werden. Verwende danach deine vollständige GMX-Adresse und dein normales Mail-Passwort.",
    "app.mailbox.hint.webde":
        "Bei WEB.DE muss der IMAP-Zugriff zuvor in den Postfach-Einstellungen aktiviert werden. Verwende danach deine vollständige WEB.DE-Adresse und dein normales Mail-Passwort.",

    "app.fields.drag": "Ziehen",
    "app.invoicing.lineItemTemplate": "Vorlage",
    "app.titles.banks": "Banken",
    "app.titles.buchungen": "Buchungen",
    "app.titles.cashRegisters": "Kassenbücher",
    "app.titles.invoicing": "Rechnungen",
    "app.validation.pattern": "Ungültiges Format",
    "app.validation.required": "Pflichtfeld",
    "app.datev.configTitle": "DATEV Konfiguration",
    "app.datev.group": "Gruppe",
    "app.datev.exportOptions": "Export-Optionen",
    "app.datev.exportTabs": "Export-Tabs",
    "app.datev.exportResults": "DATEV Export-Ergebnisse",
    "app.datev.exportDocuments": "Belege exportieren",
    "app.datev.exportBelegfeld2": "Belegfeld2 exportieren",
    "app.datev.exportKostenstelle": "Kostenstelle exportieren",
    "app.datev.transferDocuments": "Belege übertragen",
    "app.datev.exportFormatMonthly": "Export DATEV-Format (monatlich)",
    "app.datev.exportFormatCombined": "Export DATEV-Format (Perioden zusammengefasst)",
    "app.datev.sendToDatev": "an DATEV senden (Buchungsdatenservice)",
    "app.datev.documentsTitle": "DATEV Belege",
    "app.datev.step1DocumentTable": "1. DATEV Belegtabelle CSV",
    "app.datev.step2DocumentsZip": "2. Belege ZIP",
    "app.datev.step3Download": "3. {label}",
    "app.datev.missingFilesInZip": "Fehlende Dateien in ZIP",
    "app.datev.invalidAmount": "ungültiger Betrag",
    "app.datev.errorColumnCount": "Alle Zeilen müssen 40-{max} Spalten haben",
    "app.datev.errorPeriodDecode": "Falsche Periode erkannt: {period}, erlaubte Werte sind [1, 12]",
    "app.datev.documentsAttached": "{attached} von {total} Dokumenten zugeordnet",
    "app.datev.unattachedDocuments": "{count} nicht zugeordnete Dokumente werden ebenfalls importiert",
    "app.datev.creditorsToCreate": "Beim Speichern zu erstellende Kreditoren: {list}",
    "app.datev.debitorsToCreate": "Beim Speichern zu erstellende Debitoren: {list}",
    "app.datev.categoriesToCreate": "Beim Speichern zu erstellende Sachkonten: {list}",
    "app.datev.missingKostenstelle": "Fehlende Kostenstelle: {list}",
    "app.datev.missingBanks": "Fehlende Banken: {list}",
    "app.datev.missingKassen": "Fehlende Kassen: {list}",
    "app.datev.annotation": "Anmerkung",
    "app.datev.unassignedGroup": "Ohne Bank/Kasse",
    "app.datev.importError.missingBank": "Bank {value} ist nicht angelegt - diese Zeile kann nicht importiert werden",
    "app.datev.importError.missingKasse": "Kasse {value} ist nicht angelegt - diese Zeile kann nicht importiert werden",
    "app.datev.selectedForImport": "{selected} von {total} Buchungen zum Import ausgewählt",
    "app.datev.loadingDocuments": "Belege werden geladen",
    "app.items.sinceYear": "(seit {year})",
    "app.overview.bwa.umsatzerloese": "Umsatzerlöse",
    "app.overview.bwa.bestandsveraenderung": "Bestandsveränderung FE/UE",
    "app.overview.bwa.aktivierteEigenleistungen": "Aktivierte Eigenleistungen",
    "app.overview.bwa.gesamtleistung": "Gesamtleistung",
    "app.overview.bwa.materialWareneinkauf": "Material-/Wareneinkauf",
    "app.overview.bwa.rohertrag": "Rohertrag",
    "app.overview.bwa.sonstigeBetrieblicheErloese": "Sonstige betriebliche Erlöse",
    "app.overview.bwa.betrieblicherRohertrag": "Betrieblicher Rohertrag",
    "app.overview.bwa.personalkosten": "Personalkosten",
    "app.overview.bwa.raumkosten": "Raumkosten",
    "app.overview.bwa.betrieblicheSteuern": "Betriebliche Steuern",
    "app.overview.bwa.versicherungenBeitraegeAbgaben": "Versicherungen, Beiträge und Abgaben",
    "app.overview.bwa.besondereKosten": "Besondere Kosten",
    "app.overview.bwa.fahrzeugkosten": "Fahrzeugkosten (ohne Steuer)",
    "app.overview.bwa.werbeReisekosten": "Werbe- und Reisekosten",
    "app.overview.bwa.kostenWarenabgabe": "Kosten Warenabgabe",
    "app.overview.bwa.abschreibungen": "Abschreibungen",
    "app.overview.bwa.reparaturenInstandhaltungen": "Reparaturen und Instandhaltungen",
    "app.overview.bwa.sonstigeKosten": "Sonstige Kosten",
    "app.overview.bwa.gesamtkosten": "Gesamtkosten",
    "app.overview.bwa.betriebsergebnis": "Betriebsergebnis",
    "app.overview.bwa.zinsaufwendungen": "Zinsaufwendungen",
    "app.overview.bwa.sonstigerNeutralerAufwand": "Sonstiger neutraler Aufwand",
    "app.overview.bwa.neutralerAufwand": "Neutraler Aufwand",
    "app.overview.bwa.zinsertraege": "Zinserträge",
    "app.overview.bwa.sonstigerNeutralerErtrag": "Sonstiger neutraler Ertrag",
    "app.overview.bwa.verrechneteKalkKosten": "Verrechnete kalk. Kosten",
    "app.overview.bwa.neutralerErtrag": "Neutraler Ertrag",
    "app.overview.bwa.kontenklasseUnbesetzt": "Kontenklasse unbesetzt",
    "app.overview.bwa.ergebnisVorSteuern": "Ergebnis vor Steuern",
    "app.overview.bwa.steuernEinkommenErtrag": "Steuern vom Einkommen und vom Ertrag",
    "app.overview.bwa.vorlaeufigesErgebnis": "Vorläufiges Ergebnis",
    "app.overview.bwa.footerSelected": "Summe Auswahl",
    "app.overview.bwa.pdf.title": "Betriebswirtschaftliche Auswertung",
    "app.overview.bwa.pdf.berichtsposition": "Berichtsposition",
    "app.overview.bwa.pdf.unit": "Werte in EUR",
    "app.overview.bwa.pdf.range": "{from} bis {to}",
    "app.overview.bwa.pdf.quarter": "{n}. Quartal {year}",
    "app.overview.bwa.pdf.saldenvortrag": "01.01.{year} (Saldenvortrag)",
    "app.overview.bwa.pdf.abschluss": "31.12.{year} (Abschluss)",
    "app.overview.bwa.pdf.created": "Erstellt am {date} mit Binale-Buchhaltung (Version {version})",
    "app.overview.bwa.pdf.createdOn": "Erstellt am {date}",
    "app.overview.bwa.pdf.disclaimer": "Das vorläufige Ergebnis entspricht dem derzeitigen Stand der Buchführung.",
    "app.overview.bwa.pdf.page": "Seite {page} von {total}",
    "app.overview.reconciliation.startPrompt": "Zum Starten OK drücken (insgesamt {count})",
    "app.overview.reconciliation.manual.title": "Manuelle Verknüpfung",
    "app.overview.reconciliation.manual.approvalNeeded":
        "Eine festgeschriebene oder bestätigte Buchung wäre betroffen. Bitte in der Tabelle verknüpfen und dort bestätigen.",
    "app.overview.reconciliation.manual.body":
        "{count, plural, =1 {Die 2 ausgewählten Buchungen werden mit einer Zahlung verknüpft.} other {Die Rechnung wird mit # Zahlungsdarstellungen verknüpft, je eine Zahlung pro Zahlungsdarstellung.}}",
    "app.overview.reconciliation.tooltip.auto":
        "Automatisch (Standard): Die Zahl am Button nennt die Zahlungsdarstellungen (Bank, Kasse, Freie Erfassung), für die ein Vorschlag vorliegt. Ein Vorschlag entsteht, wenn:",
    "app.overview.reconciliation.tooltip.select":
        "„Markieren“ im Tab „Schnell“ markiert alle Buchungen dieser Vorschläge in der Tabelle.",
    "app.overview.reconciliation.tooltip.manual":
        "Manuell: Sind eine Zahlungsdarstellung und genau eine Rechnung markiert, wird der Button rot und verknüpft nach Rückfrage dieses Paar - ohne Betragsprüfung, da die Auswahl bewusst getroffen wurde. Voraussetzungen:",
    "app.overview.reconciliation.tooltip.split":
        "Mehrere Rechnungen: Sind zu einer Zahlungsdarstellung mehrere Rechnungen markiert, wird die Zahlungsdarstellung in eine Zeile je Rechnung aufgeteilt und die ursprüngliche Zeile gelöscht. Zusätzlich nötig:",
    "app.overview.reconciliation.split.title": "Zahlung aufteilen",
    "app.overview.reconciliation.split.body":
        "Die Zahlungsdarstellung wird in {count} Zeilen aufgeteilt - je eine pro Rechnung - und die ursprüngliche Zeile wird gelöscht.",
    "app.overview.reconciliation.tooltip.multi":
        "Mehrere Zahlungsdarstellungen: Sind zu einer Rechnung mehrere Zahlungsdarstellungen markiert, wird jede davon mit einer eigenen Zahlung mit der Rechnung verknüpft. Zusätzlich nötig:",
    "app.overview.reconciliation.tooltip.mixed":
        "Mehrere Rechnungen zusammen mit mehreren Zahlungsdarstellungen können nicht manuell verknüpft werden.",
    "app.overview.reconciliation.criteria.selectedSumEqualsOpen":
        "die Summe der markierten Zahlungsdarstellungen entspricht exakt dem offenen Betrag der Rechnung",
    "app.overview.reconciliation.criteria.sumEqualsBrutto":
        "die Summe der offenen Beträge entspricht exakt dem Betrag der Zahlungsdarstellung",
    "app.overview.reconciliation.criteria.singleItemNotJournaled":
        "die Zahlungsdarstellung hat nur eine Position und ist nicht festgeschrieben",
    "app.overview.reconciliation.criteria.unbound": "die Zahlungsdarstellung ist noch nicht verknüpft",
    "app.overview.reconciliation.criteria.matchingSource":
        "eine passende Rechnung (ER, Anzahlung, Debitoren) wird gefunden",
    "app.overview.reconciliation.criteria.sumEqualsOpen":
        "die Summe aller zugehörigen Zahlungsdarstellungen entspricht exakt dem offenen Betrag der Rechnung",
    "app.overview.reconciliation.criteria.pairSelection":
        "genau eine Rechnung (ER, Anzahlung, Debitoren) und eine Zahlungsdarstellung",
    "app.overview.reconciliation.criteria.sourceOpen": "die Rechnung hat noch einen offenen Betrag",
    "app.overview.reconciliation.tab.quick": "Schnell",
    "app.overview.reconciliation.tab.advanced": "Erweitert",
    "app.overview.reconciliation.quick.criteria": "Rechnung Nr. ↔ Belegfeld1",
    "app.overview.reconciliation.summary":
        "{payments, plural, one {# Zahlungsdarstellung} other {# Zahlungsdarstellungen}} für {invoices, plural, one {# Rechnung} other {# Rechnungen}}",
    "app.overview.reconciliation.select": "Markieren",
    "app.overview.reconciliation.connect": "Verknüpfen",
    "app.overview.reconciliation.key.label": "Zuordnen nach",
    "app.overview.reconciliation.key.belegfeld1": "Belegfeld1",
    "app.overview.reconciliation.key.belegfeld2": "Belegfeld2",
    "app.overview.reconciliation.advanced.hint":
        "Verknüpft wird, wenn genau eine offene Rechnung und die Zahlungsdarstellungen mit demselben Wert auf demselben Konto exakt den offenen Betrag ergeben.",
    "app.overview.reconciliation.skipped.title":
        "{count, plural, one {# Gruppe übersprungen} other {# Gruppen übersprungen}}",
    "app.overview.reconciliation.skipped.multipleSources": "{count} offene Rechnungen mit diesem Wert",
    "app.overview.reconciliation.skipped.noSource": "keine offene Rechnung mit diesem Wert",
    "app.overview.reconciliation.skipped.sumMismatch": "Differenz {diff} €",
    "app.overview.reconciliation.advanced.prompt":
        "{payments, plural, one {# Zahlungsdarstellung wird} other {# Zahlungsdarstellungen werden}} mit {invoices, plural, one {# Rechnung} other {# Rechnungen}} verknüpft. Zum Starten OK drücken.",
    "app.overview.reconciliation.outcome.applied": "{count, plural, one {# Rechnung} other {# Rechnungen}} verknüpft",
    "app.overview.reconciliation.outcome.changed":
        "{count, plural, one {# Rechnung hat} other {# Rechnungen haben}} sich seit der Vorschau geändert, nicht verknüpft",
    "app.overview.reconciliation.outcome.alreadyApplied":
        "{count, plural, one {# Rechnung war} other {# Rechnungen waren}} bereits verknüpft",
    "app.overview.reconciliation.outcome.failed": "{count} fehlgeschlagen: {message}",
    "app.overview.reconciliation.tooltip.advanced":
        "Erweitert: Rechnung und Zahlungsdarstellungen werden über ein gewähltes Feld (Belegfeld1, Belegfeld2, Zusatz-Info) zusammengeführt. Gruppen ohne exakten Ausgleich werden mit Grund angezeigt.",
    "app.accounting.buInsteadOfUst": "BU statt USt",
    "app.accounting.useCurrency": "Währung verwenden",
    "app.accounting.moreFields": "Weitere Felder",
    "app.accounting.datev.openInCompanyList": "In der Firmenliste öffnen",
    "app.accounting.datev.noBuchungsdatenservice": "Dieses Unternehmen hat den Buchungsdatenservice nicht aktiviert",
    "app.accounting.datev.searchByIdOrName": "Suche nach ID oder Name",
    "app.accounting.datev.filterService": "Service filtern",
    "app.accounting.datev.expired": "Abgelaufen",
    "app.accounting.datev.connectedAt": "Verbindet am",
    "app.accounting.datev.verifyWithDatev": "Überprüfen mit Datev",
    "app.accounting.datev.connectedApps": "Verbundene Anwendungen",
    "app.accounting.sinceYear": "Seit (Jahr)",
    "app.accounting.searchPlaceholder": "Suche...",
    "app.accounting.verrechnung.available": "Verfügbar",
    "app.accounting.verrechnung.connectionInfo": "Es gibt Buchungssätze, die dieser Zahlung zugeordnet werden können",
    "app.accounting.verrechnung.ignore": "Ignorieren",
    "app.accounting.verrechnung.assign": "Zuordnen",
    "app.accounting.remainingAmount": "Restbetrag",
    "app.accounting.paymentDate": "Zahlungsdatum",
    "app.accounting.records": "Buchungssätze",
    "app.accounting.noPaymentsYet": "Noch keine Zahlungen",
    "app.accounting.paymentList": "Zahlungsliste",
    "app.accounting.dueDates": "Fälligkeiten",
    "app.accounting.keyboardShortcuts": "Tastenkürzel",
    "app.accounting.toFirstField": "zum ersten Feld",
    "app.accounting.toLastField": "zum letzten Feld",
    "app.accounting.recordOrigin.badge": "KI",
    "app.accounting.recordOrigin.ai": "Vorschlag der KI",
    "app.accounting.recordOrigin.ai.hint": "Dieser Buchungsentwurf wurde automatisch aus dem Beleg erstellt.",
    "app.accounting.bruttoNettoMode": "Brutto-/Netto-Modus",
    "app.accounting.doppelerfassungWarning":
        "<b>Achtung! </b>Diese Rechnungsnummer wurde bereits verwendet. Bitte überprüfen Sie die Doppelerfassung!",
    "app.accounting.notesStatus.done": "Erledigt",
    "app.accounting.notesStatus.inProgress": "In Arbeit",
    "app.accounting.notesStatus.task": "Aufgabe",
    "app.notes.trigger": "Notizen öffnen",
    "app.notes.placeholder": "Notiz schreiben",
    "app.notes.send": "Senden",
    "app.notes.sendHint": "senden",
    "app.notes.statusNone": "Ohne",
    "app.notes.edit": "Notiz bearbeiten",
    "app.notes.delete": "Notiz löschen",
    "app.notes.deleteConfirm": "Notiz löschen?",
    "app.notes.deleteAll": "Alle löschen",
    "app.notes.deleteAllConfirm": "Alle Notizen löschen?",
    "app.notes.deleteAllConfirmDesc": "Der gesamte Verlauf wird entfernt.",
    "app.notes.emptyTitle": "Noch keine Notizen",
    "app.notes.emptyBody": "Schreiben Sie die erste Notiz.",
    "app.notes.emptyReadOnly": "Keine Notizen vorhanden.",
    "app.notes.readOnly": "Nur Lesezugriff. Notizen können nicht geändert werden.",
    "app.notes.loadError": "Notizen konnten nicht geladen werden.",
    "app.notes.retry": "Erneut versuchen",
    "app.notes.edited": "bearbeitet",
    "app.notes.imported": "Importiert",
    "app.notes.you": "Sie",
    "app.accounting.notes.unsaved": "Notizen sind erst nach dem Speichern der Buchung möglich.",
    "app.accounting.ok": "Ok",
    "app.accounting.selectContact": "Kontakt auswählen",
    "app.accounting.addContactWithName": "Kontakt mit diesem Namen im Kontakte-Modul anlegen",
    "app.accounting.copyTemplatesFromPreviousYear": "Vorlagen aus dem Vorjahr kopieren",
    "app.accounting.contactsWithoutTemplates": "Kontakte ohne Vorlagen",
    "app.accounting.festschreibenCount": "Festschreiben ({done}/{total})",
    "app.table.summe": "Summe:",
    "app.table.modulLabel": "Modul:",
    "app.table.bankingTransaction": "Banking-Transaktion",
    "app.table.bankingTransactionId": "Banking-Transaktion-ID",
    "app.table.cashRegisterReceipt": "Kassenbeleg",
    "app.table.cashRegisterReceiptId": "Kassenbeleg-ID",
    "app.table.autoRecord": "Automatische Buchung",
    "app.table.saldoTransferRecord": "Saldenvortrag",
    "app.table.expected": "erwartet",
    "app.table.actual": "tatsächlich",
    "app.table.avis.remove": "Zahlungsavis entfernen",
    "app.table.avis.change": "Zahlungsavis ändern",
    "app.table.moveToFE": "Nach FE verschieben",
    "app.table.moveToPOS": "Nach POS verschieben",
    "app.table.unsplit": "Aufteilung aufheben",
    "app.table.toPeriod0": "In Periode 0",
    "app.table.toPeriod13": "In Periode 13",
    "app.table.payment.journaledWarning":
        "Durch diese Zahlungsänderung werden einige zugehörige <strong>festgeschriebene</strong> Buchungen storniert.",
    "app.table.payment.confirmedWarning":
        "Durch diese Zahlungsänderung werden einige zugehörige <strong>bestätigte</strong> Buchungen ebenfalls aktualisiert und/oder gelöscht.",
    "app.toolbar.aiImport.importPdf": "PDF KI importieren",
    "app.toolbar.aiImport.fibuRunning": "AI FIBU läuft...",
    "app.automation.d2r.running": "Buchungsvorschläge werden erstellt ({done}/{total})",
    "app.automation.d2r.summary":
        "{created} erstellt, {withoutAccount} ohne Sachkonto, {alreadyBooked} bereits gebucht, {refused} abgelehnt, {failed} fehlgeschlagen",
    "app.automation.d2r.failed": "Der Vorgang konnte nicht abgeschlossen werden.",
    "app.automation.d2r.more": "und {count} weitere",
    "app.automation.d2r.reason.DOCUMENT_NOT_FOUND": "Dokument nicht gefunden",
    "app.automation.d2r.reason.IN_TRASH": "Dokument liegt im Papierkorb",
    "app.automation.d2r.reason.IN_NEW_DOCUMENTS": "Dokument liegt noch in den neuen Dokumenten",
    "app.automation.d2r.reason.MISSING_DOCUMENT_DATE": "Kein Belegdatum vorhanden",
    "app.automation.d2r.reason.MISSING_GROUP": "Kein Bankkonto bzw. keine Kasse gewählt",
    "app.automation.d2r.reason.YEAR_NOT_IN_ACCOUNTING_YEARS":
        "Das Belegjahr gehört zu keinem Buchungsjahr des Unternehmens",
    "app.automation.d2r.reason.PRODUCT_NOT_ALLOWED": "Für diesen Bereich ist die Buchung aus Dokumenten nicht möglich",
    "app.automation.d2r.reason.MIRROR_SYNC_FAILED": "Gebucht, die Synchronisierung ist aber fehlgeschlagen",
    "app.automation.d2r.reason.CONVERSION_FAILED": "Das Dokument konnte nicht ausgelesen werden",
    "app.automation.d2r.reason.NOT_A_RECEIPT": "Informationsdokument, kein Beleg",
    "app.automation.d2r.reason.SAVE_FAILED": "Die Buchung konnte nicht gespeichert werden",
    "app.automation.d2r.reason.PERMISSION_DENIED": "Keine Schreibrechte für diesen Bereich",
    "app.toolbar.fillBank.unifyTwo.title": "Transaktion mit Datensätzen vereinheitlichen",
    "app.toolbar.fillBank.unifyTwo.description":
        "Vereinheitlicht eine transaktion-exportierte Buchung mit einem oder mehreren manuell-erstellten Datensätzen, deren Summe der Transaktion entspricht, nach folgenden Kriterien:",
    "app.toolbar.fillBank.unifyMultiple.title": "Mehrere Datensätze vereinheitlichen",
    "app.toolbar.fillBank.unifyMultiple.description":
        "Vereinheitlicht transaktionserstellte Datensätze und manuell-erstellte Datensätze mit ausgefülltem Kontakt nach folgenden Kriterien:",
    "app.toolbar.fillBank.connectByDocs.title": "Über Dokumente verbinden",
    "app.toolbar.fillBank.connectByDocs.description":
        "Verbindet ausgewählte Bankbuchungen mit ihrer Quellrechnung (ER, ER_A, Deb) anhand gemeinsamer Dokumente nach folgenden Kriterien:",
    "app.toolbar.fillBank.connectByDocs.skipNote": "Bereits verbundene Bankbuchungen werden übersprungen.",
    "app.toolbar.fillBank.outcome.matched": "{count} zugeordnet",
    "app.toolbar.fillBank.outcome.ambiguous": "{count} nicht eindeutig, nichts geändert",
    "app.toolbar.fillBank.outcome.ambiguousZuordnung":
        "{count} nicht eindeutig, nicht verbunden; Kreditor/Debitor ggf. ergänzt",
    "app.toolbar.fillBank.outcome.noMatch": "{count} ohne Treffer",
    "app.toolbar.fillBank.outcome.alreadyLinked": "{count} bereits verbunden",
    "app.toolbar.fillBank.outcome.journaled": "{count} festgeschrieben, nicht geändert",
    "app.toolbar.fillBank.outcome.notFound": "{count} nicht gefunden",
    "app.toolbar.fillBank.classification.step1":
        "1. Kreditor oder Debitor aus Vorlagen in ER oder AR basierend auf dem <b>Kontakt</b> ausfüllen",
    "app.toolbar.fillBank.classification.step2":
        "2. Verbindet Bankbuchungen aus dem Banking-Import direkt mit dem offenen Posten (ER, ER_A, Deb) nach folgenden Kriterien:",
    "app.toolbar.fillBank.classification.step3":
        "3. Andernfalls: vereinheitlicht transaktionserstellte Datensätze und manuell-erstellte Datensätze mit ausgefülltem Kontakt nach folgenden Kriterien:",
    "app.toolbar.fillBank.criteria.sumBetrag": "Summe der Beträge = Transaktionsbetrag",
    "app.toolbar.fillBank.criteria.invoiceNumInPurpose": "Rechnungsnummer im Verwendungszweck",
    "app.toolbar.fillBank.criteria.belegfeld1": "Belegfeld1",
    "app.toolbar.fillBank.criteria.sharedDocument": "Gemeinsames Dokument",
    "app.toolbar.fillBank.criteria.openEqualsBank": "Offener Betrag = Bankbetrag",
    "app.toolbar.fillBank.criteria.creditorDebitor": "Kreditor/Debitor",
    "app.toolbar.chainEdit.title": "Ketten-Bearbeitung",
    "app.toolbar.chainEdit.description":
        "Speichert den aktuellen Datensatz mit + und lädt direkt den nächsten ausgewählten Datensatz in Tabellenreihenfolge.",
    "app.toolbar.chainEdit.completed.title": "Ketten-Bearbeitung abgeschlossen",
    "app.toolbar.chainEdit.completed.message": "Die ausgewählten Buchungen wurden vollständig bearbeitet.",
    "app.toolbar.duplicateCheck.title": "Doppelerfassung-Prüfung",
    "app.toolbar.duplicateCheck.description":
        "Filtert die Auswahl auf Datensätze mit gleicher Rechnungsnummer und gleichem Brutto-Betrag.",
    "app.toolbar.journal.title": "Journal",
    "app.toolbar.showRemovedRecords": "entfernte Buchungen anzeigen",
    "app.toolbar.paymentStatus.avis": "Avis",
    "app.toolbar.ust13b.with": "Mit § 13b",
    "app.toolbar.ust13b.without": "Ohne § 13b",
    "app.toolbar.export.csvDescription": "durch Komma getrennte Datei",
    "app.toolbar.export.pdfDescription": "druckbare PDF-Datei",
    "app.toolbar.actions": "Aktionen",
    "app.toolbar.actions.saldoDescription": "Saldo des Vorjahres nach vorne tragen",
    "app.toolbar.actions.aiReviewDescription":
        "Prüft die ausgewählten Buchungen gegen die KI-Daten des verknüpften Belegs.",
    "app.toolbar.actions.saldoTransfer": "Saldenvortrag",
    "app.toolbar.actions.saldoConfirm": "Saldo des Vorjahres ({yearFrom}) nach {yearTo} vortragen?",
    "app.ustva.shortDescription": "Kurzbeschreibung",
    "app.ustva.drilldown.kennzahl": "Kennzahl {route}",
    "app.ustva.drilldown.calculated": "Berechnete Kennzahl. Keine direkte Buchung.",
    "app.ustva.drilldown.showBookings": "Buchungen zu Kennzahl {route}, {period} anzeigen",
    "app.ustva.drilldown.composition.drill": "Kennzahl {route} aufschlüsseln",
    "app.ustva.drilldown.composition.subtracted": "wird abgezogen",
    "app.ustva.drilldown.composition.rate": "Steuersatz {rate, number, percent}",
    "app.ustva.drilldown.composition.total": "Summe",
    "app.ustva.drilldown.composition.deltaTotal": "Differenz zur Übermittlung",
    "app.ustva.drilldown.composition.rateNote":
        "Kaufmännisch gerundet auf den Periodenwert, nicht je Buchung. Eine Steuer je Buchung wird deshalb nicht ausgewiesen.",
    "app.ustva.bmgAbbr": "BMG",
    "app.ustva.stAbbr": "St.",
    "app.ustva.bemessung": "Bemessung",
    "app.ustva.steuer": "Steuer",
    "app.ustva.quartal": "{quartalNum}. Quartal {year}",
    "app.ustva.transferticket": "Transferticket",
    "app.ustva.exports.journalRest": "Festschreiben",
    "app.ustva.exports.allJournaled": "Alle Buchungen dieser Meldung sind bereits festgeschrieben",
    "app.ustva.exports.filedBy": "Übermittelt von",
    "app.ustva.exports.zahllast": "Zahllast / Erstattung",
    "app.ustva.exports.export": "Export",
    "app.ustva.exports.inDms": "In DMS gespeichert: Steuern / Umsatzsteuer",
    "app.ustva.exports.inAccounting": "In der Buchhaltung gebucht (FE)",
    "app.ustva.exportSave.title": "Protokoll speichern",
    "app.ustva.exportSave.open": "Speichern (DMS/FIBU)",
    "app.ustva.exportSave.dms": "DMS: Steuern / Umsatzsteuer",
    "app.ustva.exportSave.dmsDone": "Bereits gespeichert",
    "app.ustva.exportSave.accounting": "Buchhaltung: Freie Erfassung (Entwurf)",
    "app.ustva.exportSave.accountingDone": "Bereits gebucht",
    "app.ustva.exportSave.preview": "{soll} an {haben} · {amount} · {text} · {date} · Entwurf",
    "app.ustva.exportSave.noFeWrite": "Keine Schreibrechte für die Freie Erfassung",
    "app.ustva.exportSave.noKz83": "Keine Zahllast oder Erstattung zu buchen",
    "app.ustva.exportSave.noConfig": "Buchhaltungsjahr {year} ist nicht angelegt",
    "app.ustva.exportSave.unsupportedSkr":
        "Kontenrahmen {skr} wird nicht unterstützt; bitte den Kontenrahmen des Buchhaltungsjahres prüfen",
    "app.ustva.exportSave.noPermission": "Zum Speichern werden Schreibrechte für DMS oder die Freie Erfassung benötigt",
    "app.ustva.exportSave.pdfMissing": "Das Übertragungsprotokoll konnte nicht geladen werden",
    "app.ustva.exportSave.hashFailed":
        "Das Übertragungsprotokoll konnte nicht gelesen werden. Bitte die Seite neu laden.",
    "app.ustva.filings.title": "In Umsatzsteuer-Voranmeldungen enthalten",
    "app.ustva.filings.empty": "Diese Buchung ist in keiner übermittelten Voranmeldung enthalten.",
    "app.ustva.filings.showPdf": "PDF anzeigen",
    "app.ustva.filings.transmittedBy": "übermittelt von",
    "app.ustva.filings.columnHeader": "UStVA",
    "app.ustva.bookings.module": "Modul",
    "app.ustva.bookings.amount": "Betrag",
    "app.ustva.bookings.status": "Status",
    "app.ustva.bookings.manual": "Manuelle Korrektur",
    "app.ustva.bookings.total": "Summe",
    "app.ustva.bookings.totalFiltered": "Summe (gefiltert)",
    "app.ustva.bookings.onlyDeviations": "Nur Abweichungen ({count})",
    "app.ustva.bookings.search": "Beleg oder Konto suchen",
    "app.ustva.bookings.prevDeviation": "Vorherige Abweichung",
    "app.ustva.bookings.nextDeviation": "Nächste Abweichung",
    "app.ustva.bookings.status.added": "Neu",
    "app.ustva.bookings.status.storno": "Storno",
    "app.ustva.bookings.status.removed": "Gelöscht",
    "app.ustva.bookings.status.changed": "Geändert",
    "app.ustva.bookings.status.unchanged": "Unverändert",
    "app.ustva.reconciliation.filed": "Übermittelt",
    "app.ustva.reconciliation.difference": "Differenz",
    "app.ustva.reconciliation.today": "Wert heute",
    "app.ustva.reconciliation.complete": "Diese Ursachen erklären die Differenz vollständig.",
    "app.ustva.reconciliation.rest": "{count, plural, one {# weitere Buchung} other {# weitere Buchungen}}",
    "app.ustva.deviation.summary.scope":
        "{kzCount, plural, one {# Kennzahl} other {# Kennzahlen}} und {recordCount, plural, one {# Buchung} other {# Buchungen}} betroffen",
    "app.ustva.deviation.summary.openDeviations": "Abweichungen anzeigen",
    "app.ustva.deviation.export": "Abweichungen als PDF",
    "app.ustva.deviation.export.title": "Abweichungen zur Umsatzsteuer-Voranmeldung",
    "app.ustva.deviation.export.filtered": "Gefilterte Ansicht: diese Liste ist nicht vollständig.",
    "app.ustva.deviation.export.total": "Differenz gesamt",
    "app.ustva.deviation.export.generated": "Erstellt am",
    "app.ustva.diff.title": "Änderungen an {beleg}",
    "app.ustva.diff.identical": "Diese Buchung ist unverändert.",
    "app.ustva.deviation.warning": "Würde man heute übermitteln, ergäbe sich eine andere Meldung.",
    "app.ustva.deviation.unchanged": "Unverändert gegenüber der Übermittlung vom {date}.",
    "app.ustva.deviation.filedForQuarter": "Diese Meldung wurde für das {quartalNum}. Quartal {year} übermittelt.",
    "app.ustva.deviation.showQuarter": "Quartal anzeigen",
    "app.ustva.deviation.noBaseline":
        "Für diese Übermittlung wurde keine Kennzahlen-Aufstellung gespeichert. Ein Abgleich mit dem heutigen Stand ist nicht möglich.",
    "app.ustva.deviation.filedOn": "Übermittelt am {date} von",
    "app.ustva.deviation.filed": "übermittelt",
    "app.ustva.deviation.current": "heute",
    "app.ustva.deviation.delta": "Differenz",
    "app.ustva.deviation.cause.added": "nach der Übermittlung gebucht",
    "app.ustva.deviation.cause.storno": "Storno-Gegenbuchung nach der Übermittlung",
    "app.ustva.deviation.cause.removed": "nach der Übermittlung storniert oder gelöscht",
    "app.ustva.deviation.cause.changed": "nach der Übermittlung geändert",
    "app.ustva.deviation.cause.manual": "manuelle Korrektur bei der Übermittlung",
    "app.ustva.journalAfterExport.title": "Buchungen festschreiben",
    "app.ustva.journalAfterExport.body":
        "Die Übermittlung war erfolgreich. Sollen die {count} Buchungen, die in diese Meldung eingeflossen sind, jetzt festgeschrieben werden? Festgeschriebene Buchungen lassen sich nur noch per Storno korrigieren.",
    "app.ustva.journalAfterExport.confirm": "Festschreiben",
    "app.ustva.journalAfterExport.dismiss": "Später",
    "app.ustva.journalAfterExport.hint": "Sie können das jederzeit in der Übersicht der Übermittlungen nachholen.",
    "app.ustva.journalAfterExport.done": "Buchungen wurden festgeschrieben",
    "app.ustva.groupA": "A. Steuerpflichtige Lieferungen, sonstige Leistungen und unentgeltliche Wertabgaben",
    "app.ustva.taxableSales19": "Steuerpflichtige Umsätze 19 %",
    "app.ustva.taxableSales7": "Steuerpflichtige Umsätze 7 %",
    "app.ustva.taxableSales0": "Steuerpflichtige Umsätze 0 %",
    "app.ustva.otherTaxRates": "Andere Steuersätze",
    "app.ustva.agriculturalWithVatId": "Landwirtschaftliche Betriebe mit USt-ID",
    "app.ustva.salesPara24":
        "Umsätze, für die eine Steuer nach § 24 UStG zu entrichten ist (Sägewerkserzeugnisse, Getränke und alkoholische Flüssigkeiten, z.B. Wein)",
    "app.ustva.groupB": "B. Steuerfreie Lieferungen, sonstige Leistungen und unentgeltliche Wertabgaben",
    "app.ustva.intraCommunityDeliveriesWithVatId": "Innergemeinschaftliche Lieferungen mit USt-ID",
    "app.ustva.newVehiclesToBuyerWithoutVatId": "Neue Fahrzeuge an Abnehmer ohne USt-ID",
    "app.ustva.newVehiclesOutsideBusiness": "Neue Fahrzeuge außerhalb eine Unternehmens (§ 2a UStG)",
    "app.ustva.otherTaxFreeWithInputTax":
        "Weitere steuerfreie Umsätze mit Vorsteuerabzug (z.B. Ausfuhrlieferungen, Umsätze nach § 4 Nr. 2 bis 7 UStG)",
    "app.ustva.taxFreeWithoutInputTax":
        "Steuerfreie Umsätze ohne Vorsteuerabzug (z.B. Umsätze nach § 4 Nr. 8 bis 29 UStG)",
    "app.ustva.groupC": "C. Innergemeinschaftliche Erwerbe",
    "app.ustva.taxFreeEuAcquisitions":
        "Steuerfreie EU-Erwerbe von bestimmten Gegenständen und Anlagegold (§§ 4b und 25c UStG)",
    "app.ustva.taxableEuAcquisitions19": "Steuerpflichtige EU-Erwerbe 19 %",
    "app.ustva.taxableEuAcquisitions7": "Steuerpflichtige EU-Erwerbe 7 %",
    "app.ustva.taxableEuAcquisitions0": "Steuerpflichtige EU-Erwerbe 0 %",
    "app.ustva.newVehiclesFromSuppliersWithoutVatId":
        "Neue Fahrzeuge (§ 1b Abs. 2 und 3 UStG) von Lieferern ohne USt-ID",
    "app.ustva.groupD": "D. Leistungsempfänger als Steuerschuldner (§ 13b UStG)",
    "app.ustva.otherServicesPara3a":
        "Sonstige Leistungen nach § 3a Abs. 2 UStG eines im übrigen Gemeinschaftsgebiet ansässigen Unternehmers (§ 13b Abs. 1 UStG)",
    "app.ustva.salesUnderGrEStG": "Umsätze, die unter das GrEStG fallen (§ 13b Abs. 2 Nr. 3 UStG)",
    "app.ustva.otherServicesPara13b": "Andere Leistungen (§ 13b Abs. 2 Nr. 1, 2, 4 bis 12 UStG)",
    "app.ustva.groupE": "E. Ergänzende Angaben zu Umsätzen",
    "app.ustva.firstBuyerTriangularTransactions":
        "Lieferungen des ersten Abnehmers bei innergemeinschaftlichen Dreiecksgeschäften (§ 25b UStG)",
    "app.ustva.taxableSalesRecipientOwesTax":
        "Steuerpflichtige Umsätze des leistenden Unternehmers, für die der Leistungsempfänger die Steuer nach § 13b Abs. 5 UStG schuldet",
    "app.ustva.nonTaxableOtherServicesPara18b": "Nicht steuerbare sonstige Leistungen gem. § 18b S. 1 Nr. 2 UStG",
    "app.ustva.otherNonTaxableSales": "Übrige nicht steuerbare Umsätze (Leistungsort nicht im Inland)",
    "app.ustva.groupF": "F. Abziehbare Vorsteuerbeträge und Berichtigung des Vorsteuerabzugs",
    "app.ustva.inputTaxFromInvoices":
        "Vorsteuerbeträge aus Rechnungen von anderen Unternehmers (§ 15 Abs. 1 S. 1 Nr. 1 UStG), aus Leistungen im Sinne des § 13a Abs. 1 Nr. 6 UStG (§ 15 Abs. 1 S. 1 Nr. 5 UStG) und aus innergemeinschaftlichen Dreiecksgeschäften (§ 25b Abs. 5 UStG)",
    "app.ustva.inputTaxFromIntraCommunityAcquisition":
        "Vorsteuerbeträge aus dem innergemeinschaftlichen Erwerb von Gegenständen (§ 15 Abs. 1 S. 1 Nr. 3 UStG)",
    "app.ustva.importVat": "Entstandene Einfuhrumsatzsteuer (§ 15 Abs. 1 S. 1 Nr. 2 UStG)",
    "app.ustva.inputTaxFromPara13b":
        "Vorsteuerbeträge aus Leistungen im Sinne des § 13b UStG (§ 15 Abs. 1 S. 1 Nr. 4 UStG)",
    "app.ustva.inputTaxAverageRates":
        "Vorsteuerbeträge, die nach allgemeinen Durchschnittssätzen berechnet sind (§ 23a UStG)",
    "app.ustva.inputTaxNewVehiclesSmallBusiness":
        "Vorsteuerabzug für innergemeinschaftliche Lieferungen neuer Fahrzeuge außerhalb eines Unternehmens (§ 2a UStG) sowie von Kleinunternehmern im Sinne des § 19 Abs. 1 UStG (§ 15 Abs. 4a UStG)",
    "app.ustva.inputTaxCorrectionPara15a": "Berichtigung des Vorsteuerabzugs (§ 15a UStG)",
    "app.ustva.inputTax": "Vorsteuer",
    "app.ustva.remainingAmount": "Verbleibender Betrag",
    "app.ustva.groupG": "G. Andere Steuerbeträge",
    "app.ustva.taxFromChangeOfTaxationForm":
        "Steuer infolge des Wechsels der Besteuerungsform sowie Nachsteuer auf versteuerte Anzahlungen und ähnlichem wegen Steuersatzänderung",
    "app.ustva.incorrectlyShownTaxPara14c":
        "In Rechnungen unrichtig oder unberechtigt ausgewiesene Steuerbeträge (§ 14c UStG) sowie Steuerbeträge, die nach § 6a Abs. 4 S. 2, § 17 Abs. 1 S. 7, § 25b Abs. 2 UStG oder von einem Auslagerer oder Lagerhalter nach § 13a Abs. 1 Nr. 6 UStG geschuldet werden",
    "app.ustva.groupH": "H. Umsatzsteuer-Vorausz./Überschuss",
    "app.ustva.deductionSpecialPrepayment": "Abzug der festgesetzten Sondervorauszahlung für Dauerfristverlängerung",
    "app.ustva.remainingVatPrepayment": "Verbleibende Umsatzsteuer-Vorauszahlung /-Überschuss (negativ)",
    "app.ustva.groupI": "I. Ergänzende Angaben zu Minderungen nach § 17 Abs. 1 S. 1, 2 in V.m. Abs. 2 Nr. 1 S. 1 UStG",
    "app.ustva.reductionOfTaxBase": "Minderung der Bemessungsgrundlage",
    "app.ustva.reductionOfDeductibleInputTax": "Minderung der abziehbaren Vorsteuerbeträge",
    "app.ustva.aiCheckFailed": "KI-Prüfung fehlgeschlagen",
    "app.ustva.elsterUstvaOk": "Elster UStVA ok",
    "app.ustva.missingTaxInfo":
        "um fortzufahren, geben Sie bitte die Steuerinformationen in Ihren Unternehmenseinstellungen ein",
    "app.ustva.selectSpecificPeriod": "um fortzufahren, wählen Sie bitte einen bestimmten Zeitraum aus",
    "app.ustva.yearWithoutUstva":
        'In den Jahreseinstellungen ist für dieses Jahr "Keine UStVA" eingestellt. Es wird nur die Jahreserklärung abgegeben, daher ist der ELSTER-Versand der Voranmeldung gesperrt.',
    "app.ustva.missingElsterRole":
        "Sie haben keine Berechtigung zur Übermittlung an ELSTER. Dafür ist die Rolle „ELSTER-Übermittler“ erforderlich, die ein Administrator Ihres Unternehmens vergeben kann.",
    "app.ustva.correctedReturn": "Berichtigte Anmeldung",
    "app.ustva.documentsSubmittedSeparately": "Belege werden gesondert eingereicht",
    "app.ustva.checkReturnWithAi": "Erklärung mit KI prüfen",
    "app.ustva.aiCheckExperimentalHint": "Experimentell - prüfen Sie Plausibilität der Kennzahlen mit KI",
    "app.ustva.aiCheckReviewNotice":
        "Die KI-Prüfung ist eine unverbindliche Plausibilitätsprüfung und ersetzt nicht die fachliche Prüfung. Eine ELSTER-Übermittlung erfolgt erst nach Ihrer Prüfung und ausdrücklichen Auslösung.",
    "app.ustva.followUpQuestions": "Rückfragen:",
    "app.ustva.certificateInvalid": ".pfx Zertifikat ist defekt",
    "app.ustva.pinInvalid": "PIN ist falsch",
    "app.ustva.encrypting": "Verschlüsselung",

    "avm.nav.dashboard": "Übersicht",
    "avm.nav.assets": "Anlagegüter",
    "avm.nav.movements": "Bewegungen",
    "avm.nav.import": "Import",
    "avm.nav.restwert": "Restwertverzeichnis",
    "avm.nav.spiegel": "Anlagenspiegel",
    "avm.nav.forecast": "AfA-Vorschau",
    "avm.nav.inventory": "Inventarliste",
    "avm.nav.batches": "Buchungsstapel",
    "avm.nav.rules": "Rechenregeln",
    "avm.rules.title": "Rechenregeln des Anlagenbuchs",
    "avm.rules.search": "Regel, Begriff oder ID suchen",
    "avm.rules.statute": "Rechtsgrundlage",
    "avm.rules.statute.none": "Regel des Anlagenbuchs ohne eigene gesetzliche Vorgabe",
    "avm.rules.example": "Beispiel",
    "avm.rules.status.planned": "geplant",
    "avm.rules.status.unsupported": "nicht unterstützt",
    "avm.rules.glossary.title": "Auswahlwerte im Anlagenbuch",
    "avm.rules.noResults": "Keine Regel und kein Begriff passen zur Suche.",
    "avm.rules.graph.toggle": "Zusammenhänge",
    "avm.rules.graph.label": "Zusammenhänge der Regeln in {topic}",
    "avm.rules.graph.stub": "Regeln im Abschnitt {topic}",
    "avm.rules.graph.hint":
        "Ein Pfeil zeigt auf die Regel, auf der eine Regel aufbaut. Ein Klick auf eine Regel springt zu ihr.",
    "avm.rules.loading": "Wird geladen",
    "avm.rules.chart.toggle": "Beispiel als Diagramm",
    "avm.rules.chart.linear": "Linear",
    "avm.rules.chart.degressive": "Degressiv",
    "avm.rules.chart.bookValue": "Buchwert zum Ende des Wirtschaftsjahres, berechnet vom Anlagenbuch",
    "avm.rules.chart.afa": "AfA je Wirtschaftsjahr, berechnet vom Anlagenbuch",
    "avm.rules.chart.afaSeries": "AfA",

    "avm.dashboard.title": "Übersicht",
    "avm.dashboard.kpi.bookValueEnd": "Buchwert Ende",
    "avm.dashboard.kpi.bookValueStart": "Buchwert Anfang",
    "avm.dashboard.kpi.afa": "AfA {year}",
    "avm.dashboard.kpi.gwgShare": "davon GWG {value}",
    "avm.dashboard.kpi.additions": "Zugänge",
    "avm.dashboard.kpi.disposals": "Abgänge",
    "avm.dashboard.kpi.cost": "Anschaffungskosten",
    "avm.dashboard.kpi.count": "{count} Anlagen",
    "avm.dashboard.lastAdditions": "Letzte Zugänge",
    "avm.dashboard.todo.title": "Zu erledigen",
    "avm.dashboard.todo.usefulLifeEndsNextYear": "{count} Anlagen sind {year} vollständig abgeschrieben",
    "avm.dashboard.todo.iabDeadlineDue": "Investitionsabzugsbetrag aus {year} muss dieses Jahr zugeordnet werden",
    "avm.dashboard.todo.iabDeadlineReached": "Investitionsabzugsbetrag aus {year} ist überfällig und aufzulösen",
    "avm.dashboard.todo.batchReady": "Ein Buchungsstapel für {year} wartet auf die Übergabe",
    "avm.dashboard.todo.yearNotClosed": "{year} ist übergeben, aber noch nicht abgeschlossen",
    "avm.dashboard.todo.poolPolicyWithoutGroup":
        "Die Sammelposten-Regel ist aktiv, es gibt aber keine Sammelposten-Gruppe",
    "avm.dashboard.todo.poolAssetWrongGroup":
        "{count} Sammelposten-Wirtschaftsgüter liegen nicht in der Sammelposten-Gruppe",
    "avm.dashboard.todo.snapshotDrift": "Abweichung zum Jahresabschluss {year}",
    "avm.dashboard.todo.none": "Nichts zu tun",

    "avm.iab.title": "Investitionsabzugsbeträge",
    "avm.iab.lead":
        "Nach Paragraf 7g Abs. 1 EStG bis zu 50 Prozent der voraussichtlichen Anschaffungskosten vorab abziehen. Der Betrag muss bis zum Ende des dritten Folgejahres einer Anschaffung zugeordnet werden, sonst ist der Abzug rückgängig zu machen.",
    "avm.iab.add": "Investitionsabzugsbetrag erfassen",
    "avm.iab.col.formationYear": "Bildungsjahr",
    "avm.iab.col.deadlineYear": "Frist",
    "avm.iab.col.amount": "Betrag",
    "avm.iab.col.asset": "Zugeordnet",
    "avm.iab.col.status": "Status",
    "avm.iab.status.assigned": "zugeordnet",
    "avm.iab.status.open": "offen",
    "avm.iab.status.dueThisYear": "Frist läuft {year} ab",
    "avm.iab.status.overdue": "Frist überschritten",
    "avm.iab.noFiscalYear":
        "Ohne berechenbare Wirtschaftsjahre lassen sich keine Investitionsabzugsbeträge führen. Der Grund steht oben auf dieser Seite.",
    "avm.iab.empty": "Keine Investitionsabzugsbeträge erfasst",
    "avm.iab.form.formationYear": "Bildungsjahr",
    "avm.iab.form.amount": "Betrag",
    "avm.iab.form.asset": "Anlagegut",
    "avm.iab.form.assetNone": "Nicht zugeordnet",
    "avm.iab.form.note": "Notiz",
    "avm.iab.form.ceiling": "höchstens {amount}, das sind 50 Prozent der Anschaffungskosten",
    "avm.iab.error.amount": "Betrag muss größer als 0 sein",
    "avm.iab.error.ceiling": "Der Investitionsabzugsbetrag darf 50 Prozent der Anschaffungskosten nicht übersteigen",
    "avm.iab.error.assigned": "Dieser Investitionsabzugsbetrag ist inzwischen einem anderen Anlagegut zugeordnet",
    "avm.iab.error.yearLocked":
        "Das Wirtschaftsjahr {year} ist abgeschlossen. Die Zuordnung kann erst nach dem Wiedereröffnen geändert werden.",
    "avm.iab.error.yearLockedBefore":
        "Das Wirtschaftsjahr {year} liegt vor dem abgeschlossenen Wirtschaftsjahr {latest}. Die Zuordnung kann erst geändert werden, wenn das Wirtschaftsjahr {latest} wieder geöffnet ist.",
    "avm.iab.delete": "Investitionsabzugsbetrag löschen",

    "avm.settings.fiscalYears.title": "Beginn des Wirtschaftsjahres",
    "avm.settings.fiscalYears.lead":
        "Das Anlagenbuch rechnet im Kalenderjahr, solange kein Beginn eingetragen ist. Der Beginn gilt für jedes Jahr; ein späterer Wechsel wird als Änderung ab einem Jahr eingetragen.",
    "avm.settings.fiscalYears.add": "Änderung hinzufügen",
    "avm.settings.fiscalYears.year": "Ab Jahr",
    "avm.settings.fiscalYears.calendarYear": "{month} (Kalenderjahr)",
    "avm.settings.fiscalYears.change": "ab {year}: {month}",
    "avm.settings.fiscalYears.month": "Monat",
    "avm.settings.fiscalYears.accountingDiffers":
        "Die Buchhaltung beginnt das Wirtschaftsjahr im {accountingMonth}, das Anlagenbuch im {avmMonth}.",
    "avm.settings.fiscalYears.takeOver": "Beginn aus der Buchhaltung übernehmen",
    "avm.settings.fiscalYears.base": "Das Wirtschaftsjahr beginnt im: {month}",
    "avm.settings.fiscalYears.baseMonth": "Beginn des Wirtschaftsjahres",
    "avm.settings.fiscalYears.baseSave": "Beginn speichern",
    "avm.settings.fiscalYears.baseDelete": "Beginn löschen",
    "avm.settings.fiscalYears.baseDelete.confirm":
        "Den Beginn des Wirtschaftsjahres löschen? Danach gilt das Kalenderjahr.",
    "avm.settings.fiscalYears.closed": "Abgeschlossen",
    "avm.settings.fiscalYears.delete": "Änderung löschen",
    "avm.settings.fiscalYears.delete.confirm": "Die Änderung ab {year} aus dem Anlagenbuch löschen?",

    "avm.settings.title": "Einstellungen Anlagenbuch",
    "avm.settings.gwgPolicy": "GWG-Regelung",
    "avm.settings.gwgPolicy.immediate": "Sofortabschreibung",
    "avm.settings.gwgPolicy.pool": "Sammelposten",
    "avm.settings.roundingMode": "Rundung neuer Anlagegüter (Vorbelegung)",
    "avm.settings.roundingMode.floorEuro": "Auf volle Euro abrunden",
    "avm.settings.roundingMode.hint":
        "Wird im Assistenten und beim Import für neue Anlagegüter vorbelegt. Bestehende Anlagegüter behalten ihre Rundung; sie wird im Anlagegut geändert.",
    "avm.settings.roundingMode.cent": "Centgenau",
    "avm.settings.memoValue": "Restbuchwert neuer Anlagegüter (Vorbelegung)",
    "avm.settings.memoValue.hint":
        "Wird im Assistenten und beim Import für neue Anlagegüter vorbelegt. Bestehende Anlagegüter behalten ihren Wert; er wird im Anlagegut geändert.",
    "avm.settings.vatDefault": "Standard-Umsatzsteuerbehandlung",
    "avm.settings.vatDefault.net": "Netto",
    "avm.settings.vatDefault.gross": "Brutto",
    "avm.settings.vatDefault.partial": "Teilweise vorsteuerabzugsberechtigt",
    "avm.settings.vatDefault.kust": "Kleinunternehmer (§19 UStG)",
    "avm.settings.usedByEnabled": "Nutzer/Standort erfassen",
    "avm.settings.save": "Speichern",
    "avm.settings.roles.title": "Rollen",
    "avm.settings.roles.description": "Legt fest, wer Buchungen im Anlagenbuch freigeben darf.",
    "avm.settings.taxParameters.title": "Steuerliche Parameter",
    "avm.settings.taxParameters.hint":
        "Die angezeigten Werte gelten seit dem genannten Datum. Eine Änderung der Rechtslage wird durch eine neue Zeile mit eigenem Gültigkeitsdatum abgebildet, nicht durch eine Anpassung dieser Zeile.",
    "avm.settings.taxParameters.validFrom": "Gültig ab",
    "avm.settings.taxParameters.immediateExpenseLimit": "Grenze Sofortabschreibung",
    "avm.settings.taxParameters.gwgLimit": "GWG-Grenze",
    "avm.settings.taxParameters.poolMin": "Sammelposten Untergrenze",
    "avm.settings.taxParameters.poolMax": "Sammelposten Obergrenze",
    "avm.settings.taxParameters.poolYears": "Sammelposten Abschreibungsjahre",
    "avm.settings.taxParameters.specialRate": "Sonderabschreibungssatz",
    "avm.settings.taxParameters.specialYears": "Sonderabschreibungszeitraum",
    "avm.settings.taxParameters.iabDeadline": "IAB-Frist",

    "avm.settings.anonymize.title": "Nutzer anonymisieren",
    "avm.settings.anonymize.lead":
        "Ersetzt den Namen in Genutzt von bei allen betroffenen Anlagegütern durch anonymisiert. Der Vorgang ist endgültig und wird im Änderungsprotokoll festgehalten.",
    "avm.settings.anonymize.person": "Genutzt von",
    "avm.settings.anonymize.action": "Anonymisieren",
    "avm.settings.anonymize.confirm":
        "{count, plural, one {1 Anlagegut wird dauerhaft anonymisiert} other {# Anlagegüter werden dauerhaft anonymisiert}}. Der Vorgang kann nicht rückgängig gemacht werden. Fortfahren?",
    "avm.settings.anonymize.done":
        "{count, plural, one {1 Anlagegut wurde anonymisiert} other {# Anlagegüter wurden anonymisiert}}",
    "avm.settings.anonymize.empty": "Keine Namen hinterlegt",
    "avm.settings.anonymize.approverOnly": "Nur die Rolle AVM-Freigabe darf anonymisieren.",

    "avm.groups.title": "Anlagengruppen",
    "avm.groups.new": "Neue Gruppe",
    "avm.groups.seed": "Standardgruppen anlegen",
    "avm.groups.seed.confirm":
        "Die Standardgruppen anlegen? Bestehende Anlagengruppen bleiben unverändert. Buchungskonten entstehen erst bei der Übergabe an die Buchhaltung.",
    "avm.groups.seed.skipped": "Nicht angelegt, der Name ist schon vergeben: {names}",
    "avm.groups.name": "Bezeichnung",
    "avm.groups.assetKonto": "Anlagenkonto",
    "avm.groups.afaKonto": "AfA-Konto",
    "avm.groups.specialAfaKonto": "Sonderabschreibungskonto",
    "avm.groups.specialAfaKonto.hint":
        "Ohne Sonderabschreibungskonto kann eine Sonderabschreibung dieser Gruppe nicht in die Buchhaltung übergeben werden.",
    "avm.groups.writeDownKonto": "Konto für Teilwertabschreibung",
    "avm.groups.writeDownKonto.hint":
        "Ohne dieses Konto lässt sich eine Teilwertabschreibung in dieser Anlagengruppe nicht übergeben.",
    "avm.groups.afaaKonto": "AfaA-Konto",
    "avm.groups.afaaKonto.hint":
        "Konto für die Absetzung für außergewöhnliche Abnutzung. Ohne dieses Konto lässt sich eine AfaA in dieser Anlagengruppe nicht übergeben.",
    "avm.groups.writeUpKonto": "Zuschreibungskonto",
    "avm.groups.writeUpKonto.hint": "Ohne Zuschreibungskonto ist in dieser Anlagengruppe keine Zuschreibung möglich.",
    "avm.groupAccounts.title": "Buchungskonten",
    "avm.groupAccounts.hint":
        "Die Buchungskonten braucht nur die Übergabe an die Buchhaltung. Jedes Konto ist optional; eine Buchungszeile ohne ihr Konto wird nicht übergeben.",
    "avm.groupAccounts.skr": "Kontenrahmen",
    "avm.groupAccounts.skr.hint":
        "Die Buchungskonten dieser Anlagengruppe gehören zu diesem Kontenrahmen; er muss zu dem der Buchhaltung passen.",
    "avm.groupAccounts.skr.clears": "Beim Wechsel des Kontenrahmens werden die Konten dieser Gruppe geleert.",
    "avm.groupAccounts.save": "Buchungskonten speichern",
    "avm.groupAccounts.drawer.title": "Buchungskonten: {name}",
    "avm.groups.kind": "Art",
    "avm.groups.kind.movable": "Bewegliche Wirtschaftsgüter",
    "avm.groups.kind.intangible": "Immaterielle Wirtschaftsgüter",
    "avm.groups.kind.nonDepreciable": "Nicht abnutzbare Wirtschaftsgüter",
    "avm.groups.kind.building": "Gebäude",
    "avm.groups.kind.immovable": "Unbewegliches Anlagegut (Außenanlagen)",
    "avm.groups.kind.pool": "Sammelposten",
    "avm.groups.role": "Rolle",
    "avm.groups.role.none": "keine",
    "avm.groups.role.goodwill": "Geschäfts- oder Firmenwert",
    "avm.groups.role.land": "Grund und Boden eines bebauten Grundstücks",
    "avm.groups.role.hint":
        "Die Rolle trägt Regeln: auf den Geschäfts- oder Firmenwert gibt es keine Zuschreibung, und beim Aufteilen eines Kaufs geht der Anteil Grund und Boden in die Gruppe mit dieser Rolle.",
    "avm.groups.role.seeded": "Eine Standardgruppe behält ihre Rolle, auch wenn sie umbenannt wird.",
    "avm.groups.role.kind":
        "Diese Rolle passt nicht zur Art: Geschäfts- oder Firmenwert nur bei immateriellen, Grund und Boden nur bei nicht abnutzbaren Wirtschaftsgütern.",
    "avm.groups.kind.hint":
        "Die Art legt fest, welche Abschreibungsmethoden zulässig sind und ob eine Sonderabschreibung nach § 7g EStG möglich ist.",
    "avm.groups.kind.locked":
        "Der Anlagengruppe sind Anlagegüter zugeordnet. Die Art kann erst geändert werden, wenn diese Anlagegüter einer anderen Anlagengruppe zugeordnet oder ihre Umbuchungen in diese Anlagengruppe storniert sind.",
    "avm.groups.disposalGainKonto": "Konto für Abgangsgewinn",
    "avm.groups.disposalLossKonto": "Konto für Abgangsverlust",
    "avm.assets.method.kindNotAllowed": "In dieser Anlagengruppe nicht zulässig",
    "avm.assets.method.notInBand": "Für diese Anschaffungskosten nicht zulässig",
    "avm.assets.method.error.kind":
        "Diese Methode ist in der gewählten Anlagengruppe nicht zulässig. Bitte eine zulässige Methode oder eine andere Anlagengruppe wählen.",
    "avm.wizard.error.methodKind":
        "Diese Methode ist in der gewählten Anlagengruppe nicht zulässig. Bitte eine zulässige Methode oder eine andere Anlagengruppe wählen.",
    "avm.wizard.error.specialKind":
        "Sonderabschreibung nach § 7g EStG ist nur für bewegliche Wirtschaftsgüter möglich. Bitte die Sonderabschreibung abwählen oder eine Anlagengruppe für bewegliche Wirtschaftsgüter wählen.",
    "avm.wizard.special.kindUnavailable":
        "Die gewählte Anlagengruppe ist nicht für bewegliche Wirtschaftsgüter angelegt; eine Sonderabschreibung nach § 7g EStG ist nicht möglich.",
    "avm.movements.error.specialKind":
        "Sonderabschreibung nach § 7g EStG ist nur für bewegliche Wirtschaftsgüter möglich, und das Anlagegut gehört zu einer Anlagengruppe einer anderen Art. Bitte das Anlagegut einer Anlagengruppe für bewegliche Wirtschaftsgüter zuordnen oder eine andere Bewegungsart wählen.",
    "avm.movements.error.specialKindTransferred":
        "Sonderabschreibung nach § 7g EStG ist nur für bewegliche Wirtschaftsgüter möglich, und das Anlagegut wurde in eine Anlagengruppe einer anderen Art umgebucht. Bitte zuerst die Umbuchung stornieren oder eine andere Bewegungsart wählen.",
    "avm.movements.form.targetGroup.kindNotAllowed": "Nicht zulässig für die Abschreibungsmethode dieses Anlageguts",
    "avm.movements.form.targetGroup.specialNotAllowed":
        "Nicht zulässig: für das Anlagegut ist eine Sonderabschreibung nach § 7g EStG gebucht",
    "avm.assets.method.none": "Keine AfA",
    "avm.wizard.method.none": "Keine AfA (nicht abnutzbar)",
    "avm.wizard.method.noneDesc":
        "für Grund und Boden, Anlagen im Bau, Anzahlungen und Finanzanlagen: der Buchwert bleibt bis zu Abgang, Wertminderung oder Umbuchung unverändert",
    "avm.inventory.status.nonDepreciable": "Nicht abnutzbar",
    "avm.movements.error.specialNone":
        "Sonderabschreibung nach § 7g EStG ist für ein nicht abnutzbares Wirtschaftsgut nicht möglich. Eine Wertminderung bitte als außerplanmäßige Abschreibung buchen.",
    "avm.movements.error.noneBlocked":
        "Diese Bewegungsart ist für ein nicht abnutzbares Wirtschaftsgut nicht möglich. Bitte eine andere Bewegungsart wählen.",
    "avm.movements.form.targetGroup.completed":
        "Nicht zulässig: das Anlagegut wurde fertiggestellt und wird abgeschrieben",
    "avm.movements.form.targetGroup.iabNotAllowed":
        "Nicht zulässig: dem Anlagegut ist ein Investitionsabzugsbetrag zugeordnet",
    "avm.movements.error.completionLife":
        "Mit dieser Umbuchung beginnt die AfA. Bitte die Nutzungsdauer in Monaten angeben, mindestens 1.",
    "avm.movements.form.completionLife": "Nutzungsdauer ab Fertigstellung (Monate)",
    "avm.movements.form.completionLifeHint": "Das Datum der Umbuchung ist der Beginn der AfA.",
    "avm.wizard.error.iabKind":
        "Ein Investitionsabzugsbetrag nach § 7g EStG ist nur für bewegliche Wirtschaftsgüter möglich. Bitte die Auswahl aufheben oder eine Anlagengruppe für bewegliche Wirtschaftsgüter wählen.",
    "avm.wizard.iab.kindUnavailable":
        "Die gewählte Anlagengruppe ist nicht für bewegliche Wirtschaftsgüter angelegt; ein Investitionsabzugsbetrag nach § 7g EStG kann nicht zugeordnet werden.",
    "avm.wizard.preview.noneMethod":
        "Keine AfA: der Buchwert bleibt bis zu Abgang, Wertminderung oder Umbuchung unverändert.",
    "avm.import.row.error.noneBookValue":
        "Nicht abnutzbares Wirtschaftsgut mit einem Buchwert unter den Anschaffungskosten. Bitte die Zeile mit dem Buchwert gleich den Anschaffungskosten importieren und die Wertminderung danach als außerplanmäßige Abschreibung buchen.",
    "avm.iab.form.assetKindNotAllowed":
        "Nicht zulässig: das Anlagegut gehört oder gehörte zu einer Anlagengruppe ohne Investitionsabzugsbetrag nach § 7g EStG",
    "avm.groups.defaultUsefulLife": "Standard-Nutzungsdauer",
    "avm.groups.sortOrder": "Reihenfolge",
    "avm.groups.empty": "Keine Anlagengruppen vorhanden",
    "avm.groups.delete.confirm": "Anlagengruppe wirklich löschen?",

    "avm.assets.title": "Anlagegüter",
    "avm.assets.new": "Neues Anlagegut",
    "avm.assets.search": "Suchen",
    "avm.assets.group": "Anlagengruppe",
    "avm.assets.allGroups": "Alle Gruppen",
    "avm.assets.inventoryNum": "Inventarnummer",
    "avm.assets.name": "Bezeichnung",
    "avm.assets.supplier": "Lieferant",
    "avm.assets.acquisitionDate": "Anschaffungsdatum",
    "avm.assets.acquisitionDate.error.tooEarly":
        "Anlagegüter mit Anschaffung vor dem 01.01.2018 werden nicht unterstützt.",
    "avm.assets.cost": "Anschaffungskosten",
    "avm.assets.bookValueStart": "Buchwert Beginn",
    "avm.assets.additions": "Zugänge",
    "avm.assets.disposals": "Abgänge",
    "avm.assets.afa": "AfA",
    "avm.assets.bookValueEnd": "Buchwert Ende",
    "avm.assets.quantity": "Menge",
    "avm.assets.method": "Abschreibungsmethode",
    "avm.assets.method.linear": "Linear",
    "avm.assets.method.gwg": "GWG",
    "avm.assets.method.pool": "Sammelposten",
    "avm.assets.method.degressive": "Degressiv",
    "avm.assets.method.degressiveUnavailable":
        "Nicht verfügbar: Das Anschaffungsdatum liegt außerhalb des gesetzlichen Zeitfensters für degressive AfA.",
    "avm.assets.usefulLife": "Nutzungsdauer",
    "avm.assets.location": "Standort",
    "avm.assets.costCenter": "Kostenstelle",
    "avm.assets.usedBy": "Genutzt von",
    "avm.assets.note": "Notiz",
    "avm.assets.vatTreatment": "Umsatzsteuerbehandlung",
    "avm.assets.opening": "Eröffnungsbestand",
    "avm.assets.openingYear": "Eröffnungsjahr",
    "avm.assets.openingBookValue": "Eröffnungsbuchwert",
    "avm.assets.openingRemainingMonths": "Restlaufzeit in Monaten",
    "avm.assets.total": "Summe",
    "avm.assets.groupSum": "Gruppensumme",
    "avm.assets.empty": "Keine Anlagegüter vorhanden",
    "avm.assets.tag.gwg": "GWG",
    "avm.assets.tag.memo": "Erinnerungswert",
    "avm.assets.tag.addition": "Zugang",
    "avm.assets.tag.disposal": "Abgang",
    "avm.assets.delete.confirm": "Anlagegut wirklich löschen?",

    "avm.movements.title": "Bewegungen",
    "avm.movements.eyebrow": "Nachträgliche Veränderungen",
    "avm.movements.lead":
        "Jede Veränderung am Anlagegut wird als datierte Bewegung erfasst und wirkt auf AfA, Buchwert und Auswertungen. Der Bestand wird nie überschrieben, die Historie bleibt nachvollziehbar.",
    "avm.movements.yearTable": "Bewegungen im Wirtschaftsjahr {year}",
    "avm.movements.add": "Bewegung erfassen",
    "avm.movements.noAssets":
        "Für dieses Unternehmen ist noch kein Anlagegut erfasst. Eine Bewegung ist immer die Änderung an einem bestehenden Anlagegut, deshalb lässt sie sich erst nach der ersten Erfassung anlegen.",
    "avm.movements.noAssets.action": "Anlagegut erfassen",
    "avm.movements.empty": "Keine Bewegungen im Wirtschaftsjahr {year}",
    "avm.movements.closedYear":
        "Das Wirtschaftsjahr {year} ist abgeschlossen. Bewegungen sind erst nach dem Wiedereröffnen möglich.",
    "avm.movements.col.asset": "Anlagegut",
    "avm.movements.col.type": "Art",
    "avm.movements.col.amount": "Betrag",
    "avm.movements.col.effect": "Wirkung auf den Buchwert",
    "avm.movements.type.zugang": "Zugang",
    "avm.movements.type.disposal": "Abgang",
    "avm.movements.type.partialDisposal": "Teilabgang",
    "avm.movements.type.costAddition": "Nachträgliche AK/HK",
    "avm.movements.type.transfer": "Umbuchung",
    "avm.movements.type.writeDown": "Außerplanmäßige Abschreibung",
    "avm.movements.type.writeUp": "Zuschreibung",
    "avm.movements.type.specialDepreciation": "Sonderabschreibung",
    "avm.movements.type.storno": "Storno",
    "avm.movements.desc.disposal":
        "Verkauf, Entnahme oder Verschrottung. Die AfA wird zeitanteilig bis zum Abgangsmonat berechnet, der Restbuchwert ausgebucht und der Buchgewinn oder Buchverlust ermittelt.",
    "avm.movements.desc.partialDisposal":
        "Ein Teil einer Sammelanlage geht ab. AK und kumulierte AfA werden anteilig ausgebucht, das Anlagegut bleibt mit dem Rest bestehen.",
    "avm.movements.desc.costAddition":
        "Erweiterung oder Verbesserung nach der Anschaffung. Erhöht die Bemessungsgrundlage ab dem Jahr der Aufwendung, die Restnutzungsdauer kann angepasst werden.",
    "avm.movements.desc.transfer": "Wechsel der Anlagengruppe. Die Werte bleiben erhalten, der Ausweis ändert sich.",
    "avm.movements.desc.writeDown":
        "Dauerhafte Wertminderung nach Paragraf 253 Abs. 3 HGB. Mindert den Buchwert zusätzlich zur planmäßigen AfA, höchstens bis auf den Erinnerungswert; die Restnutzungsdauer kann angepasst werden.",
    "avm.movements.desc.writeUp":
        "Wertaufholung nach einer früheren außerplanmäßigen Abschreibung. Höchstens bis zu dem Buchwert, den das Anlagegut ohne die Abschreibung hätte.",
    "avm.movements.desc.specialDepreciation":
        "Sonderabschreibung nach Paragraf 7g Abs. 5 EStG. Im Jahr der Anschaffung und in den vier folgenden Jahren, insgesamt höchstens {rate} Prozent der Bemessungsgrundlage.",
    "avm.movements.desc.specialDepreciationAny":
        "Sonderabschreibung nach Paragraf 7g Abs. 5 EStG. Im Jahr der Anschaffung und in den vier folgenden Jahren, insgesamt höchstens der für das Anschaffungsjahr geltende Prozentsatz der Bemessungsgrundlage.",
    "avm.movements.effect.zugang": "Aktivierung mit AK/HK",
    "avm.movements.effect.disposal":
        "AfA bis zum Abgangsmonat {afa}, Restbuchwert {bookValue} ausgebucht, Erlös {proceeds}: {gainLoss}",
    "avm.movements.effect.gain": "Buchgewinn {amount}",
    "avm.movements.effect.loss": "Buchverlust {amount}",
    "avm.movements.effect.partialDisposal":
        "{leaving} von {before} Stück gehen ab, AK {cost} anteilig ausgebucht, {after} Stück bleiben",
    "avm.movements.effect.costAddition":
        "Bemessungsgrundlage von {before} auf {after}, AfA {year} {afa}, Buchwert Ende {bookValue}",
    "avm.movements.effect.transfer": "Wechsel von Gruppe {from} nach {to}, Buchwert {bookValue} unverändert",
    "avm.movements.effect.writeDown": "Buchwert ohne die Abschreibung {before}, mit ihr {after}, angesetzt {applied}",
    "avm.movements.effect.writeUp":
        "Zuschreibung {applied} von {requested}, Obergrenze {ceiling}, Buchwert Ende {bookValue}",
    "avm.movements.effect.specialDepreciation":
        "Sonder-AfA {applied}, verbleibender Höchstbetrag {cap}, Buchwert Ende {bookValue}",
    "avm.movements.effect.notApplied": "wirkt sich nicht aus",
    "avm.movements.effect.cancelled": "storniert",
    "avm.movements.effect.storno": "hebt die Bewegung vom {date} auf",
    "avm.movements.effect.none": "Keine Wirkung im gewählten Wirtschaftsjahr",
    "avm.movements.effect.kontoMissing":
        "Die Anlagengruppe dieses Anlageguts hat keine Konten für Buchgewinn und Buchverlust. Der Abgang erzeugt später eine Buchungszeile ohne Konto; tragen Sie die Konten in den Buchungskonten der Anlagengruppe ein.",
    "avm.movements.form.asset": "Anlagegut",
    "avm.movements.form.type": "Art der Bewegung",
    "avm.movements.form.amount": "Betrag",
    "avm.movements.form.maxAmount": "höchstens {amount}",
    "avm.movements.form.remainingMonthsRequired":
        "Restnutzungsdauer erforderlich, sonst wird der Betrag sofort voll abgeschrieben",
    "avm.movements.form.noTargetGroup":
        "Nicht möglich: es gibt keine andere Anlagengruppe, in die umgebucht werden könnte.",
    "avm.movements.form.proceeds": "Erlös",
    "avm.movements.form.quantity": "Stückzahl",
    "avm.movements.form.quantityHint": "anteilige Ausbuchung von AK und kumulierter AfA",
    "avm.movements.form.targetGroup": "Zielgruppe",
    "avm.movements.form.remainingMonths": "Neue Restnutzungsdauer (Monate)",
    "avm.movements.form.remainingMonthsHint": "leer lassen, um die bisherige Restnutzungsdauer zu behalten",
    "avm.movements.form.note": "Notiz",
    "avm.movements.form.effectTitle": "Wirkung",
    "avm.movements.form.writeDownKind": "Art der außerplanmäßigen Abschreibung",
    "avm.movements.form.writeDownKind.teilwert": "Teilwertabschreibung",
    "avm.movements.form.writeDownKind.teilwertHint": "nur bei Bilanzierung (Betriebsvermögensvergleich)",
    "avm.movements.form.writeDownKind.afaa": "AfaA (Absetzung für außergewöhnliche Abnutzung)",
    "avm.movements.form.writeDownKind.afaaNone":
        "Nicht möglich, solange das Anlagegut nicht abgeschrieben wird (§ 7 Abs. 1 Satz 7 EStG); bitte als Teilwertabschreibung erfassen.",
    "avm.movements.error.date": "Datum erforderlich",
    "avm.movements.error.amount": "Betrag erforderlich",
    "avm.movements.error.quantity": "Stückzahl zwischen 1 und dem Bestand erforderlich",
    "avm.movements.error.targetGroup": "Zielgruppe erforderlich",
    "avm.movements.error.writeUpCeiling": "Zuschreibung höchstens {amount}",
    "avm.movements.error.specialCap": "Sonderabschreibung höchstens {amount}",
    "avm.movements.error.specialWindow":
        "Sonderabschreibung nur im Jahr der Anschaffung und in den vier folgenden Jahren",
    "avm.movements.error.writeDownAmount": "Außerplanmäßige Abschreibung höchstens {amount}",
    "avm.movements.error.writeDownKind": "Bitte Teilwertabschreibung oder AfaA wählen.",
    "avm.movements.error.taxParametersMissing":
        "Kein Höchstbetrag ermittelbar: Es sind keine Steuerparameter hinterlegt. Bitte den Support kontaktieren.",
    "avm.movements.error.periodMissing": "Für dieses Datum ist kein Wirtschaftsjahr hinterlegt",
    "avm.movements.error.yearLocked":
        "Das Wirtschaftsjahr {year} ist abgeschlossen. Die Bewegung kann erst nach dem Wiedereröffnen erfasst werden.",
    "avm.movements.error.yearLockedBefore":
        "Das Wirtschaftsjahr {year} liegt vor dem abgeschlossenen Wirtschaftsjahr {latest}. Die Bewegung kann erst erfasst werden, wenn das Wirtschaftsjahr {latest} wieder geöffnet ist.",
    "avm.movements.error.specialMethod":
        "Sonderabschreibung ist nur bei linearer Abschreibung möglich (§ 7a Abs. 4 EStG). Bitte die Anlage auf lineare Abschreibung umstellen oder eine andere Bewegungsart wählen.",
    "avm.movements.error.poolSpecial":
        "Sonderabschreibung ist bei einem Sammelposten nicht möglich: ein Sammelposten wird als Gruppe abgeschrieben, nicht als einzelnes Wirtschaftsgut. Bitte eine andere Bewegungsart wählen.",
    "avm.movements.error.poolWriteDown":
        "Außerplanmäßige Abschreibung ist bei einem Sammelposten nicht möglich: ein Sammelposten wird als Gruppe abgeschrieben, nicht als einzelnes Wirtschaftsgut. Bitte eine andere Bewegungsart wählen.",
    "avm.movements.error.poolWriteUp":
        "Zuschreibung ist bei einem Sammelposten nicht möglich: ein Sammelposten wird als Gruppe abgeschrieben, nicht als einzelnes Wirtschaftsgut. Bitte eine andere Bewegungsart wählen.",
    "avm.movements.error.poolCostAddition":
        "Nachträgliche Anschaffungskosten sind bei einem Sammelposten nicht möglich: ein Sammelposten wird als Gruppe abgeschrieben, nicht als einzelnes Wirtschaftsgut. Bitte eine andere Bewegungsart wählen.",
    "avm.movements.error.writeUpFirmenwert":
        "Eine Zuschreibung auf den Geschäfts- oder Firmenwert ist nach § 253 Abs. 5 Satz 2 HGB unzulässig. Die Wertaufholung wird nicht gebucht.",
    "avm.movements.error.writeUpUnknownGroup":
        "Die Anlagengruppe, in der das Anlagegut an diesem Datum steht, wurde nicht gefunden. Bitte die Seite neu laden.",
    "avm.movements.storno.title": "Bewegung stornieren",
    "avm.movements.storno.date": "Stornodatum",
    "avm.movements.storno.text":
        "Die Bewegung wird durch eine Storno-Bewegung aufgehoben. Beide bleiben sichtbar, keine hat eine Wirkung.",

    "avm.detail.plan": "Abschreibungsplan",
    "avm.detail.plan.year": "Jahr",
    "avm.detail.plan.months": "Monate",
    "avm.detail.plan.status.closed": "Abgeschlossen",
    "avm.detail.plan.status.current": "Laufend",
    "avm.detail.plan.status.plan": "Geplant",
    "avm.detail.plan.cumulativeAfaEnd": "Kumulierte AfA Ende",
    "avm.detail.plan.status": "Status",
    "avm.detail.plan.empty": "Kein Abschreibungsplan vorhanden",
    "avm.detail.chart": "Verlauf",
    "avm.detail.stammdaten": "Stammdaten",
    "avm.detail.edit": "Bearbeiten",
    "avm.detail.delete": "Löschen",
    "avm.detail.bookValue": "Buchwert",
    "avm.detail.bookValue.noRowForYear": "Für dieses Jahr nicht erfasst",
    "avm.detail.kontierung": "Kontierung",
    "avm.detail.kontierung.missing":
        "Für diese Anlagengruppe fehlt ein Konto. Der Buchungsstapel kann diese Zeile nicht buchen.",
    "avm.assetDetail.iabReduction": "Investitionsabzugsbetrag {amount} mindert die Bemessungsgrundlage auf {base}",
    "avm.documents.title": "Belege und Dokumente",
    "avm.documents.addFile": "Datei",
    "avm.documents.open": "öffnen",
    "avm.documents.unlink": "Verknüpfung entfernen",
    "avm.documents.tag.avm": "Anlagenbuch",
    "avm.documents.tag.record": "Buchhaltung",
    "avm.documents.empty": "Noch keine Belege",
    "avm.documents.recordHint": "Beleg des verknüpften Buchungssatzes",
    "avm.documents.recordLoading": "Belege des verknüpften Buchungssatzes werden geladen",
    "avm.documents.missing": "Dokument {id} nicht gefunden",
    "avm.documents.noDmsAccess": "Für Belege wird Lesezugriff auf die Unterlagen benötigt",
    "avm.documents.noWriteAccess": "Für Belege wird Schreibzugriff auf das Anlagenbuch benötigt",
    "avm.detail.changeLog": "Änderungsprotokoll",
    "avm.detail.changeLog.empty": "Keine Änderungen vorhanden",
    "avm.detail.notFound": "Anlagegut nicht gefunden",

    "avm.restwert.title": "Restwertverzeichnis",
    "avm.restwert.subtitle": "Übersicht der Restwerte zum Stichtag",
    "avm.restwert.legend": "Legende",
    "avm.restwert.empty": "Keine Daten vorhanden",
    "avm.export.csv": "CSV exportieren",
    "avm.export.pdf": "PDF exportieren",
    "avm.export.xlsx": "Excel exportieren",

    "avm.spiegel.title": "Anlagenspiegel",
    "avm.spiegel.subtitle": "Wirtschaftsjahr",
    "avm.spiegel.col.group": "Anlagengruppe",
    "avm.spiegel.col.costStart": "AK/HK Anfang",
    "avm.spiegel.col.additions": "Zugänge",
    "avm.spiegel.col.disposals": "Abgänge",
    "avm.spiegel.col.transfers": "Umbuchungen",
    "avm.spiegel.col.costEnd": "AK/HK Ende",
    "avm.spiegel.col.cumAfaStart": "Kum. AfA Anfang",
    "avm.spiegel.col.afa": "AfA des Jahres",
    "avm.spiegel.col.writeUps": "Zuschreibungen",
    "avm.spiegel.col.cumAfaDisposals": "Kum. AfA Abgänge",
    "avm.spiegel.col.cumAfaTransfers": "Kum. AfA Umbuchungen",
    "avm.spiegel.col.cumAfaEnd": "Kum. AfA Ende",
    "avm.spiegel.col.bookValueEnd": "Buchwert Ende",
    "avm.spiegel.col.bookValuePrevEnd": "Buchwert Vorjahr",
    "avm.spiegel.total": "Summe",
    "avm.spiegel.empty": "Für dieses Jahr gibt es keine Anlagegüter",

    "avm.forecast.title": "AfA-Vorschau",
    "avm.forecast.window": "Zeitraum",
    "avm.forecast.window.years": "{count} Jahre",
    "avm.forecast.col.name": "Bezeichnung",
    "avm.forecast.col.total": "Summe",
    "avm.forecast.pool": "Sammelposten {year}",
    "avm.forecast.empty": "Keine geplanten Abschreibungen im gewählten Zeitraum",

    "avm.pool.settings.noGroup":
        "Die Sammelposten-Politik ist aktiv, es gibt aber keine Anlagengruppe mit einem Sammelposten-Konto. Standardgruppen anlegen oder eine Anlagengruppe der Art Sammelposten ergänzen.",
    "avm.pool.settings.hint":
        "Sammelposten werden über {years} Jahre gleichmäßig aufgelöst, unabhängig vom Anschaffungsmonat.",
    "avm.pool.asset.noPlan":
        "Sammelposten-Güter haben keinen eigenen Abschreibungsplan. Der Buchwert steht in der Sammelposten-Zeile.",

    "avm.inventory.title": "Inventarliste",
    "avm.inventory.filter.applied": "gefiltert",
    "avm.inventory.filter.location": "Standort",
    "avm.inventory.filter.status": "Status",
    "avm.inventory.status.active": "Aktiv",
    "avm.inventory.status.writtenOff": "Abgeschrieben",
    "avm.inventory.status.disposed": "Abgegangen",
    "avm.inventory.export.xlsx": "Excel",
    "avm.inventory.export.sheet": "Inventurbogen",
    "avm.inventory.sheet.counted": "Gezählt",
    "avm.inventory.sheet.note": "Bemerkung",
    "avm.inventory.empty": "Keine Anlagegüter im Bestand",

    "avm.batches.title": "Buchungsstapel",
    "avm.batches.tab.afa": "AfA-Stapel",
    "avm.batches.tab.disposal": "Abgangs-Stapel",
    "avm.batches.kpi.total": "Summe",
    "avm.batches.kpi.lines": "Zeilen",
    "avm.batches.status.none": "Kein Stapel",
    "avm.batches.status.ready": "Bereit",
    "avm.batches.status.transferred": "Übergeben",
    "avm.batches.create": "Stapel erzeugen",
    "avm.batches.createDifference": "Differenzstapel erzeugen",
    "avm.batches.createDifference.hint": "Bucht nur die Änderung.",
    "avm.batches.createReplacement": "Storno und neuer Stapel",
    "avm.batches.createReplacement.hint": "Storniert den übergebenen Stapel und bucht den Stand neu.",
    "avm.batches.transfer": "Stapel übergeben",
    "avm.batches.transfer.confirm": "{count} Zeilen über {total} als Entwürfe in die Freie Erfassung übergeben?",
    "avm.batches.transfer.lockYear":
        "Mit der Übergabe wird das Wirtschaftsjahr {year} abgeschlossen. Danach sind Bewegungen und Wertänderungen in {year} gesperrt.",
    "avm.batches.transfer.closedYear": "Das Wirtschaftsjahr {year} ist abgeschlossen.",
    "avm.batches.transfer.remaining":
        "Das Wirtschaftsjahr {year} wird abgeschlossen, sobald auch der {batch} übergeben ist.",
    "avm.batches.transfer.stillOpen":
        "Das Wirtschaftsjahr {year} ist noch nicht abgeschlossen. Bitte es unten im Jahresabschluss abschließen.",
    "avm.batches.transfer.stale":
        "{count, plural, one {Der {batches} {year} wurde} other {Der {batches} {year} wurden}} vor einer späteren Änderung übergeben; die Differenz ist noch nicht in der Buchhaltung. Das Wirtschaftsjahr bleibt offen. Bitte „Differenzstapel erzeugen“ oder „Storno und neuer Stapel“ wählen und den Stapel übergeben; danach schließt das Wirtschaftsjahr.",
    "avm.batches.transfer.stale.join": " und der ",
    "avm.batches.transfer.alsoLocks":
        "{count, plural, one {Damit ist auch das Wirtschaftsjahr {last} gesperrt.} =2 {Damit sind auch die Wirtschaftsjahre {first} und {last} gesperrt.} other {Damit sind auch die Wirtschaftsjahre {first} bis {last} gesperrt.}}",
    "avm.batches.delete": "Stapel löschen",
    "avm.batches.recreate": "Löschen und neu erzeugen",
    "avm.batches.csv": "Als CSV",
    "avm.batches.stale": "Der gespeicherte Stapel weicht von der aktuellen Berechnung ab",
    "avm.batches.staleTransferred":
        "Das Register hat sich seit der Übergabe dieses Stapels verändert. Angezeigt werden die tatsächlich übergebenen Zeilen, nicht die aktuelle Berechnung. Bitte „Differenzstapel erzeugen“ oder „Storno und neuer Stapel“ wählen und den Stapel übergeben.",
    "avm.batches.difference.empty":
        "Die übergebenen Buchungen entsprechen der aktuellen Berechnung; es gibt keine Differenz zu buchen. Der Differenzstapel ohne Zeilen hält den aktuellen Stand des Anlagenbuchs fest.",
    "avm.batches.empty": "Für dieses Jahr entstehen keine Buchungen",
    "avm.batches.goToFe": "Entwürfe in der Freien Erfassung öffnen",
    "avm.batches.goToFeHint": "Wählen Sie dort den Filter Entwurf, um die übergebenen Buchungen zu bestätigen.",
    "avm.batches.goToFeNoAccess":
        "Die übergebenen Entwürfe liegen in der Freien Erfassung; Sie haben dort keinen Lesezugriff.",
    "avm.batches.transfer.blocked.fe": "Dafür wird Schreibzugriff auf die Freie Erfassung benötigt",
    "avm.batches.notice.transfer":
        "Für Umbuchungen erzeugt das Anlagenbuch keine Buchung. Buchen Sie den Kontowechsel bei Bedarf in der Freien Erfassung.",
    "avm.batches.notice.disposalGroup":
        "Der Abgang wird auf die Gruppe zum Abgangsdatum gebucht, das Verzeichnis führt die Anlage unter der Gruppe zum Jahresende.",
    "avm.batches.notice.poolExit":
        "Der Sammelposten verlässt das Verzeichnis; der Anlagenspiegel zeigt einen Abgang zu Anschaffungskosten, eine Buchung entsteht dafür nicht.",
    "avm.batches.notice.missingKonto":
        "Für diese Zeile fehlt ein Konto. Ergänzen Sie die Anlagengruppe, bevor Sie den Stapel erzeugen.",
    "avm.batches.missingKonten.title": "Kontierung der Anlagengruppen fehlt",
    "avm.batches.missingKonten.body":
        "Die Übergabe an die Buchhaltung ist erst möglich, wenn diese Anlagengruppen die Konten ihrer Buchungszeilen haben. Ein Klick auf die Anlagengruppe öffnet ihre Buchungskonten.",
    "avm.batches.chartMismatch.title": "Buchungskonten eines anderen Kontenrahmens",
    "avm.batches.chartMismatch.body":
        "Die Buchhaltung {year} führt SKR 0{skr}. Die Buchungskonten dieser Anlagengruppen gehören zu einem anderen Kontenrahmen; bitte in ihren Buchungskonten den Kontenrahmen SKR 0{skr} wählen und die Konten dieses Kontenrahmens eintragen:",
    "avm.batches.accounts.none": "Für die Übergabe an die Buchhaltung braucht jede Anlagengruppe Buchungskonten.",
    "avm.batches.accounts.noChart":
        "Die Buchhaltung hat keinen Kontenrahmen SKR 03 oder SKR 04. Bitte die Buchungskonten je Anlagengruppe von Hand hinterlegen.",
    "avm.batches.accounts.seed": "Buchungskonten anlegen",
    "avm.batches.accounts.fillable":
        "Einige Standardgruppen haben noch nicht alle Buchungskonten ihres Kontenrahmens. Beim Ergänzen bleiben eingetragene Konten unverändert.",
    "avm.batches.accounts.fill": "Buchungskonten ergänzen",
    "avm.batches.accounts.unconfigured.title": "Anlagengruppen ohne Buchungskonten",
    "avm.batches.accounts.unconfigured.body":
        "Für diese Anlagengruppen gibt es keine Standardkonten. Eine Gruppe ohne Buchungszeile im Stapel hält die Übergabe nicht auf.",
    "avm.batches.accounts.unconfigured": "nicht konfiguriert",
    "avm.batches.fiscalYearMismatch.title": "Abweichender Beginn des Wirtschaftsjahres",
    "avm.batches.fiscalYearMismatch.body":
        "Das Wirtschaftsjahr {year} beginnt im Anlagenbuch am {avmStart} und in der Buchhaltung am {accountingStart}. Die Übergabe ist trotzdem möglich.",
    "avm.batches.fiscalYearMismatch.consequences":
        "<li>Die Buchungen tragen das Datum {avmEnd} aus dem Wirtschaftsjahr des Anlagenbuchs und landen damit im Buchhaltungsjahr {recordYear}.</li><li>Als Buchungsperiode wird Monat {postingMonth} gesetzt, sodass monatliche Auswertungen die gesamte Jahres-AfA in diesem Monat zeigen.</li><li>Der Zeitraum, den die Buchhaltung als Wirtschaftsjahr {year} führt, erhält damit nicht die AfA genau dieses Zeitraums, und jedes weitere Jahr verschiebt sich gleich.</li>",
    "avm.batches.fiscalYearMismatch.culprit":
        "Prüfen Sie zuerst die Buchhaltung: dort steht der falsche Beginn wahrscheinlicher, denn ein falsches Wirtschaftsjahr im Anlagenbuch wäre schon ab der ersten Buchung falsch.",
    "avm.batches.col.date": "Datum",
    "avm.batches.col.soll": "Soll",
    "avm.batches.col.haben": "Haben",
    "avm.batches.col.text": "Text",
    "avm.batches.col.amount": "Betrag",

    "avm.closing.title": "Jahresabschluss",
    "avm.closing.close": "Jahr abschliessen",
    "avm.closing.reopen": "Jahr wieder öffnen",
    "avm.closing.closed": "Abgeschlossen am {date}",
    "avm.closing.reopened": "Wieder geöffnet am {date}",
    "avm.closing.totalAfa": "AfA gesamt",
    "avm.closing.totalBookValue": "Buchwert Ende",
    "avm.closing.blocked.batch": "Noch nicht alle Buchungsstapel des Jahres sind übergeben",
    "avm.closing.blocked.earlier": "Für {year} fehlt der Jahresabschluss",
    "avm.closing.blocked.locked":
        "Das Wirtschaftsjahr {year} liegt vor dem abgeschlossenen Wirtschaftsjahr {latest}. Bitte zuerst {latest} wieder öffnen.",
    "avm.closing.blocked.empty": "Für {year} enthält der Abschluss keine Anlagen",
    "avm.closing.blocked.role": 'Dafür wird die Berechtigung "Anlagenbuch freigeben" benötigt',
    "avm.closing.blocked.write": "Dafür wird Schreibzugriff auf das Anlagenbuch benötigt",
    "avm.closing.confirm.close": "{count} Anlagen mit {total} AfA abschliessen?",
    "avm.closing.confirm.stale": "Bitte nur abschließen, wenn die Differenz von Hand in der Buchhaltung gebucht ist.",
    "avm.closing.confirm.reopen":
        "Der Abschluss bleibt als Nachweis erhalten. Die übergebenen Buchungen bleiben in der Buchhaltung; eine Korrektur wird dort gebucht. Jahr wieder öffnen?",
    "avm.closing.drift": "Abweichung zum Jahresabschluss {year}",
    "avm.closing.drift.field": "Feld",
    "avm.closing.drift.stored": "Gespeichert",
    "avm.closing.drift.computed": "Berechnet",
    "avm.closing.drift.onlyComputed": "Neu hinzugekommen seit dem Abschluss",
    "avm.closing.drift.onlyStored": "Seit dem Abschluss entfernt",

    "avm.restricted.title": "Kein Zugriff",
    "avm.restricted.description": "Für das Anlagenbuch ist keine Leseberechtigung vorhanden.",

    "avm.error.periods": "Die Wirtschaftsjahre dieses Unternehmens sind nicht schlüssig: {message}",
    "avm.error.outsideRange":
        "{count, plural, one {# Anlagegut liegt außerhalb der berechneten Wirtschaftsjahre und wird} other {# Anlagegüter liegen außerhalb der berechneten Wirtschaftsjahre und werden}} ohne Abschreibung geführt.",
    "avm.error.planFailed":
        "{count, plural, one {Für # Anlagegut konnte kein Abschreibungsplan berechnet werden. Es fehlt} other {Für # Anlagegüter konnte kein Abschreibungsplan berechnet werden. Sie fehlen}} in Anlagenspiegel, Restwertverzeichnis, Inventarliste, AfA-Stapel und Jahresabschluss. Bis zur Behebung sind Stapel erzeugen und Jahr abschließen gesperrt.",
    "avm.error.planFailed.action":
        "Öffnen Sie das genannte Anlagegut und ändern Sie in den Stammdaten die Abschreibungsmethode, zum Beispiel auf linear. Liegt das Anlagegut in einem bereits abgeschlossenen Wirtschaftsjahr, öffnen Sie dieses Wirtschaftsjahr zuerst wieder.",
    "avm.error.writeUpAboveCap":
        "Die Zuschreibung vom {date} über {amount} liegt über ihrer Obergrenze von {cap}. Stornieren Sie die Zuschreibung und buchen Sie höchstens {cap} neu; liegt sie in einem abgeschlossenen Wirtschaftsjahr, öffnen Sie dieses zuerst wieder.",
    "avm.error.writeUpUnimpairedMissing":
        "Die Zuschreibung vom {date} braucht als Obergrenze den Buchwert ohne Teilwertabschreibung, weil das Gebäude mit einer eigenen AfA-Bemessungsgrundlage übernommen ist. Tragen Sie den Buchwert ohne Teilwertabschreibung in den Stammdaten ein.",
    "avm.fiscalYear.action": "Zu den AVM-Einstellungen",
    "avm.yearSelect.label": "Wirtschaftsjahr",
    "avm.error.noTaxParameters": "Für dieses Wirtschaftsjahr sind keine Steuerparameter hinterlegt.",
    "avm.error.noGroups":
        "Für dieses Unternehmen sind noch keine Anlagengruppen angelegt, ohne Anlagengruppe lässt sich kein Anlagegut erfassen. Anlagengruppen werden einmalig in den Einstellungen angelegt, dort erstellt die Aktion Standardgruppen anlegen sie samt der beiden Konten für Abgangsgewinn und Abgangsverlust passend zum Kontenrahmen.",
    "avm.error.noGroups.action": "Einstellungen öffnen",
    "avm.error.loadFailed": "Die Daten des Anlagenbuchs konnten nicht geladen werden.",
    "avm.loading": "Wird geladen...",

    "avm.classify.expense": "Sofort als Aufwand buchbar",
    "avm.classify.gwg": "Geringwertiges Wirtschaftsgut",
    "avm.classify.pool": "Sammelposten",
    "avm.classify.linear": "Lineare Abschreibung",

    "avm.wizard.eyebrow": "Erfassungsassistent",
    "avm.wizard.title": "Neues Anlagegut",
    "avm.wizard.lead":
        "Vier Schritte. Nutzungsdauer, AfA-Art und Konto schlägt das System vor, jede Vorgabe lässt sich überschreiben.",
    "avm.wizard.step1": "Was wurde angeschafft?",
    "avm.wizard.step2": "Kosten und Datum",
    "avm.wizard.step3": "Abschreibung",
    "avm.wizard.step4": "Prüfen und speichern",
    "avm.wizard.save": "Anlagegut speichern",
    "avm.wizard.field.name": "Bezeichnung",
    "avm.wizard.field.supplier": "Lieferant / Herkunft",
    "avm.wizard.field.group": "Anlagengruppe",
    "avm.wizard.field.groupHint": "bestimmt Konto und vorgeschlagene Nutzungsdauer",
    "avm.wizard.field.location": "Standort",
    "avm.wizard.field.costCenter": "Kostenstelle",
    "avm.wizard.field.costCenterNone": "keine Kostenstelle",
    "avm.wizard.field.quantity": "Stückzahl",
    "avm.wizard.field.quantityHint": "ab 2 Stück eine Sammelanlage, Teilabgänge werden anteilig ausgebucht",
    "avm.wizard.field.usedBy": "Genutzt von / verantwortlich",
    "avm.wizard.field.amountNet": "Anschaffungskosten netto",
    "avm.wizard.field.amountGross": "Anschaffungskosten brutto (Rechnungsbetrag)",
    "avm.wizard.field.amountPartial": "Aktivierungsbetrag (netto plus nicht abziehbare Vorsteuer)",
    "avm.wizard.field.incidental": "Anschaffungsnebenkosten",
    "avm.wizard.field.incidentalHint": "Fracht, Montage, Aufbau",
    "avm.wizard.field.date": "Anschaffungsdatum",
    "avm.wizard.field.dateHint": "maßgeblich ist die Betriebsbereitschaft",
    "avm.wizard.field.vat": "Vorsteuer",
    "avm.wizard.field.vatHint": "Vorbelegung aus den Einstellungen",
    "avm.wizard.vat.net": "voll abziehbar, netto aktivieren",
    "avm.wizard.vat.gross": "nicht abziehbar, brutto aktivieren",
    "avm.wizard.vat.partial": "anteilig abziehbar, Anteil erfassen",
    "avm.wizard.vat.kust": "kein Ausweis (§ 19 UStG), Rechnungsbetrag",
    "avm.wizard.field.record": "Beleg aus der Buchhaltung",
    "avm.wizard.record.none": "Beleg später zuordnen",
    "avm.wizard.classification.expense":
        "Bis {limit} netto: sofort als Aufwand. Eine Aufnahme ins Anlagenverzeichnis ist nicht nötig.",
    "avm.wizard.classification.recordAnyway": "Trotzdem als Anlagegut erfassen",
    "avm.wizard.classification.gwg":
        "Geringwertiges Wirtschaftsgut. Bis {limit} netto im Jahr der Anschaffung voll abschreibbar, das Anlagegut wird im Verzeichnis geführt.",
    "avm.wizard.classification.pool": "Sammelposten. Zwischen {min} und {max} netto, Auflösung über {years} Jahre.",
    "avm.wizard.classification.linear":
        "Aktivierung und Abschreibung über die Nutzungsdauer. Über {limit} netto: planmäßige AfA, zeitanteilig ab dem Anschaffungsmonat.",
    "avm.wizard.method.linear": "Lineare Normalabschreibung",
    "avm.wizard.method.linearDesc": "gleichmäßig über die Nutzungsdauer, zeitanteilig im ersten Jahr",
    "avm.wizard.method.gwg": "GWG, Sofortabschreibung",
    "avm.wizard.method.gwgDesc": "volle Abschreibung im Anschaffungsjahr",
    "avm.wizard.method.pool": "Sammelposten (Pool)",
    "avm.wizard.method.degressive": "Degressive AfA",
    "avm.wizard.method.poolDesc": "Auflösung über {years} Jahre, unabhängig vom Abgang einzelner Gegenstände",
    "avm.wizard.method.degressiveDesc":
        "dreifacher linearer Satz, hoechstens 30 Prozent, nur fuer Anschaffungen im gesetzlichen Zeitfenster",
    "avm.wizard.field.usefulLifeYears": "Nutzungsdauer (Jahre)",
    "avm.wizard.field.usefulLifeMonths": "Nutzungsdauer (Monate)",
    "avm.wizard.field.usefulLifeHint": "Vorschlag aus der Anlagengruppe",
    "avm.wizard.field.usefulLifeHintBuilding": "Ergibt sich aus Nutzung und Datum (§ 7 Abs. 4 EStG)",
    "avm.wizard.field.usefulLifeHintLease": "Ergibt sich aus dem Ende des Mietvertrags",
    "avm.wizard.field.usefulLifeHintBuildingGroup":
        "Ergibt sich aus Nutzung und Datum (§ 7 Abs. 4 EStG) oder aus dem Ende des Mietvertrags",
    "avm.wizard.special.label": "Sonderabschreibung nach Paragraf 7g Abs. 5 EStG",
    "avm.wizard.special.description":
        "{amount} vollständig im Jahr der Anschaffung zusätzlich zur planmäßigen AfA, höchstens {rate} Prozent der Bemessungsgrundlage; möglich in den ersten {years} Jahren ab der Anschaffung.",
    "avm.wizard.special.windowUnavailable":
        "Für dieses Anschaffungsdatum ist keine Sonderabschreibung nach Paragraf 7g Abs. 5 EStG möglich.",
    "avm.wizard.iab.label": "Investitionsabzugsbetrag zuordnen",
    "avm.wizard.iab.empty": "Kein nicht zugeordneter Investitionsabzugsbetrag vorhanden.",
    "avm.memoValue.label": "Restbuchwert am Ende der Nutzungsdauer",
    "avm.memoValue.one": "1,00 (Erinnerungswert)",
    "avm.memoValue.zero": "0,00",
    "avm.memoValue.wizardHint":
        "Vorbelegt aus den Einstellungen des Unternehmens; die Vorbelegung lässt sich dort ändern und wirkt nur auf neue Anlagegüter.",
    "avm.memoValue.assetHint":
        "Gilt nur für dieses Anlagegut. Eine Änderung der Vorbelegung in den Einstellungen ändert diesen Wert nicht.",
    "avm.roundingMode.label": "Rundung der AfA",
    "avm.roundingMode.wizardHint":
        "Die Rundung ist aus den Einstellungen des Unternehmens vorbelegt; die Vorbelegung lässt sich dort ändern und wirkt nur auf neue Anlagegüter.",
    "avm.roundingMode.assetHint":
        "Gilt nur für dieses Anlagegut. Eine Änderung der Vorbelegung in den Einstellungen ändert diese Rundung nicht.",
    "avm.oneYear.hardwareQuestion": "Ist das Computerhardware oder Peripherie (BMF-Schreiben vom 22.02.2022)?",
    "avm.oneYear.hardware.yes": "Ja",
    "avm.oneYear.hardware.no": "Nein",
    "avm.oneYear.hardwareHint":
        "Computer, Notebooks, Tablets, Thin Clients, Workstations, Dockingstationen, kleine Server, externe Netzteile und Peripheriegeräte.",
    "avm.oneYear.label": "Nutzungsdauer nach BMF-Schreiben vom 22.02.2022",
    "avm.oneYear.term.one": "1 Jahr",
    "avm.oneYear.term.oneDesc": "Volle AfA im Wirtschaftsjahr der Anschaffung, unabhängig vom Monat",
    "avm.oneYear.term.three": "3 Jahre",
    "avm.oneYear.term.threeDesc": "36 Monate, monatsgenau ab dem Anschaffungsmonat",
    "avm.oneYear.beforeCutoff":
        "„1 Jahr“ gilt erst ab Wirtschaftsjahren, die nach dem 31.12.2020 enden (BMF-Schreiben vom 22.02.2022); diese Anschaffung wird über 3 Jahre abgeschrieben.",
    "avm.import.row.error.fullYearAfaCutoff":
        "1 Jahr gilt erst ab Wirtschaftsjahren, die nach dem 31.12.2020 enden; bitte 3 Jahre wählen",
    "avm.oneYear.saasHint": "SaaS- und Cloud-Abonnements sind keine Anlagegüter und gehören nicht ins Anlagenbuch",
    "avm.businessUse90.label":
        "Im Wirtschaftsjahr der Investition und im folgenden vermietet oder in einer inländischen Betriebsstätte zu mindestens 90 % betrieblich genutzt",
    "avm.businessUse90.tooltip":
        "Sonderabschreibung (§ 7g Abs. 6 Nr. 2 EStG) und Investitionsabzugsbetrag (§ 7g Abs. 1 Satz 1 EStG) setzen voraus, dass das Wirtschaftsgut im Wirtschaftsjahr der Investition und im folgenden Wirtschaftsjahr vermietet oder in einer inländischen Betriebsstätte des Betriebs ausschließlich oder fast ausschließlich, also zu mindestens 90 %, betrieblich genutzt wird. Ein Pkw, dessen private Nutzung nach der Ein-Prozent-Regelung versteuert wird, erfüllt das meist nicht.",
    "avm.businessUse90.tooltipLabel": "Erläuterung zur Nutzung im Wirtschaftsjahr der Investition und im folgenden",
    "avm.businessUse90.rests.special": "Auf der Bestätigung beruht eine gebuchte Sonderabschreibung.",
    "avm.businessUse90.rests.iab": "Auf der Bestätigung beruht ein zugeordneter Investitionsabzugsbetrag.",
    "avm.businessUse90.rests.both":
        "Auf der Bestätigung beruhen eine gebuchte Sonderabschreibung und ein zugeordneter Investitionsabzugsbetrag.",
    "avm.businessUse90.remove.open": "Zum Entfernen bitte zuerst {step}.",
    "avm.businessUse90.remove.closed":
        "Das Wirtschaftsjahr {year} ist abgeschlossen; zum Entfernen bitte es zuerst wieder öffnen und dann {step}.",
    "avm.businessUse90.remove.closedBefore":
        "Das Wirtschaftsjahr {year} liegt vor dem abgeschlossenen Wirtschaftsjahr {latest}; zum Entfernen bitte zuerst die Jahresabschlüsse von {latest} zurück bis {year} wieder öffnen und dann {step}.",
    "avm.businessUse90.step.special": "die Sonderabschreibung stornieren",
    "avm.businessUse90.step.iab": "die Zuordnung aufheben",
    "avm.businessUse90.step.both": "die Sonderabschreibung stornieren und die Zuordnung aufheben",
    "avm.import.field.businessUse90Confirmed": "Vermietet oder mindestens 90 % betrieblich genutzt",
    "avm.businessUse90.hint": "Voraussetzung für Sonderabschreibung und Investitionsabzugsbetrag nach § 7g EStG",
    "avm.wizard.error.businessUse90":
        "Bitte die betriebliche Nutzung von mindestens 90 % bestätigen oder auf Sonderabschreibung und Investitionsabzugsbetrag verzichten",
    "avm.movements.error.businessUse90":
        "Die Sonderabschreibung setzt eine betriebliche Nutzung von mindestens 90 % voraus (§ 7g Abs. 6 Nr. 2 EStG). Bitte die Nutzung zuerst in den Stammdaten bestätigen oder eine andere Bewegungsart wählen.",
    "avm.iab.form.assetBusinessUse90": "Betriebliche Nutzung von mindestens 90 % ist in den Stammdaten nicht bestätigt",
    "avm.assets.method.fullYear": "1 Jahr (volle AfA im Anschaffungsjahr)",
    "avm.groups.oneYearChoice": "Wahl 1 Jahr / 3 Jahre",
    "avm.groups.oneYearChoice.none": "Nicht anbieten",
    "avm.groups.oneYearChoice.always": "Immer anbieten (Software)",
    "avm.groups.oneYearChoice.askHardware": "Nach Hardware-Frage (Computerhardware)",
    "avm.groups.oneYearChoice.hint":
        "Software und Computerhardware dürfen nach dem BMF-Schreiben vom 22.02.2022 im Anschaffungsjahr voll abgeschrieben werden (1 Jahr) oder über 3 Jahre.",
    "avm.groups.oneYearChoice.kind": "Nur für Gruppen der Art bewegliche oder immaterielle Wirtschaftsgüter",
    "avm.rightKind.label": "Rechteart",
    "avm.rightKind.patent": "Patent",
    "avm.rightKind.trademark": "Marke",
    "avm.rightKind.other": "Sonstiges Recht",
    "avm.rightKind.filingDate": "Anmeldetag",
    "avm.rightKind.hint.patent":
        "Ein Patent läuft 20 Jahre ab dem Anmeldetag (§ 16 PatG). Die Nutzungsdauer ist mit der Restlaufzeit ab dem Erwerb vorbelegt und darf sie nicht überschreiten.",
    "avm.rightKind.hint.trademark":
        "Für eine erworbene Marke sind 180 Monate vorbelegt (BMF-Schreiben vom 12.07.1999); eine kürzere Nutzungsdauer ist möglich.",
    "avm.rightKind.hint.other":
        "Für ein sonstiges Recht gibt es keine Vorgabe. Bitte die Nutzungsdauer nach der Vertragslaufzeit eintragen.",
    "avm.rightKind.error.required": "Bitte die Rechteart wählen: Patent, Marke oder Sonstiges Recht.",
    "avm.rightKind.error.filingDate":
        "Bei einem Patent richtet sich die längste Nutzungsdauer nach dem Anmeldetag (§ 16 PatG). Bitte den Anmeldetag eintragen oder eine andere Rechteart wählen.",
    "avm.rightKind.error.expired":
        "Das Patent war beim Erwerb bereits abgelaufen; bitte als Sonstiges Recht erfassen oder das Anmeldedatum prüfen",
    "avm.rightKind.error.lifeAbovePatent":
        "Das Patent läuft 20 Jahre ab dem Anmeldetag (§ 16 PatG); ab dem Erwerb sind das höchstens {max} Monate. Bitte höchstens {max} Monate eintragen oder den Anmeldetag prüfen.",
    "avm.rightKind.error.remainingAbovePatent":
        "Das Patent läuft 20 Jahre ab dem Anmeldetag (§ 16 PatG); ab dem {start} sind das höchstens {max} Monate. Bitte höchstens {max} Monate eintragen oder den Anmeldetag prüfen.",
    "avm.rightKind.error.movementExpired":
        "Das Patent ist am {start} bereits abgelaufen. Bitte die Restnutzungsdauer leer lassen oder den Anmeldetag prüfen.",
    "avm.rightKind.error.openingExpired":
        "Das Patent ist am {start} bereits abgelaufen. Bitte das Anlagegut als Sonstiges Recht erfassen oder den Anmeldetag prüfen.",
    "avm.groups.asksRightKind": "Rechteart abfragen",
    "avm.groups.asksRightKind.hint":
        "Jedes Anlagegut dieser Gruppe wählt Patent, Marke oder Sonstiges Recht; die Rechteart bestimmt die Vorbelegung der Nutzungsdauer.",
    "avm.groups.asksRightKind.kind":
        'Die Einstellung "Rechteart abfragen" gibt es nur für Anlagengruppen der Art immaterielle Wirtschaftsgüter. Bitte die Einstellung ausschalten.',
    "avm.import.field.fullYearAfa": "1 Jahr (volle AfA)",
    "avm.import.field.hardwareBmf": "Computerhardware (BMF)",
    "avm.import.field.rightKind": "Rechteart (Patent, Marke, Sonstiges Recht)",
    "avm.import.field.patentFilingDate": "Anmeldetag (Patent)",
    "avm.import.row.error.flag": "Ja/Nein-Angabe nicht lesbar (ja, nein, x oder leer)",
    "avm.import.row.error.fullYearAfa":
        "Diese Anlagengruppe bietet 1 Jahr nicht an (nur Software oder bestätigte Computerhardware)",
    "avm.import.row.error.fullYearAfaTerms": "1 Jahr verlangt lineare AfA über 12 Monate",
    "avm.import.row.error.fullYearAfaPool":
        "1 Jahr ist nicht möglich: die Anschaffungskosten fallen in den Sammelposten, den die Sammelposten-Wahl des Unternehmens vorgibt",
    "avm.import.row.error.hardwareBmf": "Die Hardware-Angabe gibt es nur in einer Gruppe mit Hardware-Frage",
    "avm.import.row.error.rightKind":
        'Rechteart nicht lesbar oder in dieser Gruppe nicht abgefragt; bitte Patent, Marke oder Sonstiges Recht in einer Gruppe mit "Rechteart abfragen"',
    "avm.import.row.error.patentFilingDate":
        "Patent ohne lesbaren Anmeldetag; bitte den Anmeldetag eintragen oder eine andere Rechteart wählen",
    "avm.import.row.error.patentExpired":
        "Das Patent war beim Erwerb bereits abgelaufen; bitte als Sonstiges Recht erfassen oder das Anmeldedatum prüfen",
    "avm.import.row.error.patentLife":
        "Nutzungsdauer länger als die Restlaufzeit des Patents (20 Jahre ab Anmeldetag, § 16 PatG); bitte kürzen oder den Anmeldetag prüfen",
    "avm.wizard.preview.title": "Vorschau",
    "avm.wizard.preview.summary": "{years} Jahre, AfA im ersten Jahr {afa}",
    "avm.wizard.preview.col.year": "Jahr",
    "avm.wizard.preview.col.months": "Monate",
    "avm.wizard.preview.col.afa": "AfA",
    "avm.wizard.preview.col.bookValueEnd": "Buchwert Ende",
    "avm.wizard.preview.none":
        "Für diese Angaben lässt sich keine Vorschau berechnen. Ein Sammelposten wird als Gruppe aufgelöst, und ein Anschaffungsdatum außerhalb der geladenen Wirtschaftsjahre ergibt keinen Plan.",
    "avm.wizard.preview.buildingMissing": "Für die Vorschau bitte Nutzung und Datum (oder das Mietende) angeben.",
    "avm.wizard.review.title": "Das wird gespeichert",
    "avm.wizard.review.inventoryNum": "Inventarnummer",
    "avm.wizard.review.inventoryAuto": "wird automatisch vergeben",
    "avm.wizard.review.konto": "Konto",
    "avm.wizard.review.method": "Methode",
    "avm.wizard.review.afaFirstYear": "AfA {year}",
    "avm.wizard.review.postingTitle": "Buchung des Zugangs",
    "avm.wizard.review.postingNote":
        "Die Eingangsrechnung bucht das Anlagenkonto bereits. Das Anlagenbuch erzeugt keine Zugangsbuchung, der verknüpfte Beleg dokumentiert den Zugang.",
    "avm.wizard.review.linkedRecord": "Verknüpfter Beleg",
    "avm.wizard.review.noRecord": "kein Beleg verknüpft",
    "avm.wizard.review.specialDepreciation": "Sonderabschreibung § 7g Abs. 5",
    "avm.wizard.review.businessUse90": "Vermietet oder mindestens 90 % betrieblich genutzt",
    "avm.wizard.review.confirmed": "bestätigt",
    "avm.wizard.review.notConfirmed": "nicht bestätigt",
    "avm.wizard.review.iabAssigned": "Investitionsabzugsbetrag zugeordnet",
    "avm.wizard.error.nameRequired": "Bezeichnung erforderlich",
    "avm.wizard.error.groupRequired": "Anlagengruppe erforderlich",
    "avm.wizard.error.quantity": "Stückzahl muss mindestens 1 sein",
    "avm.wizard.error.dateRequired": "Anschaffungsdatum erforderlich",
    "avm.wizard.error.amountRequired": "Anschaffungskosten erforderlich",
    "avm.wizard.error.recordAnyway": "Bitte bestätigen, dass der Gegenstand trotzdem erfasst werden soll",
    "avm.wizard.error.usefulLife": "Nutzungsdauer erforderlich",
    "avm.wizard.error.method": "Die gewählte Methode ist für diesen Betrag nicht zulässig",
    "avm.wizard.error.specialMethod": "Sonderabschreibung ist nur bei linearer Abschreibung möglich",
    "avm.wizard.error.acquisitionDateTooEarly":
        "Das Anschaffungsdatum liegt vor dem frühesten hinterlegten Steuerjahr {year}. Bitte ein Datum ab dem {year}-01-01 wählen.",
    "avm.noAccounting.proposals":
        "Zugangsvorschläge stammen aus der Buchhaltung und stehen nur mit Zugriff auf ein Buchhaltungsprodukt zur Verfügung.",
    "avm.noAccounting.recordDocuments":
        "Belege aus der verknüpften Buchung stehen nur mit Zugriff auf ein Buchhaltungsprodukt zur Verfügung.",
    "avm.noAccounting.costCenter":
        "Kostenstellen stammen aus der Buchhaltung und stehen nur mit Zugriff auf ein Buchhaltungsprodukt zur Verfügung.",
    "avm.noAccounting.record":
        "Die Verknüpfung mit einem Beleg aus der Buchhaltung steht nur mit Zugriff auf ein Buchhaltungsprodukt zur Verfügung.",
    "avm.noAccounting.batches":
        "Der Buchungsstapel übergibt die Abschreibungen an die Buchhaltung und steht nur mit Zugriff auf ein Buchhaltungsprodukt zur Verfügung.",
    "avm.proposals.title": "Offene Vorschläge aus der Buchhaltung",
    "avm.proposals.empty": "Keine offenen Vorschläge",
    "avm.proposals.loading": "Vorschläge werden geladen",
    "avm.proposals.take": "übernehmen",
    "avm.proposals.dismiss": "ausblenden",
    "avm.proposals.net": "netto {amount}",
    "avm.proposals.reason.noAsset": "Konto {konto}, kein Anlagegut hinterlegt",
    "avm.proposals.reason.gwg": "Konto {konto}, unter {limit}, Vorschlag GWG",
    "avm.proposals.reason.expense": "Konto {konto}, unter {limit}, sofort als Aufwand möglich",
    "avm.import.eyebrow": "Erstanlage",
    "avm.import.title": "Import und Altbestand",
    "avm.import.lead":
        "Bestehende Anlageverzeichnisse werden als Excel- oder CSV-Datei eingelesen. Die Spalten werden erkannt und können zugeordnet werden, vor der Übernahme prüft das System Plausibilität und Summen.",
    "avm.import.drop": "Datei hier ablegen oder klicken (.xlsx, .xls, .csv)",
    "avm.import.dropActive": "Datei loslassen",
    "avm.import.rejected": "Dieses Dateiformat wird nicht unterstützt. Erlaubt sind .xlsx, .xls und .csv.",
    "avm.import.file": "{fileName}, {count} Zeilen",
    "avm.import.clear": "Andere Datei wählen",
    "avm.import.parseError": "Die Datei konnte nicht gelesen werden",
    "avm.import.headerRow.label": "Kopfzeile",
    "avm.import.headerRow.hint":
        "Als Kopfzeile erkannte Zeile. Sehen die Spaltennamen unten falsch aus, wählen Sie die richtige Zeile.",
    "avm.import.headerRow.option": "Zeile {row}: {preview}",
    "avm.import.headerRow.emptyRow": "(leere Zeile)",
    "avm.import.mapping.title": "Spaltenzuordnung",
    "avm.import.mapping.col.column": "Spalte in der Datei",
    "avm.import.mapping.col.sample": "Beispielwert",
    "avm.import.mapping.col.field": "Feld im Anlagenbuch",
    "avm.import.mapping.col.status": "Status",
    "avm.import.mapping.status.recognized": "erkannt",
    "avm.import.mapping.status.optional": "optional",
    "avm.import.mapping.status.required": "erforderlich",
    "avm.import.mapping.ignore": "nicht übernehmen",
    "avm.import.mapping.missing": "Pflichtfeld nicht zugeordnet: {field}",
    "avm.import.mapping.missingGroup": "Die Spalte Anlagengruppe muss zugeordnet sein",
    "avm.import.mapping.duplicateColumn": "Mehrfach derselben Spalte zugeordnet",
    "avm.import.field.inventoryNum": "Inventarnummer",
    "avm.import.field.name": "Gegenstand",
    "avm.import.field.group": "Anlagengruppe",
    "avm.import.field.acquisitionDate": "Anschaffungsdatum",
    "avm.import.field.acquisitionCost": "Anschaffungskosten",
    "avm.import.field.usefulLifeYears": "Nutzungsdauer (Jahre)",
    "avm.import.field.usefulLifeMonths": "Nutzungsdauer (Monate)",
    "avm.import.field.openingBookValue": "Buchwert Vorjahr",
    "avm.import.field.remainingMonths": "Restnutzungsdauer (Monate)",
    "avm.import.field.supplier": "Lieferant",
    "avm.import.field.location": "Standort",
    "avm.import.field.costCenter": "Kostenstelle",
    "avm.import.field.quantity": "Stückzahl",
    "avm.import.field.usedBy": "Genutzt von",
    "avm.import.field.note": "Notiz",
    "avm.import.field.method": "AfA-Art",
    "avm.import.field.memoValue": "Erinnerungswert",
    "avm.import.field.roundingMode": "Rundung",
    "avm.import.checks.title": "Prüfung vor der Übernahme",
    "avm.import.checks.ok": "{count} Zeilen fehlerfrei.",
    "avm.import.checks.needsLife":
        "{count} Zeilen ohne Nutzungsdauer. Vorschlag aus der Anlagengruppe, bitte bestätigen.",
    "avm.import.checks.acceptLife": "Vorschläge für die Nutzungsdauer übernehmen",
    "avm.import.checks.errors": "{count} Zeilen mit Fehlern werden nicht übernommen.",
    "avm.import.checks.expectedTotal": "Erwartete Summe der Restbuchwerte",
    "avm.import.checks.computedTotal": "Summe laut Datei: {amount}",
    "avm.import.checks.totalMatches": "stimmt mit dem Vorjahresabschluss überein",
    "avm.import.checks.totalDiffers": "weicht um {delta} vom Vorjahresabschluss ab",
    "avm.import.checks.openingYear": "Anfangsbestand zum Beginn des Wirtschaftsjahres {year}",
    "avm.import.submit": "{count} Zeilen übernehmen",
    "avm.import.rows.title": "Zeilen",
    "avm.import.rows.col.row": "Zeile",
    "avm.import.rows.col.status": "Status",
    "avm.import.rows.col.problems": "Hinweise",
    "avm.import.rows.status.ok": "ok",
    "avm.import.rows.status.needsLife": "Nutzungsdauer bestätigen",
    "avm.import.rows.status.error": "Fehler",
    "avm.import.row.error.name": "Bezeichnung fehlt",
    "avm.import.row.error.group":
        "Anlagengruppe „{value}“ nicht gefunden. Bitte den Namen einer vorhandenen Anlagengruppe angeben: {groups}",
    "avm.import.row.error.groupAmbiguous":
        "Das Anlagenkonto „{value}“ gehört zu mehreren Anlagengruppen: {candidates}. Bitte den Namen der Anlagengruppe angeben.",
    "avm.import.row.error.date": "Anschaffungsdatum ungültig",
    "avm.import.row.error.cost": "Anschaffungskosten ungültig",
    "avm.import.row.error.bookValue": "Buchwert ungültig",
    "avm.import.row.error.bookValueAboveCost": "Buchwert über den Anschaffungskosten",
    "avm.import.row.error.usefulLife": "Nutzungsdauer fehlt und die Gruppe hat keinen Standardwert",
    "avm.import.row.error.costCenter": "Kostenstelle länger als 8 Zeichen",
    "avm.import.row.error.quantity": "Stückzahl ungültig",
    "avm.import.row.error.memoValue":
        "Erinnerungswert ungültig: erlaubt sind 1, 1,00, 0 oder 0,00; leer übernimmt die Vorbelegung aus den Einstellungen",
    "avm.import.row.error.roundingMode":
        "Rundung ungültig: erlaubt sind Euro (auf volle Euro abrunden) oder Cent (centgenau); leer übernimmt die Vorbelegung aus den Einstellungen",
    "avm.import.row.error.inventoryNum": "Inventarnummer ungültig",
    "avm.import.row.error.degressiveWindow": "Degressive AfA außerhalb des gesetzlichen Zeitfensters",
    "avm.import.row.error.methodKind":
        "Abschreibungsmethode in dieser Anlagengruppe nicht zulässig. Bitte in der Datei eine zulässige Methode angeben oder die Zeile einer anderen Anlagengruppe zuordnen.",
    "avm.import.row.error.poolGroup":
        "Sammelposten ohne Anlagengruppe für Sammelposten. Bitte in den Einstellungen die Sammelposten-Gruppe anlegen und die Datei erneut einlesen.",
    "avm.import.row.note.poolGroup":
        "In die Sammelposten-Gruppe {name} übernommen: die Poolregel erfasst jedes Wirtschaftsgut in dieser Wertgrenze.",
    "avm.import.row.note.linearForKind":
        "Lineare Abschreibung übernommen, weil die Anlagengruppe die abgeleitete Methode nicht zulässt.",
    "avm.import.row.error.acquisitionDateTooEarly": "Anschaffungsdatum vor dem frühesten Steuerjahr {year}",
    "avm.import.ways.title": "Wege in den Bestand",
    "avm.import.ways.excel": "Excel-Import",
    "avm.import.ways.excelDesc": "Altbestand mit Restbuchwert und Restnutzungsdauer zum Umstellungsstichtag.",
    "avm.import.ways.wizard": "Erfassungsassistent",
    "avm.import.ways.wizardDesc": "Einzelne Neuzugänge, geführt in vier Schritten.",
    "avm.import.ways.proposals": "Vorschlag aus der Buchhaltung",
    "avm.import.ways.proposalsDesc": "Buchungen auf Anlagenkonten ohne Anlagegut werden als Zugang vorgeschlagen.",
    "avm.building.title": "Gebäudeangaben",
    "avm.building.titleOptional": "Gebäudeangaben für die Fertigstellung",
    "avm.building.optionalHint":
        "Nur nötig, wenn das Anlagegut mit der Fertigstellung in eine Anlagengruppe für Gebäude umgebucht wird.",
    "avm.building.basis": "Grundlage der Nutzungsdauer",
    "avm.building.basis.building": "Gebäude (§ 7 Abs. 4 EStG)",
    "avm.building.basis.lease": "Unbeweglicher Mietereinbau (Restlaufzeit des Mietvertrags)",
    "avm.building.type.building": "Gebäude-AfA nach § 7 Abs. 4 EStG",
    "avm.building.type.buildingDesc": "Nutzungsdauer aus Nutzung, Bauantrag und Fertigstellung",
    "avm.building.type.lease": "Unbeweglicher Mietereinbau (Restlaufzeit des Mietvertrags)",
    "avm.building.type.leaseDesc": "Nutzungsdauer bis zum Ende des Mietvertrags, höchstens 400 Monate",
    "avm.building.use": "Nutzung des Gebäudes",
    "avm.building.use.nonResidentialBusiness": "Wirtschaftsgebäude im Betriebsvermögen, nicht zu Wohnzwecken",
    "avm.building.use.other": "Anderes Gebäude, zum Beispiel Wohngebäude",
    "avm.building.applicationDate": "Bauantrag gestellt am",
    "avm.building.completionDate": "Fertiggestellt am",
    "avm.building.leaseEnd": "Mietvertrag endet am",
    "avm.building.limit.building":
        "Gesetzliche Nutzungsdauer: {months} Monate. Eine kürzere tatsächliche Nutzungsdauer ist mit Nachweis zulässig.",
    "avm.building.limit.lease":
        "Restlaufzeit des Mietvertrags: {months} Monate (höchstens 400). Eine kürzere Nutzungsdauer ist zulässig.",
    "avm.building.error.missingUse":
        "Bitte die Nutzung des Gebäudes mit Bauantrag und Fertigstellung oder das Ende des Mietvertrags angeben.",
    "avm.building.error.missingApplicationDate":
        "Der AfA-Satz eines Wirtschaftsgebäudes hängt vom Datum des Bauantrags ab (§ 7 Abs. 4 Satz 1 Nr. 1 EStG). Bitte das Datum des Bauantrags eintragen.",
    "avm.building.error.missingCompletionDate":
        "Der AfA-Satz des Gebäudes hängt vom Jahr der Fertigstellung ab (§ 7 Abs. 4 Satz 1 Nr. 2 EStG). Bitte das Datum der Fertigstellung eintragen.",
    "avm.building.error.missingLeaseEnd": "Bitte das Ende des Mietvertrags eintragen.",
    "avm.building.error.leaseBeforeStart": "Der Mietvertrag endet vor dem Beginn der AfA. Bitte das Mietende prüfen.",
    "avm.building.error.completionLifeTooLong":
        "Die Fertigstellung trägt eine Nutzungsdauer von {life} Monaten; nach diesen Gebäudeangaben sind höchstens {max} Monate zulässig. Bitte die Gebäudeangaben prüfen oder die Umbuchung stornieren und mit höchstens {max} Monaten neu buchen.",
    "avm.building.error.completionDateDiffers":
        "Das Gebäude wurde mit der Umbuchung vom {date} fertiggestellt; diese Umbuchung ist das Fertigstellungsdatum. Bitte das Fertigstellungsdatum auf den {date} setzen oder leer lassen.",
    "avm.building.split.landFailed":
        "Das Gebäude ist gespeichert, der Anteil Grund und Boden von {amount} nicht ({reason}). Bitte ihn in der Anlagengruppe {name} als eigenes Anlagegut erfassen.",
    "avm.building.error.completionDateDiffersTransfer":
        "Mit dieser Umbuchung wird das Gebäude am {date} fertiggestellt; die Umbuchung ist das Fertigstellungsdatum. Das Fertigstellungsdatum in den Gebäudeangaben weicht davon ab. Bitte es in den Stammdaten auf den {date} setzen oder leer lassen.",
    "avm.movements.form.targetGroup.buildingCompletionDate":
        "Fertigstellungsdatum weicht von der Umbuchung ab: bitte in den Stammdaten anpassen",
    "avm.building.error.flipClosed":
        "Die Änderung wechselt die AfA des Gebäudes zwischen dem gesetzlichen AfA-Satz (§ 7 Abs. 4 Satz 1 EStG) und der Verteilung auf die Restnutzungsdauer; das ändert die Beträge ab der Bewegung vom {date} im abgeschlossenen Wirtschaftsjahr {year}. Bitte das Wirtschaftsjahr {latest} wieder öffnen und zuerst die Bewegung vom {date} stornieren.",
    "avm.building.error.flipRemaining":
        "Die Änderung wechselt die AfA des Gebäudes zwischen dem gesetzlichen AfA-Satz (§ 7 Abs. 4 Satz 1 EStG) und der Verteilung auf die Restnutzungsdauer; die Bewegung vom {date} trägt eine Restnutzungsdauer von {months} Monaten, die dann nicht mehr gälte. Bitte zuerst die Bewegung vom {date} stornieren.",
    "avm.movements.storno.lifeRests":
        "Auf dieser Fertigstellung beruht die Restnutzungsdauer der Bewegung vom {date}. Bitte zuerst die Bewegung vom {date} stornieren.",
    "avm.building.error.quantityOneDisposed":
        "Ein Gebäude wird als ein Anlagegut mit der Menge 1 geführt; ein Teilverkauf richtet sich nach dem Flächenanteil und wird von Hand in der Buchhaltung gebucht. Da bereits ein Teilabgang gebucht ist, kann die Menge nicht mehr auf 1 sinken. Bitte eine andere Anlagengruppe wählen.",
    "avm.assets.quantity.error.belowDisposed":
        "Die Menge kann nicht auf {quantity} sinken: mit {count, plural, one {dem Teilabgang} other {den Teilabgängen}} vom {dates} {units, plural, one {ist} other {sind}} bereits {units} Stück abgegangen. Bitte eine Menge ab {min} eintragen oder zuerst {count, plural, one {den Teilabgang} other {die Teilabgänge}} vom {dates} stornieren.",
    "avm.building.error.quantityOne":
        "Ein Gebäude wird als ein Anlagegut mit der Menge 1 geführt; ein Teilverkauf richtet sich nach dem Flächenanteil und wird von Hand in der Buchhaltung gebucht. Bitte die Menge 1 eintragen und jedes weitere Gebäude als eigenes Anlagegut erfassen.",
    "avm.building.error.flipForward":
        "Soll das Anlagegut erst ab jetzt in der neuen Gruppe geführt werden, bitte stattdessen die Anlagengruppe hier unverändert lassen und eine Umbuchung in die neue Gruppe buchen, datiert nach der letzten Bewegung vom {date} und in einem offenen Wirtschaftsjahr.",
    "avm.building.error.flipRemainingTransfer":
        "Die Umbuchung wechselt die AfA des Gebäudes zwischen dem gesetzlichen AfA-Satz (§ 7 Abs. 4 Satz 1 EStG) und der Verteilung auf die Restnutzungsdauer; die Bewegung vom {date} trägt eine Restnutzungsdauer von {months} Monaten, die dann nicht mehr gälte. Bitte die Umbuchung mit einem Datum nach dem {date} buchen oder zuerst die Bewegung vom {date} stornieren.",
    "avm.building.error.flipRemainingStorno":
        "Die Stornierung der Umbuchung wechselt die AfA des Gebäudes zwischen dem gesetzlichen AfA-Satz (§ 7 Abs. 4 Satz 1 EStG) und der Verteilung auf die Restnutzungsdauer; die Bewegung vom {date} trägt eine Restnutzungsdauer von {months} Monaten, die dann nicht mehr gälte. Bitte zuerst die Bewegung vom {date} stornieren und dann die Umbuchung.",
    "avm.movements.form.targetGroup.buildingQuantity":
        "Menge über 1: ein Gebäude hat die Menge 1, bitte zuerst in den Stammdaten anpassen",
    "avm.movements.form.targetGroup.buildingQuantityDisposed":
        "Menge über 1 mit gebuchtem Teilabgang: ein Gebäude hat die Menge 1, bitte eine andere Zielgruppe wählen",
    "avm.movements.error.beforeOpening":
        "Das Anlagegut ist mit dem Eröffnungsbestand {openingYear} übernommen; eine Bewegung vor dem Wirtschaftsjahr {openingYear} ist im übernommenen Buchwert enthalten. Bitte ein Datum im Wirtschaftsjahr {openingYear} oder später wählen.",
    "avm.movements.error.buildingPartialDisposal":
        "Ein Gebäude wird als ein Anlagegut mit der Menge 1 geführt; ein Teilverkauf richtet sich nach dem Flächenanteil und wird von Hand in der Buchhaltung gebucht. Bitte den Abgang des ganzen Gebäudes buchen oder den Teilverkauf von Hand buchen.",
    "avm.building.error.lifeTooLong":
        "Die Nutzungsdauer ist länger als die zulässige von {max} Monaten. Bitte höchstens {max} Monate eintragen.",
    "avm.building.error.completionAttributes":
        "Für die Umbuchung in eine Anlagengruppe für Gebäude fehlen die Gebäudeangaben. Bitte zuerst in den Stammdaten des Anlageguts die Nutzung mit Bauantrag und Fertigstellung oder das Ende des Mietvertrags eintragen.",
    "avm.building.remainingMonths":
        "Ein Gebäude wird mit dem gesetzlichen AfA-Satz weiter abgeschrieben, auch nach nachträglichen Herstellungskosten (R 7.4 Abs. 9 EStR). Eine Restnutzungsdauer wird hier nicht gesetzt.",
    "avm.movements.form.targetGroup.buildingAttributes":
        "Gebäudeangaben fehlen: bitte zuerst in den Stammdaten eintragen",
    "avm.movements.form.targetGroup.buildingLife": "Nutzungsdauer länger als nach § 7 Abs. 4 EStG zulässig",
    "avm.building.split.label": "Kaufpreis auf Grund und Boden und Gebäude aufteilen",
    "avm.building.split.hint":
        "Der Anteil für Grund und Boden wird als eigenes Anlagegut ohne AfA in der Anlagengruppe mit der Rolle Grund und Boden erfasst. Außenanlagen und Betriebsvorrichtungen bitte einzeln erfassen.",
    "avm.building.split.land": "Anteil Grund und Boden",
    "avm.building.split.building": "Anteil Gebäude",
    "avm.building.split.sum":
        "Grund und Boden und Gebäude ergeben zusammen {total}. Bitte die Anteile so aufteilen, dass sie genau {cost} ergeben.",
    "avm.building.split.amount":
        "Bitte beide Anteile mit einem Betrag über 0,00 angeben oder ohne Aufteilung speichern.",
    "avm.building.split.noLandGroup":
        "Es gibt keine Anlagengruppe mit der Rolle Grund und Boden für den Grundstücksanteil bebauter Grundstücke. Bitte in den Einstellungen die Standardgruppen anlegen, einer eigenen nicht abnutzbaren Anlagengruppe diese Rolle geben oder ohne Aufteilung speichern.",
    "avm.building.split.landName": "{name}, Grund und Boden",
    "avm.building.split.review": "Grund und Boden {land} in der Anlagengruppe {name}, Gebäude {building}",
    "avm.import.field.buildingUse": "Nutzung (Wirtschaftsgebäude oder anderes Gebäude)",
    "avm.import.field.buildingApplicationDate": "Bauantrag",
    "avm.import.field.completionDate": "Fertigstellung",
    "avm.import.field.leaseEnd": "Mietende",
    "avm.import.field.openingAfaBase": "AfA-Bemessungsgrundlage",
    "avm.import.field.openingUnimpairedBookValue": "Buchwert ohne Teilwertabschreibung",
    "avm.import.field.specialBuildingAfa": "Sonder- oder degressive Gebäude-AfA in Anspruch genommen",
    "avm.import.row.error.buildingUse":
        "Nutzung nicht lesbar: bitte genau „Wirtschaftsgebäude im Betriebsvermögen, nicht zu Wohnzwecken“ oder „Anderes Gebäude, zum Beispiel Wohngebäude“ eintragen (oder NON_RESIDENTIAL_BUSINESS / OTHER)",
    "avm.import.row.error.buildingDate": "Bauantrag, Fertigstellung oder Mietende ist kein gültiges Datum",
    "avm.import.row.error.buildingUseOrLease":
        "Nutzung und Mietende schließen sich aus: bitte nur eines von beiden angeben",
    "avm.import.row.error.buildingMissing":
        "Gebäudeangaben fehlen: ein Wirtschaftsgebäude braucht den Bauantrag, ein anderes Gebäude die Fertigstellung, ein unbeweglicher Mietereinbau das Mietende",
    "avm.import.row.error.buildingLife":
        "Nutzungsdauer länger als nach Paragraf 7 Abs. 4 EStG zulässig, oder Mietende vor der Anschaffung",
    "avm.import.row.error.buildingColumns":
        "Nutzung, Bauantrag, Fertigstellung und Mietende gehören zu einer Gebäudegruppe: bitte die Anlagengruppe prüfen oder die Zellen leeren",
    "avm.import.row.error.specialBuildingAfa":
        "Sonder- oder degressive Gebäude-AfA vor der Übernahme: bitte in der Buchhaltung erfassen",
    "avm.import.row.error.openingBase":
        "AfA-Bemessungsgrundlage nur für ein übernommenes Gebäude, zwischen Buchwert Vorjahr und Anschaffungskosten",
    "avm.import.row.error.openingUnimpaired":
        "Buchwert ohne Teilwertabschreibung nur für ein übernommenes Gebäude, zwischen Buchwert Vorjahr und Anschaffungskosten",
    "avm.import.rows.col.building": "Gebäude",
    "avm.import.rows.building.lease": "Mietende {date}",
    "avm.import.rows.building.base": "AfA-Bemessungsgrundlage {amount}",
    "avm.import.rows.building.unimpaired": "ohne Teilwertabschreibung {amount}",
    "avm.assets.openingAfaBase": "AfA-Bemessungsgrundlage",
    "avm.assets.openingAfaBase.hint":
        "Leer lassen, wenn sie den Anschaffungskosten entspricht. Nach einer Teilwertabschreibung, AfaA oder Sonder-AfA vor der Übernahme die gekürzte Bemessungsgrundlage eintragen.",
    "avm.assets.openingUnimpairedBookValue": "Buchwert ohne Teilwertabschreibung",
    "avm.assets.openingUnimpairedBookValue.hint":
        "Der Buchwert zu Beginn des Eröffnungsjahres ohne die Teilwertabschreibungen; er begrenzt eine spätere Zuschreibung.",
    "avm.import.field.openingCumulativeAfa": "Kumulierte Abschreibungen",
    "avm.import.row.error.cumulativeAfa":
        "Anschaffungskosten {cost} abzüglich kumulierter Abschreibungen {cumulative} ergeben nicht den Buchwert Vorjahr {bookValue}: bitte den Buchwert oder die kumulierten Abschreibungen korrigieren",
    "avm.import.row.error.cumulativeAfaColumn":
        "Kumulierte Abschreibungen nur als Betrag ab 0,00 und nur für eine Zeile mit Eröffnungsbestand: bitte den Betrag prüfen oder die Zelle leeren",
    "app.agent.skippedNoRight": "Keine Berechtigung für {product}, dieser Teil wird übersprungen.",
    "app.agent.stepFailed": "Der Schritt {step} ist fehlgeschlagen, es geht mit dem nächsten weiter",
    "app.agent.skippedDependency":
        "Der Schritt {step} wird übersprungen, weil ein vorheriger Schritt nicht gelaufen ist",
    "app.agent.nothingToDo": "Für den Schritt {step} gibt es nichts zu tun",
    "app.agent.continuesOnServer": "Der Auftrag läuft im Hintergrund weiter, das Ergebnis finden Sie in Binale",
    "app.agent.step.start": "Start",
    "app.agent.step.upload": "Upload",
    "app.agent.step.aiReading": "KI-Auslesen",
    "app.agent.step.aiRetry": "KI erneut lesen",
    "app.agent.step.autoSort": "Automatisch sortieren",
    "app.agent.step.sortQuestions": "Sortierfragen",
    "app.agent.step.documentContacts": "Kontakte aus Belegen",
    "app.agent.step.kasseFromDocuments": "Kasse aus Belegen",
    "app.agent.step.bankImport": "Bankimport",
    "app.agent.step.bankContacts": "Bankkontakte",
    "app.agent.step.draftsFromDocuments": "Entwürfe aus Belegen",
    "app.agent.step.draftsFromTransactions": "Entwürfe aus Transaktionen",
    "app.agent.step.fillBank": "Bank füllen",
    "app.agent.step.reconcile": "Kontenabstimmung",
    "app.agent.step.aiCheck": "KI-Prüfung",
    "app.agent.step.postingRules": "Buchungsregeln",
    "app.agent.step.report": "Bericht",
    "app.agent.title": "Binale Agent",
    "app.agent.button": "Binale Agent",
    "app.agent.stepOf": "Schritt {step} von {total}",
    "app.agent.finished": "Fertig",
    "app.agent.paused": "Pausiert",
    "app.agent.progress": "{done} von {total} fertig",
    "app.agent.pause": "Pausieren",
    "app.agent.resume": "Fortsetzen",
    "app.agent.stop": "Beenden",
    "app.agent.close": "Schließen",
    "app.agent.confirmStop.title": "Agent beenden?",
    "app.agent.confirmStop.body": "Der laufende Schritt wird noch abgeschlossen, danach hält der Agent an.",
    "app.agent.confirmStop.keep": "Weiterlaufen",
    "app.agent.panelPlaceholder": "Diese Ansicht steht noch nicht zur Verfügung.",
    "app.agent.panelSkip": "Überspringen",
    "app.agent.start.thinking": "Ich schaue mir Ihre Belege, Bankkonten und das Postfach an",
    "app.agent.start.overview":
        "Ich sehe {documents} Belege in Neue Dokumente und {banks} Bankkonten mit finAPI für {year}.",
    "app.agent.start.open":
        "Für {year} sind noch offen: {documents} Belege zum Buchen, {bank} Banktransaktionen und {kasse} Kassentransaktionen ohne Buchung.",
    "app.agent.start.mailboxError":
        "Das Postfach meldet einen Fehler, neue E-Mail-Belege kommen derzeit nicht an. Bitte prüfen Sie die Postfach-Verbindung.",
    "app.agent.start.bankStale": "Das Bankkonto {bank} wurde seit mehr als 30 Tagen nicht importiert.",
    "app.agent.start.uploadQuestion": "Möchten Sie jetzt neue Belege hochladen?",
    "app.agent.start.upload": "Belege hochladen",
    "app.agent.start.skipUpload": "Ohne Upload weiter",
    "app.agent.upload.done": "{count} Belege hochgeladen",
    "app.agent.aiReading.progress": "Die KI liest Ihre Belege",
    "app.agent.aiReading.done": "{done} Belege gelesen, {failed} konnten nicht gelesen werden",
    "app.agent.aiRetry.question": "{count} Belege konnte die KI nicht lesen. Soll sie es noch einmal versuchen?",
    "app.agent.aiRetry.retry": "Erneut versuchen",
    "app.agent.aiRetry.skip": "Überspringen",
    "app.agent.aiRetry.thinking": "Ich starte das Auslesen noch einmal",
    "app.agent.aiRetry.done": "{done} Belege gelesen, {failed} weiterhin fehlerhaft",
    "app.agent.autoSort.thinking": "Ich sortiere die Belege aus Neue Dokumente",
    "app.agent.autoSort.done": "{moved} von {total} Belegen einsortiert",
    "app.agent.report.uploaded": "{count} Belege hochgeladen",
    "app.agent.report.aiRead": "{count} Belege von der KI gelesen",
    "app.agent.report.aiRetried": "{count} Belege beim zweiten Versuch gelesen",
    "app.agent.report.aiFailed": "{count} Belege konnten nicht gelesen werden",
    "app.agent.report.sorted": "{moved} von {total} Belegen automatisch einsortiert",
    "app.agent.aiStillRunning": "{count} Belege werden noch gelesen, das Ergebnis finden Sie in Binale",
    "app.agent.start.overviewNoDocuments": "Ich sehe {banks} Bankkonten mit finAPI für {year}.",
    "app.agent.report.aiNotStarted": "{count} Belege wurden von der KI nicht gestartet",
    "app.agent.sortQuestions.intro": "Bei {count} Belegen brauche ich Ihre Hilfe",
    "app.agent.sortQuestions.later": "Später",
    "app.agent.sortQuestions.done": "{answered} Belege beantwortet, {later} auf später verschoben",
    "app.agent.report.sortAnswered": "{count} Belege nach Ihren Antworten einsortiert",
    "app.agent.report.sortLater": "{count} Belege warten noch auf Ihre Entscheidung",
    "app.agent.sortQuestions.documentMissing": "Der Beleg wurde nicht gefunden",
    "app.agent.documentContacts.thinking": "Ich ordne Ihre Belege den Kontakten zu",
    "app.agent.documentContacts.done":
        "{linked} Belege mit bestehenden Kontakten verknüpft, {created} Kontakte neu angelegt",
    "app.agent.report.documentContactsLinked": "{count} Belege mit bestehenden Kontakten verknüpft",
    "app.agent.report.documentContactsCreated": "{count} Kontakte aus Belegen angelegt",
    "app.agent.kasse.thinking": "Ich buche die Kassenbelege in die Kasse",
    "app.agent.kasse.done": "{count} Kassenbuchungen für {register} angelegt",
    "app.agent.report.kasseCreated": "{count} Kassenbuchungen aus Belegen angelegt",
    "app.agent.report.kasseRefused":
        "{count} Kassenbelege konnten nicht gebucht werden, bitte prüfen Sie diese in der Kasse",
    "app.agent.bankImport.start": "Bankumsätze für {bank} importieren. Bitte starten Sie den Import mit Aktualisieren.",
    "app.agent.bankImport.done": "{bank}: {count} Bankumsätze importiert",
    "app.agent.bankImport.doneNoCount": "{bank}: Bankumsätze importiert",
    "app.agent.bankImport.skipped": "Bank {bank} übersprungen",
    "app.agent.bankImport.skipBank": "Diese Bank überspringen",
    "app.agent.report.bankImportedNoCount": "{bank}: Bankumsätze importiert",
    "app.agent.report.bankImported": "{bank}: {count} Bankumsätze importiert",
    "app.agent.report.bankSkipped": "{count} Bankkonten übersprungen",
    "app.agent.bankContacts.thinking": "Ich ordne die Bankumsätze bestehenden Kontakten zu",
    "app.agent.bankContacts.matched": "{count} Bankumsätze mit Kontakten verknüpft",
    "app.agent.bankContacts.suggesting": "Ich suche neue Kontakte in den übrigen Bankumsätzen",
    "app.agent.bankContacts.ask": "{count} Kontakte anlegen?",
    "app.agent.bankContacts.create": "Anlegen",
    "app.agent.bankContacts.skip": "Überspringen",
    "app.agent.bankContacts.creating": "Ich lege die Kontakte an",
    "app.agent.bankContacts.created": "{count} Kontakte angelegt",
    "app.agent.bankContacts.noContactsProduct": "Das Modul Kontakte ist für diese Firma nicht aktiv.",
    "app.agent.report.bankContactsMatched": "{count} Bankumsätze mit Kontakten verknüpft",
    "app.agent.report.bankContactsCreated": "{count} Kontakte aus Bankumsätzen angelegt",
    "app.agent.report.bankContactsLinkedExisting": "{count} Bankumsätze mit bestehenden Kontakten verknüpft",
    "app.agent.report.bankContactsOpen": "{count} Kontakte aus Bankumsätzen noch nicht angelegt",
    "app.agent.drafts.thinking": "Ich suche Belege ohne Buchungsentwurf",
    "app.agent.drafts.progress": "Buchungsentwürfe aus Belegen ({product})",
    "app.agent.drafts.done": "{count} Buchungsentwürfe aus Belegen erstellt ({product})",
    "app.agent.report.draftsCreated": "{count} Buchungsentwürfe aus Belegen erstellt",
    "app.agent.report.draftRefused": "{count} Belege nicht gebucht: {reason}",
    "app.agent.report.draftsFailed": "{count} Belege konnten nicht gebucht werden",
    "app.agent.report.draftsRunning": "{count} Belege werden im Hintergrund gebucht, das Ergebnis finden Sie in Binale",
    "app.agent.txDrafts.bankThinking": "Ich erstelle Buchungsentwürfe aus Bankumsätzen",
    "app.agent.txDrafts.kasseThinking": "Ich erstelle Buchungsentwürfe aus der Kasse",
    "app.agent.txDrafts.bankDone": "{count} Buchungsentwürfe aus Bankumsätzen erstellt",
    "app.agent.txDrafts.kasseDone": "{count} Buchungsentwürfe aus der Kasse erstellt",
    "app.agent.report.txDraftsBank": "{count} Buchungsentwürfe aus Bankumsätzen erstellt",
    "app.agent.report.txDraftsKasse": "{count} Buchungsentwürfe aus der Kasse erstellt",
    "app.agent.report.txDraftsNotFound": "{count} Umsätze nicht gefunden, bitte Seite neu laden und erneut starten",
    "app.agent.report.txDraftsInvalid": "{count} Umsätze nicht gebucht, die Angaben sind unvollständig",
    "app.agent.fillBank.thinking": "Ich ordne die Bankumsätze Ihren Buchungen zu",
    "app.agent.fillBank.done": "{count} Bankumsätze zugeordnet",
    "app.agent.report.fillBankMatched": "{count} Bankumsätze zugeordnet (Bank zuordnen)",
    "app.agent.report.fillBankAmbiguous":
        "{count} Bankumsätze haben mehrere mögliche Buchungen und brauchen Ihre Auswahl",
    "app.agent.report.fillBankJournaled": "{count} Bankumsätze sind festgeschrieben und wurden nicht geändert",
    "app.agent.reconcile.thinking": "Ich gleiche die Konten ab",
    "app.agent.reconcile.done": "{count} Zahlungen im Kontenabgleich angelegt",
    "app.agent.report.reconciled": "{count} Zahlungen im Kontenabgleich angelegt",
    "app.agent.report.reconcileSkipped": "{count} Gruppen im Kontenabgleich brauchen Ihre Prüfung",
    "app.agent.report.reconcileChanged":
        "{count} Gruppen im Kontenabgleich haben sich geändert und wurden nicht übernommen",
    "app.agent.report.reconcileFailed": "{count} Gruppen im Kontenabgleich konnten nicht angelegt werden",
    "app.agent.report.reconcileAccountFailed":
        "{count} Konten konnten im Kontenabgleich nicht abgeglichen werden, bitte prüfen Sie Ihre Rechte für Bank und Kasse",
    "app.agent.aiCheck.thinking": "Ich prüfe die Buchungen mit der KI",
    "app.agent.aiCheck.done": "{checked} Buchungen geprüft, {invalid} mit Abweichungen",
    "app.agent.report.aiChecked": "{count} Buchungen mit der KI geprüft",
    "app.agent.report.aiCheckInvalid": "{count} Buchungen weichen vom Beleg ab, bitte prüfen Sie diese",
    "app.agent.report.aiCheckNotChecked":
        "{count} Buchungen konnten nicht geprüft werden, bitte prüfen Sie diese selbst",
    "app.agent.postingRules.thinking": "Ich suche Vorschläge für Buchungsregeln",
    "app.agent.postingRules.askIncoming": "Es gibt {count} Vorschläge für Buchungsregeln bei Eingangsrechnungen.",
    "app.agent.postingRules.askOutgoing": "Es gibt {count} Vorschläge für Buchungsregeln bei Ausgangsrechnungen.",
    "app.agent.postingRules.import": "Als Entwurf übernehmen",
    "app.agent.postingRules.skip": "Später",
    "app.agent.postingRules.importing": "Ich übernehme die Vorschläge als Entwürfe",
    "app.agent.postingRules.done": "{count} Buchungsregeln als Entwurf übernommen",
    "app.agent.report.postingRulesImported":
        "{count} Buchungsregeln als Entwurf übernommen, bitte aktivieren Sie diese selbst",
    "app.agent.report.postingRulesOpen": "{count} Vorschläge für Buchungsregeln warten noch auf Ihre Entscheidung",
    "app.agent.report.title": "Bericht",
    "app.agent.report.thinking": "Ich fasse zusammen, was passiert ist",
    "app.agent.report.sectionDone": "Erledigt",
    "app.agent.report.sectionOpen": "Braucht Sie noch",
    "app.agent.report.nothingDone": "Es gab nichts zu erledigen.",
    "app.agent.report.nothingOpen": "Es ist nichts mehr offen.",
    "app.agent.report.continuesInBinale": "{step}: läuft im Hintergrund weiter, das Ergebnis finden Sie in Binale",
    "app.agent.report.pending.DOCUMENTS_NEED_ANSWER": "{count} Belege warten auf Ihre Antwort",
    "app.agent.report.pending.DOCUMENTS_NOT_PROCESSED": "{count} Belege wurden noch nicht von der KI gelesen",
    "app.agent.report.pending.DOCUMENTS_READY_TO_BOOK": "{count} Belege sind bereit zum Buchen",
    "app.agent.report.pending.BANK_TRANSACTIONS_NOT_BOOKED": "{count} Bankumsätze sind noch nicht gebucht",
    "app.agent.report.pending.KASSE_TRANSACTIONS_NOT_BOOKED": "{count} Kassenumsätze sind noch nicht gebucht",
    "app.agent.report.pending.AI_DRAFTS_TO_REVIEW": "{count} KI-Entwürfe warten auf Ihre Prüfung",
    "app.agent.report.pending.DRAFTS_WITHOUT_ACCOUNT": "{count} Entwürfe haben noch kein Konto",
    "app.agent.report.ustvaOpen": "In Binale ist für {period} noch keine Voranmeldung übermittelt",
    "app.agent.report.reviewDrafts": "Entwürfe prüfen",
    "app.agent.report.download": "Bericht herunterladen",
};

export type IMessagesType = typeof messagesDe;
